
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9Umtx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $4ez2K = parcelRequire("4ez2K");


var $cDs9S = parcelRequire("cDs9S");


var $aGB72 = parcelRequire("aGB72");

const $69550b9fcc608518$var$styles = {
    header: "_2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuI7V3 _0rIjykLl21 _0xmtko5zaO _46hvQmNHnM",
    flex: "_0aFT5vf5Xk _39xV02N91d",
    titleContainer: "_4ouGXIdnbC"
};
const $69550b9fcc608518$var$ModalHeader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, testId: userDefinedTestId, hasCloseButton: t0 } = props;
    const hasCloseButton = t0 === undefined ? false : t0;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $69550b9fcc608518$var$styles.header
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== modalTestId || $[3] !== onClose || $[4] !== shouldShowCloseButton) {
        t2 = shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $69550b9fcc608518$var$styles.flex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: onClose,
            testId: modalTestId
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "start",
            alignItems: "center",
            xcss: $69550b9fcc608518$var$styles.titleContainer
        }, children)) : children;
        $[1] = children;
        $[2] = modalTestId;
        $[3] = onClose;
        $[4] = shouldShowCloseButton;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2 || $[7] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            className: t1
        }, t2);
        $[6] = t2;
        $[7] = testId;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`; // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $69550b9fcc608518$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $69550b9fcc608518$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $69550b9fcc608518$var$styles.titleContainer
    }, children)) : children);
};
var $69550b9fcc608518$export$2e2bcd8739ae039 = $69550b9fcc608518$var$ModalHeader;
module.exports["default"] = $69550b9fcc608518$export$2e2bcd8739ae039;

});

parcelRegister("4ez2K", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0e536ece82020529$var$rowGapMap = {
    'space.0': "_42d1HAPgdg",
    'space.025': "_42d1HAFQfX",
    'space.050': "_42d1HA1Y8M",
    'space.075': "_42d1HAgVvo",
    'space.100': "_42d1HA2ADO",
    'space.150': "_42d1HA8HPE",
    'space.200': "_42d1HA5zaO",
    'space.250': "_42d1HAkG2W",
    'space.300': "_42d1HANHnM",
    'space.400': "_42d1HAVa5s",
    'space.500': "_42d1HAS40j",
    'space.600': "_42d1HAp0Oa",
    'space.800': "_42d1HAGXk2",
    'space.1000': "_42d1HAyFLW"
};
const $0e536ece82020529$var$columnGapMap = {
    'space.0': "_17lj8pPgdg",
    'space.025': "_17lj8pFQfX",
    'space.050': "_17lj8p1Y8M",
    'space.075': "_17lj8pgVvo",
    'space.100': "_17lj8p2ADO",
    'space.150': "_17lj8p8HPE",
    'space.200': "_17lj8p5zaO",
    'space.250': "_17lj8pkG2W",
    'space.300': "_17lj8pNHnM",
    'space.400': "_17lj8pVa5s",
    'space.500': "_17lj8pS40j",
    'space.600': "_17lj8pp0Oa",
    'space.800': "_17lj8pGXk2",
    'space.1000': "_17lj8pyFLW"
};
const $0e536ece82020529$var$justifyContentMap = {
    start: "_37wbyu7p2s",
    center: "_37wbyuDIqT",
    end: "_37wbyuF05b",
    'space-between': "_37wbyuI7V3",
    'space-around': "_37wbyuxEoi",
    'space-evenly': "_37wbyuZHm0",
    stretch: "_37wbyuFlnN"
};
const $0e536ece82020529$var$flexDirectionMap = {
    column: "_0aFT5vbt8w",
    row: "_0aFT5v1qpb"
};
const $0e536ece82020529$var$flexWrapMap = {
    wrap: "_3TGfC9HnLE",
    nowrap: "_3TGfC9LRg7"
};
const $0e536ece82020529$var$alignItemsMap = {
    start: "_0hPCNL7p2s",
    center: "_0hPCNLDIqT",
    baseline: "_0hPCNLQame",
    end: "_0hPCNLF05b",
    stretch: "_0hPCNLFlnN"
};
const $0e536ece82020529$var$styles = {
    root: "_3iDTPbQ4SZ _24h04i2Njc"
}; /**
    * __Flex__
    *
    * `Flex` is a primitive component that implements the CSS Flexbox API.
    *
    * - [Examples](https://atlassian.design/components/primitives/flex/examples)
    * - [Code](https://atlassian.design/components/primitives/flex/code)
    *
    * @example
    * ```tsx
    * import { Box } from '@atlaskit/primitives/compiled'
    * import { Flex } from '@atlaskit/primitives/compiled/flex'
    *
    * const Component = () => (
    *   <Flex direction="column">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Flex>
    * )
    * ```
    */ 
const $0e536ece82020529$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(32);
    let alignItems;
    let ariaAttributes;
    let children;
    let columnGap;
    let direction;
    let gap;
    let justifyContent;
    let role;
    let rowGap;
    let t1;
    let testId;
    let wrap;
    let xcss;
    if ($[0] !== t0) {
        ({ as: t1, role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes } = t0);
        $[0] = t0;
        $[1] = alignItems;
        $[2] = ariaAttributes;
        $[3] = children;
        $[4] = columnGap;
        $[5] = direction;
        $[6] = gap;
        $[7] = justifyContent;
        $[8] = role;
        $[9] = rowGap;
        $[10] = t1;
        $[11] = testId;
        $[12] = wrap;
        $[13] = xcss;
    } else {
        alignItems = $[1];
        ariaAttributes = $[2];
        children = $[3];
        columnGap = $[4];
        direction = $[5];
        gap = $[6];
        justifyContent = $[7];
        role = $[8];
        rowGap = $[9];
        t1 = $[10];
        testId = $[11];
        wrap = $[12];
        xcss = $[13];
    }
    const Component = t1 === undefined ? "div" : t1;
    const t2 = gap && $0e536ece82020529$var$columnGapMap[gap];
    const t3 = columnGap && $0e536ece82020529$var$columnGapMap[columnGap];
    const t4 = gap && $0e536ece82020529$var$rowGapMap[gap];
    const t5 = rowGap && $0e536ece82020529$var$rowGapMap[rowGap];
    const t6 = alignItems && $0e536ece82020529$var$alignItemsMap[alignItems];
    const t7 = direction && $0e536ece82020529$var$flexDirectionMap[direction];
    const t8 = justifyContent && $0e536ece82020529$var$justifyContentMap[justifyContent];
    const t9 = wrap && $0e536ece82020529$var$flexWrapMap[wrap];
    let t10;
    if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== xcss) {
        t10 = (0, $hekY6.default)([
            $0e536ece82020529$var$styles.root,
            t2,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            xcss
        ]);
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
        $[22] = xcss;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== Component || $[25] !== ariaAttributes || $[26] !== children || $[27] !== ref || $[28] !== role || $[29] !== t10 || $[30] !== testId) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            ...ariaAttributes,
            role: role,
            className: t10,
            "data-testid": testId,
            ref: ref,
            children: children
        });
        $[24] = Component;
        $[25] = ariaAttributes;
        $[26] = children;
        $[27] = ref;
        $[28] = role;
        $[29] = t10;
        $[30] = testId;
        $[31] = t11;
    } else t11 = $[31];
    return t11;
} : ({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $hekY6.default)([
            $0e536ece82020529$var$styles.root,
            gap && $0e536ece82020529$var$columnGapMap[gap],
            columnGap && $0e536ece82020529$var$columnGapMap[columnGap],
            gap && $0e536ece82020529$var$rowGapMap[gap],
            rowGap && $0e536ece82020529$var$rowGapMap[rowGap],
            alignItems && $0e536ece82020529$var$alignItemsMap[alignItems],
            direction && $0e536ece82020529$var$flexDirectionMap[direction],
            justifyContent && $0e536ece82020529$var$justifyContentMap[justifyContent],
            wrap && $0e536ece82020529$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$0e536ece82020529$export$f51f4c4ede09e011.displayName = 'Flex';
module.exports["Flex"] = $0e536ece82020529$export$f51f4c4ede09e011;

});

parcelRegister("cDs9S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");

const $4d35b190332285b6$export$de65de8213222d10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { label: label, onBlur: onBlur, onClick: onClick, testId: testId } = t0;
    const t1 = testId && `${testId}--close-button`;
    const t2 = label || "Close Modal";
    let t3;
    if ($[0] !== onBlur || $[1] !== onClick || $[2] !== t1 || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: t1,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            onBlur: onBlur,
            onClick: onClick
        });
        $[0] = onBlur;
        $[1] = onClick;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
module.exports["CloseButton"] = $4d35b190332285b6$export$de65de8213222d10;

});

parcelRegister("1sCHt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $6cOYa = parcelRequire("6cOYa");


var $n1i5T = parcelRequire("n1i5T");


var $aDGhF = parcelRequire("aDGhF");

/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $24817d87aac8e247$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function Button(t0, ref) {
    const $ = (0, $bDgLe.c)(110);
    let analyticsContext;
    let appearance;
    let ariaLabelledBy;
    let autoFocus;
    let icon;
    let interactionName;
    let isDisabled;
    let isSelected;
    let label;
    let onClick;
    let onClickCapture;
    let onKeyDownCapture;
    let onKeyUpCapture;
    let onMouseDownCapture;
    let onMouseUpCapture;
    let onPointerDownCapture;
    let onPointerUpCapture;
    let onTouchEndCapture;
    let onTouchStartCapture;
    let shape;
    let spacing;
    let t1;
    let t2;
    let t3;
    let testId;
    let tooltip;
    let unsafeRest;
    if ($[0] !== t0) {
        const { "aria-label": preventedAriaLabel, "aria-labelledby": t4, analyticsContext: t5, appearance: t6, autoFocus: t7, icon: t8, interactionName: t9, isDisabled: t10, isLoading: t11, isSelected: t12, isTooltipDisabled: t13, label: t14, onClick: t15, onClickCapture: t16, onKeyDownCapture: t17, onKeyUpCapture: t18, onMouseDownCapture: t19, onMouseUpCapture: t20, onPointerDownCapture: t21, onPointerUpCapture: t22, onTouchEndCapture: t23, onTouchStartCapture: t24, shape: t25, spacing: t26, testId: t27, tooltip: t28, type: t29, ...t30 } = t0;
        ariaLabelledBy = t4;
        analyticsContext = t5;
        appearance = t6;
        autoFocus = t7;
        icon = t8;
        interactionName = t9;
        isDisabled = t10;
        t1 = t11;
        isSelected = t12;
        t2 = t13;
        label = t14;
        onClick = t15;
        onClickCapture = t16;
        onKeyDownCapture = t17;
        onKeyUpCapture = t18;
        onMouseDownCapture = t19;
        onMouseUpCapture = t20;
        onPointerDownCapture = t21;
        onPointerUpCapture = t22;
        onTouchEndCapture = t23;
        onTouchStartCapture = t24;
        shape = t25;
        spacing = t26;
        testId = t27;
        tooltip = t28;
        t3 = t29;
        unsafeRest = t30;
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = appearance;
        $[3] = ariaLabelledBy;
        $[4] = autoFocus;
        $[5] = icon;
        $[6] = interactionName;
        $[7] = isDisabled;
        $[8] = isSelected;
        $[9] = label;
        $[10] = onClick;
        $[11] = onClickCapture;
        $[12] = onKeyDownCapture;
        $[13] = onKeyUpCapture;
        $[14] = onMouseDownCapture;
        $[15] = onMouseUpCapture;
        $[16] = onPointerDownCapture;
        $[17] = onPointerUpCapture;
        $[18] = onTouchEndCapture;
        $[19] = onTouchStartCapture;
        $[20] = shape;
        $[21] = spacing;
        $[22] = t1;
        $[23] = t2;
        $[24] = t3;
        $[25] = testId;
        $[26] = tooltip;
        $[27] = unsafeRest;
    } else {
        analyticsContext = $[1];
        appearance = $[2];
        ariaLabelledBy = $[3];
        autoFocus = $[4];
        icon = $[5];
        interactionName = $[6];
        isDisabled = $[7];
        isSelected = $[8];
        label = $[9];
        onClick = $[10];
        onClickCapture = $[11];
        onKeyDownCapture = $[12];
        onKeyUpCapture = $[13];
        onMouseDownCapture = $[14];
        onMouseUpCapture = $[15];
        onPointerDownCapture = $[16];
        onPointerUpCapture = $[17];
        onTouchEndCapture = $[18];
        onTouchStartCapture = $[19];
        shape = $[20];
        spacing = $[21];
        t1 = $[22];
        t2 = $[23];
        t3 = $[24];
        testId = $[25];
        tooltip = $[26];
        unsafeRest = $[27];
    }
    const isLoading = t1 === undefined ? false : t1;
    const isTooltipDisabled = t2 === undefined ? true : t2;
    const type = t3 === undefined ? "button" : t3;
    let saferRest;
    if ($[28] !== unsafeRest) {
        const { className: _className, css: _css, as: _as, style: _style, ...t4 } = unsafeRest;
        saferRest = t4;
        $[28] = unsafeRest;
        $[29] = saferRest;
    } else saferRest = $[29];
    if (isTooltipDisabled) {
        const t4 = shape === "circle";
        const t5 = !!icon;
        let t6;
        if ($[30] !== icon) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
                icon: icon
            });
            $[30] = icon;
            $[31] = t6;
        } else t6 = $[31];
        let t7;
        if ($[32] !== label) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label);
            $[32] = label;
            $[33] = t7;
        } else t7 = $[33];
        let t8;
        if ($[34] !== isLoading || $[35] !== t6 || $[36] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
                type: "icon",
                isLoading: isLoading
            }, t6, t7);
            $[34] = isLoading;
            $[35] = t6;
            $[36] = t7;
            $[37] = t8;
        } else t8 = $[37];
        let t9;
        if ($[38] !== analyticsContext || $[39] !== appearance || $[40] !== ariaLabelledBy || $[41] !== autoFocus || $[42] !== interactionName || $[43] !== isDisabled || $[44] !== isLoading || $[45] !== isSelected || $[46] !== onClick || $[47] !== onClickCapture || $[48] !== onKeyDownCapture || $[49] !== onKeyUpCapture || $[50] !== onMouseDownCapture || $[51] !== onMouseUpCapture || $[52] !== onPointerDownCapture || $[53] !== onPointerUpCapture || $[54] !== onTouchEndCapture || $[55] !== onTouchStartCapture || $[56] !== ref || $[57] !== saferRest || $[58] !== spacing || $[59] !== t4 || $[60] !== t5 || $[61] !== t8 || $[62] !== testId || $[63] !== type) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
                ...saferRest,
                ref: ref,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: t4,
                hasIconBefore: t5,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: onClick,
                onClickCapture: onClickCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                type: type,
                interactionName: interactionName
            }, t8);
            $[38] = analyticsContext;
            $[39] = appearance;
            $[40] = ariaLabelledBy;
            $[41] = autoFocus;
            $[42] = interactionName;
            $[43] = isDisabled;
            $[44] = isLoading;
            $[45] = isSelected;
            $[46] = onClick;
            $[47] = onClickCapture;
            $[48] = onKeyDownCapture;
            $[49] = onKeyUpCapture;
            $[50] = onMouseDownCapture;
            $[51] = onMouseUpCapture;
            $[52] = onPointerDownCapture;
            $[53] = onPointerUpCapture;
            $[54] = onTouchEndCapture;
            $[55] = onTouchStartCapture;
            $[56] = ref;
            $[57] = saferRest;
            $[58] = spacing;
            $[59] = t4;
            $[60] = t5;
            $[61] = t8;
            $[62] = testId;
            $[63] = type;
            $[64] = t9;
        } else t9 = $[64];
        return t9;
    }
    const t4 = tooltip?.content ?? label;
    const t5 = tooltip?.testId;
    const t6 = tooltip?.position;
    const t7 = tooltip?.delay;
    const t8 = tooltip?.onShow;
    const t9 = tooltip?.onHide;
    const t10 = tooltip?.mousePosition;
    const t11 = tooltip?.analyticsContext;
    const t12 = tooltip?.strategy;
    const t13 = tooltip?.tag;
    const t14 = tooltip?.truncate;
    const t15 = tooltip?.component;
    const t16 = tooltip?.hideTooltipOnClick;
    const t17 = tooltip?.hideTooltipOnMouseDown;
    const t18 = tooltip?.ignoreTooltipPointerEvents;
    const t19 = tooltip?.shortcut;
    let t20;
    if ($[65] !== analyticsContext || $[66] !== appearance || $[67] !== ariaLabelledBy || $[68] !== autoFocus || $[69] !== icon || $[70] !== interactionName || $[71] !== isDisabled || $[72] !== isLoading || $[73] !== isSelected || $[74] !== label || $[75] !== onClick || $[76] !== onClickCapture || $[77] !== onKeyDownCapture || $[78] !== onKeyUpCapture || $[79] !== onMouseDownCapture || $[80] !== onMouseUpCapture || $[81] !== onPointerDownCapture || $[82] !== onPointerUpCapture || $[83] !== onTouchEndCapture || $[84] !== onTouchStartCapture || $[85] !== ref || $[86] !== saferRest || $[87] !== shape || $[88] !== spacing || $[89] !== testId || $[90] !== type) {
        t20 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === "circle",
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e_0)=>{
                    triggerProps.onMouseOver?.(e_0);
                    saferRest.onMouseOver?.(e_0);
                },
                onMouseOut: (e_1)=>{
                    triggerProps.onMouseOut?.(e_1);
                    saferRest.onMouseOut?.(e_1);
                },
                onMouseMove: (e_2)=>{
                    triggerProps.onMouseMove?.(e_2);
                    saferRest.onMouseMove?.(e_2);
                },
                onMouseDown: (e_3)=>{
                    triggerProps.onMouseDown?.(e_3);
                    saferRest.onMouseDown?.(e_3);
                },
                onFocus: (e_4)=>{
                    triggerProps.onFocus?.(e_4);
                    saferRest.onFocus?.(e_4);
                },
                onBlur: (e_5)=>{
                    triggerProps.onBlur?.(e_5);
                    saferRest.onBlur?.(e_5);
                },
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
                type: "icon",
                isLoading: isLoading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
                icon: icon
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
        $[65] = analyticsContext;
        $[66] = appearance;
        $[67] = ariaLabelledBy;
        $[68] = autoFocus;
        $[69] = icon;
        $[70] = interactionName;
        $[71] = isDisabled;
        $[72] = isLoading;
        $[73] = isSelected;
        $[74] = label;
        $[75] = onClick;
        $[76] = onClickCapture;
        $[77] = onKeyDownCapture;
        $[78] = onKeyUpCapture;
        $[79] = onMouseDownCapture;
        $[80] = onMouseUpCapture;
        $[81] = onPointerDownCapture;
        $[82] = onPointerUpCapture;
        $[83] = onTouchEndCapture;
        $[84] = onTouchStartCapture;
        $[85] = ref;
        $[86] = saferRest;
        $[87] = shape;
        $[88] = spacing;
        $[89] = testId;
        $[90] = type;
        $[91] = t20;
    } else t20 = $[91];
    let t21;
    if ($[92] !== t10 || $[93] !== t11 || $[94] !== t12 || $[95] !== t13 || $[96] !== t14 || $[97] !== t15 || $[98] !== t16 || $[99] !== t17 || $[100] !== t18 || $[101] !== t19 || $[102] !== t20 || $[103] !== t4 || $[104] !== t5 || $[105] !== t6 || $[106] !== t7 || $[107] !== t8 || $[108] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t4,
            testId: t5,
            position: t6,
            delay: t7,
            onShow: t8,
            onHide: t9,
            mousePosition: t10,
            analyticsContext: t11,
            strategy: t12,
            tag: t13,
            truncate: t14,
            component: t15,
            hideTooltipOnClick: t16,
            hideTooltipOnMouseDown: t17,
            ignoreTooltipPointerEvents: t18,
            shortcut: t19
        }, t20);
        $[92] = t10;
        $[93] = t11;
        $[94] = t12;
        $[95] = t13;
        $[96] = t14;
        $[97] = t15;
        $[98] = t16;
        $[99] = t17;
        $[100] = t18;
        $[101] = t19;
        $[102] = t20;
        $[103] = t4;
        $[104] = t5;
        $[105] = t6;
        $[106] = t7;
        $[107] = t8;
        $[108] = t9;
        $[109] = t21;
    } else t21 = $[109];
    return t21;
} : function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
            ...saferRest,
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: (e, analyticsEvent)=>{
                onClick?.(e, analyticsEvent);
                triggerProps.onClick?.(e);
            },
            onMouseOver: (e_0)=>{
                triggerProps.onMouseOver?.(e_0);
                saferRest.onMouseOver?.(e_0);
            },
            onMouseOut: (e_1)=>{
                triggerProps.onMouseOut?.(e_1);
                saferRest.onMouseOut?.(e_1);
            },
            onMouseMove: (e_2)=>{
                triggerProps.onMouseMove?.(e_2);
                saferRest.onMouseMove?.(e_2);
            },
            onMouseDown: (e_3)=>{
                triggerProps.onMouseDown?.(e_3);
                saferRest.onMouseDown?.(e_3);
            },
            onFocus: (e_4)=>{
                triggerProps.onFocus?.(e_4);
                saferRest.onFocus?.(e_4);
            },
            onBlur: (e_5)=>{
                triggerProps.onBlur?.(e_5);
                saferRest.onBlur?.(e_5);
            },
            ref: (0, $lmzCg.default)([
                ref,
                triggerProps?.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, label))));
}));
$24817d87aac8e247$var$IconButton.displayName = 'IconButton';
var $24817d87aac8e247$export$2e2bcd8739ae039 = $24817d87aac8e247$var$IconButton;
module.exports["default"] = $24817d87aac8e247$export$2e2bcd8739ae039;

});

parcelRegister("hBYtq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $7r5Hr = parcelRequire("7r5Hr");


var $7kFxw = parcelRequire("7kFxw");


var $dpsRj = parcelRequire("dpsRj");


var $5EzLH = parcelRequire("5EzLH");


var $8cnlb = parcelRequire("8cnlb");

const $10888dde32781e27$var$styles = {
    root: "_30huDKYbGa _24h04i2Njc _034jHtYbGa _0wOv4Q7zJH",
    disabled: "_0wOv4Qsyl5"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $10888dde32781e27$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(37);
    let analyticsContext;
    let children;
    let componentName;
    let htmlAttributes;
    let interactionName;
    let isDisabled;
    let style;
    let t1;
    let t2;
    let tabIndex;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ children: children, isDisabled: isDisabled, type: t1, onClick: t2, interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = children;
        $[3] = componentName;
        $[4] = htmlAttributes;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = style;
        $[8] = t1;
        $[9] = t2;
        $[10] = tabIndex;
        $[11] = testId;
        $[12] = xcss;
    } else {
        analyticsContext = $[1];
        children = $[2];
        componentName = $[3];
        htmlAttributes = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        style = $[7];
        t1 = $[8];
        t2 = $[9];
        tabIndex = $[10];
        testId = $[11];
        xcss = $[12];
    }
    const type = t1 === undefined ? "button" : t1;
    const providedOnClick = t2 === undefined ? (0, $dpsRj.default) : t2;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    if ($[13] !== interactionContext || $[14] !== interactionName || $[15] !== providedOnClick) {
        t3 = (e, analyticsEvent)=>{
            interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
            providedOnClick(e, analyticsEvent);
        };
        $[13] = interactionContext;
        $[14] = interactionName;
        $[15] = providedOnClick;
        $[16] = t3;
    } else t3 = $[16];
    const handleClick = t3;
    const t4 = componentName || "Pressable";
    let t5;
    if ($[17] !== analyticsContext || $[18] !== handleClick || $[19] !== t4) {
        t5 = {
            fn: handleClick,
            action: "clicked",
            componentName: t4,
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: analyticsContext,
            actionSubject: "button"
        };
        $[17] = analyticsContext;
        $[18] = handleClick;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t5);
    let safeHtmlAttributes;
    if ($[21] !== htmlAttributes) {
        const { className: _spreadClass, ...t6 } = htmlAttributes;
        safeHtmlAttributes = t6;
        $[21] = htmlAttributes;
        $[22] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[22];
    const t6 = tabIndex ?? ((0, $7kFxw.isSafari)() && !isDisabled ? 0 : undefined);
    const t7 = isDisabled && $10888dde32781e27$var$styles.disabled;
    let t8;
    if ($[23] !== t7 || $[24] !== xcss) {
        t8 = (0, $k12R1.cx)($10888dde32781e27$var$styles.root, t7, xcss);
        $[23] = t7;
        $[24] = xcss;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== children || $[27] !== isDisabled || $[28] !== onClick || $[29] !== ref || $[30] !== safeHtmlAttributes || $[31] !== style || $[32] !== t6 || $[33] !== t8 || $[34] !== testId || $[35] !== type) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8cnlb.Focusable), {
            as: "button",
            tabIndex: t6,
            style: style,
            ...safeHtmlAttributes,
            type: type,
            onClick: onClick,
            disabled: isDisabled,
            xcss: t8,
            testId: testId,
            ref: ref,
            children: children
        });
        $[26] = children;
        $[27] = isDisabled;
        $[28] = onClick;
        $[29] = ref;
        $[30] = safeHtmlAttributes;
        $[31] = style;
        $[32] = t6;
        $[33] = t8;
        $[34] = testId;
        $[35] = type;
        $[36] = t9;
    } else t9 = $[36];
    return t9;
} : ({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $dpsRj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8cnlb.Focusable // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button",
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $7kFxw.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $k12R1.cx)($10888dde32781e27$var$styles.root, isDisabled && $10888dde32781e27$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
module.exports["Pressable"] = $10888dde32781e27$export$27c701ed9e449e99;

});

parcelRegister("8cnlb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c31d56bd0cf6b25c$var$focusRingStyles = null;
const $c31d56bd0cf6b25c$var$insetFocusRingStyles = null;
const $c31d56bd0cf6b25c$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let isInset;
    let style;
    let t1;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: t1, children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = isInset;
        $[4] = style;
        $[5] = t1;
        $[6] = testId;
        $[7] = xcss;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        isInset = $[3];
        style = $[4];
        t1 = $[5];
        testId = $[6];
        xcss = $[7];
    }
    const Component = t1 === undefined ? "button" : t1;
    let safeHtmlAttributes;
    if ($[8] !== htmlAttributes) {
        const { className: _spreadClass, ...t2 } = htmlAttributes;
        safeHtmlAttributes = t2;
        $[8] = htmlAttributes;
        $[9] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[9];
    const t2 = isInset && "_34b3D2ZPSy _0aMSfYZPSy";
    let t3;
    if ($[10] !== t2 || $[11] !== xcss) {
        t3 = (0, $hekY6.default)([
            "_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu",
            t2,
            xcss
        ]);
        $[10] = t2;
        $[11] = xcss;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== Component || $[14] !== children || $[15] !== ref || $[16] !== safeHtmlAttributes || $[17] !== style || $[18] !== t3 || $[19] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            ...safeHtmlAttributes,
            ref: ref,
            className: t3,
            style: style,
            "data-testid": testId,
            children: children
        });
        $[13] = Component;
        $[14] = children;
        $[15] = ref;
        $[16] = safeHtmlAttributes;
        $[17] = style;
        $[18] = t3;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $hekY6.default)([
            "_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu",
            isInset && "_34b3D2ZPSy _0aMSfYZPSy",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
module.exports["Focusable"] = $c31d56bd0cf6b25c$export$35a3bebf7ef2d934;

});

parcelRegister("aGB72", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $d9HXn = parcelRequire("d9HXn");

const $c0dd4c910b91322e$export$33ffd74ebf07f060 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const modalContext = (0, $cozmU.useContext)((0, $d9HXn.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
} : ()=>{
    const modalContext = (0, $cozmU.useContext)((0, $d9HXn.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};
module.exports["useModal"] = $c0dd4c910b91322e$export$33ffd74ebf07f060;

});

parcelRegister("jq995", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $24dy7 = parcelRequire("24dy7");


var $lMGh1 = parcelRequire("lMGh1");


var $aGB72 = parcelRequire("aGB72");

const $a1932ee8628e33b7$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $a1932ee8628e33b7$var$iconStyles = null;
const $a1932ee8628e33b7$var$titleStyles = null;
const $a1932ee8628e33b7$var$textStyles = null;
const $a1932ee8628e33b7$var$truncatedTextStyles = null;
const $a1932ee8628e33b7$var$TitleIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { appearance: appearance } = t0;
    const Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))) : (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1)));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _1UtDYzOLYo _4ya3eEOLYo _2l4i3rOLYo _1kk5TkOLYo _3iugoSOLYo _26BoRwOLYo"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = $a1932ee8628e33b7$var$iconColor[appearance];
    let t3;
    if ($[1] !== Icon || $[2] !== appearance || $[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement(Icon, {
            label: appearance,
            color: t2,
            spacing: "spacious"
        }));
        $[1] = Icon;
        $[2] = appearance;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))) : (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1)));
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _1UtDYzOLYo _4ya3eEOLYo _2l4i3rOLYo _1kk5TkOLYo _3iugoSOLYo _26BoRwOLYo"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Icon, {
        label: appearance,
        color: $a1932ee8628e33b7$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
const $a1932ee8628e33b7$var$ModalTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(14);
    const { appearance: appearance, children: children, isMultiline: t0, testId: userDefinedTestId } = props;
    const isMultiline = t0 === undefined ? true : t0;
    const { titleId: titleId, testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2mHwu82ADO _2sNsIgWSk4 _3iDTPbQ4SZ _4ouGXIdnbC _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== appearance) {
        t2 = appearance && /*#__PURE__*/ $cozmU.createElement($a1932ee8628e33b7$var$TitleIcon, {
            appearance: appearance
        });
        $[1] = appearance;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = testId && `${testId}-text`;
    const t4 = !isMultiline && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7";
    let t5;
    if ($[3] !== t4) {
        t5 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgWSk4 _4ouGXIdnbC _1T2N03wPeg",
            t4
        ]);
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== children || $[6] !== t3 || $[7] !== t5 || $[8] !== titleId) {
        t6 = /*#__PURE__*/ $cozmU.createElement("span", {
            id: titleId,
            "data-testid": t3,
            className: t5
        }, children);
        $[5] = children;
        $[6] = t3;
        $[7] = t5;
        $[8] = titleId;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t2 || $[11] !== t6 || $[12] !== testId) {
        t7 = /*#__PURE__*/ $cozmU.createElement("h1", {
            "data-testid": testId,
            className: t1
        }, t2, t6);
        $[10] = t2;
        $[11] = t6;
        $[12] = testId;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ $cozmU.createElement("h1", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2sNsIgWSk4 _3iDTPbQ4SZ _4ouGXIdnbC _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg"
        ])
    }, appearance && /*#__PURE__*/ $cozmU.createElement($a1932ee8628e33b7$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        id: titleId,
        "data-testid": testId && `${testId}-text`,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgWSk4 _4ouGXIdnbC _1T2N03wPeg",
            !isMultiline && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
        ])
    }, children));
};
var $a1932ee8628e33b7$export$2e2bcd8739ae039 = $a1932ee8628e33b7$var$ModalTitle;
module.exports["default"] = $a1932ee8628e33b7$export$2e2bcd8739ae039;

});

parcelRegister("fEPJS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cPEb7 = parcelRequire("cPEb7");


var $aGB72 = parcelRequire("aGB72");

/* scroll-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $cbY7C = parcelRequire("cbY7C");


var $LQnOI = parcelRequire("LQnOI");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $aEhqo = parcelRequire("aEhqo");


var $8cnlb = parcelRequire("8cnlb");

const $87e9b4decd8f5823$var$keylineColor = "var(--ds-border, #0B120E24)";
const $87e9b4decd8f5823$var$styles = {
    base: "_1ma2CfOLYo _3iDTPbOLYo _0aFT5vOLYo _2O5Vij7dHp _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _4bt5LAnQyn _2WAcuGIZbP _3GZDR8ZqHV _2aYxTvIZbP",
    topKeyline: "_1v3aPqOeNX",
    bottomKeyline: "_2R4pr3OeNX"
};
const $87e9b4decd8f5823$var$keylineHeight = 1;
const $87e9b4decd8f5823$var$ScrollContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $cozmU.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $cozmU.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $cozmU.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $cozmU.useState)(false); // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $cozmU.useEffect)(()=>{
        const schedule = (0, $LQnOI.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $aEhqo.default)((0, $LQnOI.default)(()=>{
        const target_0 = scrollableRef.current;
        if (target_0) {
            const scrollableDistance = target_0.scrollHeight - target_0.clientHeight;
            if (target_0.previousElementSibling) setTopKeyline(target_0.scrollTop > $87e9b4decd8f5823$var$keylineHeight);
            if (target_0.nextElementSibling) setBottomKeyline(target_0.scrollTop <= scrollableDistance - $87e9b4decd8f5823$var$keylineHeight);
        }
    })); // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $cozmU.useEffect)(()=>{
        const target_1 = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target_1 ? (0, $cbY7C.bind)(target_1, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $dpsRj.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.Focusable), {
        as: "div",
        isInset: true // tabindex is allowed here so that keyboard users can scroll content
        ,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $lmzCg.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $w6R6I.cx)($87e9b4decd8f5823$var$styles.base, showTopKeyline && $87e9b4decd8f5823$var$styles.topKeyline, showBottomKeyline && $87e9b4decd8f5823$var$styles.bottomKeyline)
    }, children);
});
$87e9b4decd8f5823$var$ScrollContainer.displayName = 'ScrollContainer';
var $87e9b4decd8f5823$export$2e2bcd8739ae039 = $87e9b4decd8f5823$var$ScrollContainer;









var $gUZwF = parcelRequire("gUZwF");

/**
 * This returns whether or not scrolling is allowed based on the existing
 * scrolling context.
 */ const $f79d780cb6dacc6a$var$useScroll = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScroll() {
    const shouldScrollInViewport = (0, $cozmU.useContext)((0, $gUZwF.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
} : function useScroll() {
    const shouldScrollInViewport = (0, $cozmU.useContext)((0, $gUZwF.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
};
var $f79d780cb6dacc6a$export$2e2bcd8739ae039 = $f79d780cb6dacc6a$var$useScroll;


const $9e7bddbebc663ae3$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgmnOE",
    paddingBlock: "_4c065UFQfX",
    paddingInline: "_2Y7lL4NHnM"
};
const $9e7bddbebc663ae3$var$ModalBody = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, testId: userDefinedTestId, hasInlinePadding: t0 } = props;
    const hasInlinePadding = t0 === undefined ? true : t0;
    const { testId: modalTestId } = (0, $aGB72.useModal)();
    const shouldScrollInViewport = (0, $f79d780cb6dacc6a$export$2e2bcd8739ae039)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    let t1;
    if ($[0] !== children || $[1] !== hasInlinePadding || $[2] !== modalTestId || $[3] !== shouldScrollInViewport || $[4] !== testId || $[5] !== userDefinedTestId) {
        t1 = shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            className: (0, $hekY6.default)([
                $9e7bddbebc663ae3$var$styles.root,
                hasInlinePadding && $9e7bddbebc663ae3$var$styles.paddingInline
            ])
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPEb7.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87e9b4decd8f5823$export$2e2bcd8739ae039), {
            testId: userDefinedTestId || modalTestId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            className: (0, $hekY6.default)([
                $9e7bddbebc663ae3$var$styles.root,
                $9e7bddbebc663ae3$var$styles.paddingBlock,
                hasInlinePadding && $9e7bddbebc663ae3$var$styles.paddingInline
            ])
        }, children)));
        $[0] = children;
        $[1] = hasInlinePadding;
        $[2] = modalTestId;
        $[3] = shouldScrollInViewport;
        $[4] = testId;
        $[5] = userDefinedTestId;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $aGB72.useModal)();
    const shouldScrollInViewport = (0, $f79d780cb6dacc6a$export$2e2bcd8739ae039)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $9e7bddbebc663ae3$var$styles.root,
            hasInlinePadding && $9e7bddbebc663ae3$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPEb7.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87e9b4decd8f5823$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $9e7bddbebc663ae3$var$styles.root,
            /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $9e7bddbebc663ae3$var$styles.paddingBlock,
            hasInlinePadding && $9e7bddbebc663ae3$var$styles.paddingInline
        ])
    }, children)));
};
var $9e7bddbebc663ae3$export$2e2bcd8739ae039 = $9e7bddbebc663ae3$var$ModalBody;
module.exports["default"] = $9e7bddbebc663ae3$export$2e2bcd8739ae039;

});

parcelRegister("eQiT1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $aGB72 = parcelRequire("aGB72");

const $4f71e897e15991d9$var$footerStyles = null;
const $4f71e897e15991d9$var$ModalFooter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_2mHwu82ADO _2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuz9WS _43nrzTLl21 _0xmtkoNHnM _46hvQm5zaO"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== children || $[2] !== testId) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t0
        }, children);
        $[1] = children;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $aGB72.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuz9WS _43nrzTLl21 _0xmtkoNHnM _46hvQm5zaO"
        ])
    }, children);
};
var $4f71e897e15991d9$export$2e2bcd8739ae039 = $4f71e897e15991d9$var$ModalFooter;
module.exports["default"] = $4f71e897e15991d9$export$2e2bcd8739ae039;

});

parcelRegister("vIR70", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");


var $aRMYx = parcelRequire("aRMYx");

/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $d6dba9d6a128c298$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingButton(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    let appearance;
    let isDisabled;
    let isSelected;
    let rest;
    let spacing;
    let t1;
    if ($[0] !== t0) {
        ({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: t1, spacing: spacing, ...rest } = t0);
        $[0] = t0;
        $[1] = appearance;
        $[2] = isDisabled;
        $[3] = isSelected;
        $[4] = rest;
        $[5] = spacing;
        $[6] = t1;
    } else {
        appearance = $[1];
        isDisabled = $[2];
        isSelected = $[3];
        rest = $[4];
        spacing = $[5];
        t1 = $[6];
    }
    const isLoading = t1 === undefined ? false : t1;
    const t2 = isLoading || undefined;
    let t3;
    if ($[7] !== appearance || $[8] !== isDisabled || $[9] !== isLoading || $[10] !== isSelected || $[11] !== spacing) {
        t3 = isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRMYx.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null;
        $[7] = appearance;
        $[8] = isDisabled;
        $[9] = isLoading;
        $[10] = isSelected;
        $[11] = spacing;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== appearance || $[14] !== isDisabled || $[15] !== isSelected || $[16] !== ref || $[17] !== rest || $[18] !== spacing || $[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            ...rest,
            ref: ref,
            appearance: appearance,
            "aria-disabled": t2,
            isDisabled: isDisabled,
            isSelected: isSelected,
            overlay: t3,
            spacing: spacing
        });
        $[13] = appearance;
        $[14] = isDisabled;
        $[15] = isSelected;
        $[16] = ref;
        $[17] = rest;
        $[18] = spacing;
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRMYx.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$d6dba9d6a128c298$var$LoadingButton.displayName = 'LoadingButton';
var $d6dba9d6a128c298$export$2e2bcd8739ae039 = $d6dba9d6a128c298$var$LoadingButton;
module.exports["default"] = $d6dba9d6a128c298$export$2e2bcd8739ae039;

});

parcelRegister("7ZB0A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $9yCGl = parcelRequire("9yCGl");


var $4LCZp = parcelRequire("4LCZp");


var $8IeMU = parcelRequire("8IeMU");

const $a476a1f5a5982366$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $a476a1f5a5982366$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function Button(t0, ref) {
    const $ = (0, $bDgLe.c)(38);
    let children;
    let iconAfter;
    let iconBefore;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] !== t0) {
        ({ appearance: t1, children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: t2, onMouseDown: t3, onMouseUp: t4, shouldFitContainer: t5, spacing: t6, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = iconAfter;
        $[3] = iconBefore;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        children = $[1];
        iconAfter = $[2];
        iconBefore = $[3];
        rest = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const isSelected = t2 === undefined ? false : t2;
    const providedOnMouseDown = t3 === undefined ? (0, $dpsRj.default) : t3;
    const providedOnMouseUp = t4 === undefined ? (0, $dpsRj.default) : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    const spacing = t6 === undefined ? "default" : t6;
    let t7;
    if ($[11] !== children || $[12] !== iconAfter || $[13] !== iconBefore) {
        t7 = (0, $8IeMU.default)({
            children: children,
            iconBefore: iconBefore,
            iconAfter: iconAfter
        });
        $[11] = children;
        $[12] = iconAfter;
        $[13] = iconBefore;
        $[14] = t7;
    } else t7 = $[14];
    const isOnlySingleIcon = t7;
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    let t8;
    if ($[15] !== providedOnMouseDown) {
        t8 = (event)=>{
            providedOnMouseDown(event);
            if ($a476a1f5a5982366$var$isFirefox) setIsActive(true);
        };
        $[15] = providedOnMouseDown;
        $[16] = t8;
    } else t8 = $[16];
    const onMouseDown = t8;
    let t9;
    if ($[17] !== providedOnMouseUp) {
        t9 = (event_0)=>{
            providedOnMouseUp(event_0);
            if ($a476a1f5a5982366$var$isFirefox) setIsActive(false);
        };
        $[17] = providedOnMouseUp;
        $[18] = t9;
    } else t9 = $[18];
    const onMouseUp = t9;
    let t10;
    if ($[19] !== appearance || $[20] !== isOnlySingleIcon || $[21] !== isSelected || $[22] !== shouldFitContainer || $[23] !== spacing) {
        t10 = (0, $4LCZp.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
        $[19] = appearance;
        $[20] = isOnlySingleIcon;
        $[21] = isSelected;
        $[22] = shouldFitContainer;
        $[23] = spacing;
        $[24] = t10;
    } else t10 = $[24];
    const buttonCss = t10;
    const t11 = isActive ? true : undefined;
    let t12;
    if ($[25] !== appearance || $[26] !== buttonCss || $[27] !== children || $[28] !== iconAfter || $[29] !== iconBefore || $[30] !== isSelected || $[31] !== onMouseDown || $[32] !== onMouseUp || $[33] !== ref || $[34] !== rest || $[35] !== spacing || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yCGl.default), {
            ...rest,
            ref: ref,
            appearance: appearance,
            buttonCss: buttonCss,
            children: children,
            "data-firefox-is-active": t11,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isSelected: isSelected,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            spacing: spacing
        });
        $[25] = appearance;
        $[26] = buttonCss;
        $[27] = children;
        $[28] = iconAfter;
        $[29] = iconBefore;
        $[30] = isSelected;
        $[31] = onMouseDown;
        $[32] = onMouseUp;
        $[33] = ref;
        $[34] = rest;
        $[35] = spacing;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $dpsRj.default), onMouseUp: providedOnMouseUp = (0, $dpsRj.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $8IeMU.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $cozmU.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($a476a1f5a5982366$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $cozmU.useCallback)((event_0)=>{
        providedOnMouseUp(event_0);
        if ($a476a1f5a5982366$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $cozmU.useMemo)(()=>(0, $4LCZp.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yCGl.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$a476a1f5a5982366$var$Button.displayName = 'Button';
var $a476a1f5a5982366$export$2e2bcd8739ae039 = $a476a1f5a5982366$var$Button;
module.exports["default"] = $a476a1f5a5982366$export$2e2bcd8739ae039;

});

parcelRegister("3izAL", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $4a7cO = parcelRequire("4a7cO");


var $cl1W1 = parcelRequire("cl1W1");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc2f8099477ab616059b3ca3af61579>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $2d02e1283592f4f5$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};


const $67daab8572a9e647$export$5e65a44e5b6ecadb = (color)=>(0, $2d02e1283592f4f5$export$41a358c9c2356760)[color] !== undefined;



var $b2E2m = parcelRequire("b2E2m");


var $1tDzb = parcelRequire("1tDzb");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $koUFz = parcelRequire("koUFz");


var $ebPt8 = parcelRequire("ebPt8");


const $17a4815694ef33a7$export$ff257d957d48c421 = (0, $ebPt8.getSerializedStylesMap)((0, $koUFz.CURRENT_SURFACE_CSS_VAR), (0, $2d02e1283592f4f5$export$41a358c9c2356760));


function $b595c0a778f8cfbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b595c0a778f8cfbc$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $b595c0a778f8cfbc$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $cl1W1.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $67daab8572a9e647$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $17a4815694ef33a7$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b2E2m.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b2E2m.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b2E2m.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b2E2m.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b2E2m.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b2E2m.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b2E2m.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4a7cO.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b595c0a778f8cfbc$export$2e2bcd8739ae039 = $b595c0a778f8cfbc$export$e71c4d32a2263218;
const $b595c0a778f8cfbc$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
module.exports["Box"] = $b595c0a778f8cfbc$export$e71c4d32a2263218;

});

parcelRegister("4a7cO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $78caabb4a946befc$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $cozmU.createContext)('elevation.surface');
module.exports["SurfaceContext"] = $78caabb4a946befc$export$1ca2a26fecb070ae;

});

parcelRegister("1tDzb", function(module, exports) {
/* parse-xcss.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("cozmU");


var $kQDaq = parcelRequire("kQDaq");

const $1fc5499df21d310c$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $1fc5499df21d310c$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $kQDaq.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
module.exports["parseXcss"] = $1fc5499df21d310c$export$a9c84988c8f81f2d;

});

parcelRegister("buxP3", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4193602efb8ae1ec92457e1d4ae51cd6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $413fe9e8f8444c04$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};



var $0IH32 = parcelRequire("0IH32");


var $15WAQ = parcelRequire("15WAQ");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75649f8b704acb878c98303f7bc82aee>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $72874a00261fe8cb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};



var $gjS4Z = parcelRequire("gjS4Z");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9183c00a6ce1b53a46530f6f0a7883ea>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $79dbb7d207d9f4d3$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e931a3b15648861e85392c4c0721fbb>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $5346cbf033968ba4$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46fa1415e9618559c3725b5d922ea57>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $c443177b42f8299d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd1de71dbd395ec11ae36c4fe5f287>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $7583bee614197cff$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a468f2941874c14b7f39734d626517>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $3173e5f0fb0637fb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15dcdf4fb5f4336a22fbffce70eb0f75>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $2a2f845718845872$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};



var $hpqhf = parcelRequire("hpqhf");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e652bb770b0f835445d139bf6da7fa80>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $7dc73fbebadb6e7b$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};



var $j9gRX = parcelRequire("j9gRX");

const $1aa71af7b7ff6c45$export$9a199fbafee0014e = {
    backgroundColor: (0, $0IH32.backgroundColorMap),
    blockSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $15WAQ.borderColorMap),
    borderBlockEndColor: (0, $15WAQ.borderColorMap),
    borderBlockEndWidth: (0, $gjS4Z.borderWidthMap),
    borderBlockStartColor: (0, $15WAQ.borderColorMap),
    borderBlockStartWidth: (0, $gjS4Z.borderWidthMap),
    borderBlockWidth: (0, $gjS4Z.borderWidthMap),
    borderBottomColor: (0, $15WAQ.borderColorMap),
    borderBottomLeftRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $gjS4Z.borderWidthMap),
    borderColor: (0, $15WAQ.borderColorMap),
    borderEndEndRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $15WAQ.borderColorMap),
    borderInlineEndColor: (0, $15WAQ.borderColorMap),
    borderInlineEndWidth: (0, $gjS4Z.borderWidthMap),
    borderInlineStartColor: (0, $15WAQ.borderColorMap),
    borderInlineStartWidth: (0, $gjS4Z.borderWidthMap),
    borderInlineWidth: (0, $gjS4Z.borderWidthMap),
    borderLeftColor: (0, $15WAQ.borderColorMap),
    borderLeftWidth: (0, $gjS4Z.borderWidthMap),
    borderRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $15WAQ.borderColorMap),
    borderRightWidth: (0, $gjS4Z.borderWidthMap),
    borderStartEndRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $15WAQ.borderColorMap),
    borderTopLeftRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $72874a00261fe8cb$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $gjS4Z.borderWidthMap),
    borderWidth: (0, $gjS4Z.borderWidthMap),
    bottom: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    boxShadow: (0, $7dc73fbebadb6e7b$export$7aff6e7ba39bb774),
    color: (0, $j9gRX.textColorMap),
    columnGap: (0, $hpqhf.positiveSpaceMap),
    font: (0, $5346cbf033968ba4$export$6ffa317d5e70375),
    fontFamily: (0, $c443177b42f8299d$export$3c7e9587132614b4),
    fontWeight: (0, $7583bee614197cff$export$303e322c6b1ed114),
    gap: (0, $hpqhf.positiveSpaceMap),
    height: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    inlineSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    inset: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetBlock: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetBlockEnd: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetBlockStart: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetInline: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetInlineEnd: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    insetInlineStart: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    left: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    margin: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginBlock: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginBlockEnd: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginBlockStart: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginBottom: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginInline: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginInlineEnd: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginInlineStart: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginLeft: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginRight: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    marginTop: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    maxBlockSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    maxHeight: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    maxWidth: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    minBlockSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    minHeight: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    minInlineSize: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    minWidth: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    opacity: (0, $2a2f845718845872$export$daf94a976c798b4f),
    outlineColor: (0, $15WAQ.borderColorMap),
    outlineOffset: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    outlineWidth: (0, $gjS4Z.borderWidthMap),
    padding: (0, $hpqhf.positiveSpaceMap),
    paddingBlock: (0, $hpqhf.positiveSpaceMap),
    paddingBlockEnd: (0, $hpqhf.positiveSpaceMap),
    paddingBlockStart: (0, $hpqhf.positiveSpaceMap),
    paddingBottom: (0, $hpqhf.positiveSpaceMap),
    paddingInline: (0, $hpqhf.positiveSpaceMap),
    paddingInlineEnd: (0, $hpqhf.positiveSpaceMap),
    paddingInlineStart: (0, $hpqhf.positiveSpaceMap),
    paddingLeft: (0, $hpqhf.positiveSpaceMap),
    paddingRight: (0, $hpqhf.positiveSpaceMap),
    paddingTop: (0, $hpqhf.positiveSpaceMap),
    right: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    rowGap: (0, $hpqhf.positiveSpaceMap),
    top: (0, $413fe9e8f8444c04$export$632685d741f3dbbf),
    width: (0, $79dbb7d207d9f4d3$export$6ccdbebca2ee545f),
    zIndex: (0, $3173e5f0fb0637fb$export$b5f31a7e431d2eab)
};



var $kQDaq = parcelRequire("kQDaq");


var $1P2f3 = parcelRequire("1P2f3");

const $4df3b690bf859ee1$var$isSafeEnvToThrow = ()=>typeof $1P2f3 === 'object' && typeof $1P2f3.env === 'object' && false;
const $4df3b690bf859ee1$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $4df3b690bf859ee1$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $4df3b690bf859ee1$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($4df3b690bf859ee1$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $4df3b690bf859ee1$var$safeSelectors.test(key)) {
            styleObj[key] = $4df3b690bf859ee1$var$transformStyles(value);
            return;
        }
        if ($4df3b690bf859ee1$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($4df3b690bf859ee1$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $1aa71af7b7ff6c45$export$9a199fbafee0014e))) return;
        const tokenValue = (0, $1aa71af7b7ff6c45$export$9a199fbafee0014e)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $4df3b690bf859ee1$var$baseXcss = (style)=>{
    const transformedStyles = $4df3b690bf859ee1$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $kQDaq.uniqueSymbol)]: /*#__PURE__*/ (0, $lOiVq.css)(transformedStyles)
    };
};
function $4df3b690bf859ee1$export$f6c783d06584602c(style) {
    return $4df3b690bf859ee1$var$baseXcss(style);
}
module.exports["xcss"] = $4df3b690bf859ee1$export$f6c783d06584602c;

});

parcelRegister("7vK9E", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $bB0i2 = parcelRequire("bB0i2");


var $7r5Hr = parcelRequire("7r5Hr");


var $ir4h8 = parcelRequire("ir4h8");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $5EzLH = parcelRequire("5EzLH");


var $9GVkD = parcelRequire("9GVkD");


var $8cnlb = parcelRequire("8cnlb");

const $ac5f4156a44c5c03$var$styles = {
    root: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _24h04i2Njc",
    position: "_1mT5xdRAKS"
};
const $ac5f4156a44c5c03$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ac5f4156a44c5c03$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $ac5f4156a44c5c03$var$AnchorNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(50);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let componentName;
    let href;
    let htmlAttributes;
    let interactionName;
    let style;
    let t1;
    let t2;
    let target;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ href: href, children: children, onClick: t1, interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: t2, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = children;
        $[5] = componentName;
        $[6] = href;
        $[7] = htmlAttributes;
        $[8] = interactionName;
        $[9] = style;
        $[10] = t1;
        $[11] = t2;
        $[12] = target;
        $[13] = testId;
        $[14] = xcss;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        children = $[4];
        componentName = $[5];
        href = $[6];
        htmlAttributes = $[7];
        interactionName = $[8];
        style = $[9];
        t1 = $[10];
        t2 = $[11];
        target = $[12];
        testId = $[13];
        xcss = $[14];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const newWindowLabel = t2 === undefined ? "(opens new window)" : t2;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    if ($[15] !== interactionContext || $[16] !== interactionName || $[17] !== providedOnClick) {
        t3 = (e, analyticsEvent)=>{
            interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
            providedOnClick(e, analyticsEvent);
        };
        $[15] = interactionContext;
        $[16] = interactionName;
        $[17] = providedOnClick;
        $[18] = t3;
    } else t3 = $[18];
    const handleClick = t3;
    const opensNewWindowLabelId = (0, $6JrSr.useId)();
    const t4 = componentName || "Anchor";
    let t5;
    if ($[19] !== analyticsContext || $[20] !== handleClick || $[21] !== t4) {
        t5 = {
            fn: handleClick,
            action: "clicked",
            componentName: t4,
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: analyticsContext,
            actionSubject: "link"
        };
        $[19] = analyticsContext;
        $[20] = handleClick;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t5);
    let safeHtmlAttributes;
    if ($[23] !== htmlAttributes) {
        const { className: _spreadClass, ...t6 } = htmlAttributes;
        safeHtmlAttributes = t6;
        $[23] = htmlAttributes;
        $[24] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[24];
    const RouterLink = (0, $ir4h8.useRouterLink)();
    const isExternal = typeof href === "string" && $ac5f4156a44c5c03$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === "string" && $ac5f4156a44c5c03$var$IS_NON_HTTP_BASED.test(href);
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === "object";
    (0, $bB0i2.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    const Component = isRouterLink ? RouterLink : "a";
    const t6 = !isRouterLink && typeof href !== "string" ? undefined : href;
    const t7 = ariaLabel && target === "_blank" && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel;
    const t8 = ariaLabelledBy && target === "_blank" ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy;
    let t9;
    if ($[25] !== xcss) {
        t9 = (0, $k12R1.cx)($ac5f4156a44c5c03$var$styles.root, $ac5f4156a44c5c03$var$styles.position, xcss);
        $[25] = xcss;
        $[26] = t9;
    } else t9 = $[26];
    const t10 = testId ? isRouterLink ? "true" : "false" : undefined;
    let t11;
    if ($[27] !== ariaLabel || $[28] !== ariaLabelledBy || $[29] !== children || $[30] !== newWindowLabel || $[31] !== opensNewWindowLabelId || $[32] !== target) {
        t11 = target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            id: opensNewWindowLabelId,
            children: `, ${newWindowLabel}`
        });
        $[27] = ariaLabel;
        $[28] = ariaLabelledBy;
        $[29] = children;
        $[30] = newWindowLabel;
        $[31] = opensNewWindowLabelId;
        $[32] = target;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== Component || $[35] !== children || $[36] !== onClick || $[37] !== ref || $[38] !== safeHtmlAttributes || $[39] !== style || $[40] !== t10 || $[41] !== t11 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9 || $[46] !== target || $[47] !== testId || $[48] !== xcss) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8cnlb.Focusable), {
            as: Component,
            className: xcss,
            style: style,
            ref: ref,
            ...safeHtmlAttributes,
            href: t6,
            target: target,
            onClick: onClick,
            "aria-label": t7,
            "aria-labelledby": t8,
            xcss: t9,
            testId: testId,
            "data-is-router-link": t10,
            children: [
                children,
                t11
            ]
        });
        $[34] = Component;
        $[35] = children;
        $[36] = onClick;
        $[37] = ref;
        $[38] = safeHtmlAttributes;
        $[39] = style;
        $[40] = t10;
        $[41] = t11;
        $[42] = t6;
        $[43] = t7;
        $[44] = t8;
        $[45] = t9;
        $[46] = target;
        $[47] = testId;
        $[48] = xcss;
        $[49] = t12;
    } else t12 = $[49];
    return t12;
} : ({ href: href, children: children, onClick: providedOnClick = (0, $dpsRj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $6JrSr.useId)();
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $ir4h8.useRouterLink)();
    const isExternal = typeof href === 'string' && $ac5f4156a44c5c03$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ac5f4156a44c5c03$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $bB0i2.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8cnlb.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $k12R1.cx)($ac5f4156a44c5c03$var$styles.root, $ac5f4156a44c5c03$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
const $ac5f4156a44c5c03$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $cozmU.forwardRef)($ac5f4156a44c5c03$var$AnchorNoRef);
module.exports["Anchor"] = $ac5f4156a44c5c03$export$b688253958b8dfe7;

});

parcelRegister("iMnC5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4a7cO = parcelRequire("4a7cO");

const $de86aa0b3c6b3430$var$baseStyles = null;
const $de86aa0b3c6b3430$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtlest.hovered': "_0KLXruL7r8",
    'color.background.accent.lime.subtlest.pressed': "_0KLXrulDnJ",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtler.hovered': "_0KLXruuIDk",
    'color.background.accent.lime.subtler.pressed': "_0KLXruyTNr",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.subtle.hovered': "_0KLXrude7x",
    'color.background.accent.lime.subtle.pressed': "_0KLXrum9Fz",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.lime.bolder.hovered': "_0KLXruaWdC",
    'color.background.accent.lime.bolder.pressed': "_0KLXruCN3C",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtlest.hovered': "_0KLXruIg5O",
    'color.background.accent.red.subtlest.pressed': "_0KLXruElzn",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtler.hovered': "_0KLXruFOVf",
    'color.background.accent.red.subtler.pressed': "_0KLXruFnU8",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.subtle.hovered': "_0KLXruIt8U",
    'color.background.accent.red.subtle.pressed': "_0KLXrunRhf",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.red.bolder.hovered': "_0KLXrumCVf",
    'color.background.accent.red.bolder.pressed': "_0KLXruPm25",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtlest.hovered': "_0KLXru629A",
    'color.background.accent.orange.subtlest.pressed': "_0KLXrupg0Z",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtler.hovered': "_0KLXruEo5I",
    'color.background.accent.orange.subtler.pressed': "_0KLXru78bI",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.subtle.hovered': "_0KLXrunwBH",
    'color.background.accent.orange.subtle.pressed': "_0KLXruKHmw",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.orange.bolder.hovered': "_0KLXruwYNk",
    'color.background.accent.orange.bolder.pressed': "_0KLXruDYlO",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtlest.hovered': "_0KLXruBwZU",
    'color.background.accent.yellow.subtlest.pressed': "_0KLXruHN5H",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtler.hovered': "_0KLXruJMtC",
    'color.background.accent.yellow.subtler.pressed': "_0KLXruVvUp",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.subtle.hovered': "_0KLXruSF9i",
    'color.background.accent.yellow.subtle.pressed': "_0KLXruOIUD",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.yellow.bolder.hovered': "_0KLXru5gSm",
    'color.background.accent.yellow.bolder.pressed': "_0KLXruTjon",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtlest.hovered': "_0KLXruMqh8",
    'color.background.accent.green.subtlest.pressed': "_0KLXruUxn0",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtler.hovered': "_0KLXruSZVv",
    'color.background.accent.green.subtler.pressed': "_0KLXruratX",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.subtle.hovered': "_0KLXru6mZS",
    'color.background.accent.green.subtle.pressed': "_0KLXruIBxe",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.green.bolder.hovered': "_0KLXruB5SF",
    'color.background.accent.green.bolder.pressed': "_0KLXruLYGL",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtlest.hovered': "_0KLXrugqYx",
    'color.background.accent.teal.subtlest.pressed': "_0KLXrufBlI",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtler.hovered': "_0KLXruA8mq",
    'color.background.accent.teal.subtler.pressed': "_0KLXrujHQE",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.subtle.hovered': "_0KLXrubjxt",
    'color.background.accent.teal.subtle.pressed': "_0KLXruUDSb",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.teal.bolder.hovered': "_0KLXrunc80",
    'color.background.accent.teal.bolder.pressed': "_0KLXruu11s",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtlest.hovered': "_0KLXruotmK",
    'color.background.accent.blue.subtlest.pressed': "_0KLXruxyGe",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtler.hovered': "_0KLXruRRyT",
    'color.background.accent.blue.subtler.pressed': "_0KLXrueeqx",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.subtle.hovered': "_0KLXruKSSk",
    'color.background.accent.blue.subtle.pressed': "_0KLXru40Rv",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.blue.bolder.hovered': "_0KLXruupqB",
    'color.background.accent.blue.bolder.pressed': "_0KLXru36Hh",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtlest.hovered': "_0KLXrueJK9",
    'color.background.accent.purple.subtlest.pressed': "_0KLXruhT4j",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtler.hovered': "_0KLXrujgGS",
    'color.background.accent.purple.subtler.pressed': "_0KLXruWgRz",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.subtle.hovered': "_0KLXru46BV",
    'color.background.accent.purple.subtle.pressed': "_0KLXruU9Hm",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.purple.bolder.hovered': "_0KLXruXxp4",
    'color.background.accent.purple.bolder.pressed': "_0KLXru1L16",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtlest.hovered': "_0KLXruWeuD",
    'color.background.accent.magenta.subtlest.pressed': "_0KLXruK9iC",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtler.hovered': "_0KLXrukPhQ",
    'color.background.accent.magenta.subtler.pressed': "_0KLXruGjVz",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.subtle.hovered': "_0KLXruexkg",
    'color.background.accent.magenta.subtle.pressed': "_0KLXruV3kb",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.magenta.bolder.hovered': "_0KLXruPb8Y",
    'color.background.accent.magenta.bolder.pressed': "_0KLXruwQL0",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtlest.hovered': "_0KLXruBee8",
    'color.background.accent.gray.subtlest.pressed': "_0KLXruysrI",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtler.hovered': "_0KLXruXljP",
    'color.background.accent.gray.subtler.pressed': "_0KLXru6vdf",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.subtle.hovered': "_0KLXruY62e",
    'color.background.accent.gray.subtle.pressed': "_0KLXruvFnq",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.accent.gray.bolder.hovered': "_0KLXruW5tB",
    'color.background.accent.gray.bolder.pressed': "_0KLXrunA18",
    'color.background.disabled': "_0KLXruVrZW",
    'color.background.input': "_0KLXru7Cj1",
    'color.background.input.hovered': "_0KLXruqWX3",
    'color.background.input.pressed': "_0KLXruutHW",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.inverse.subtle.hovered': "_0KLXruVzWZ",
    'color.background.inverse.subtle.pressed': "_0KLXruTmu4",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.hovered': "_0KLXruKcZT",
    'color.background.neutral.pressed': "_0KLXrunpTK",
    'color.background.neutral.subtle': "_0KLXru66of",
    'color.background.neutral.subtle.hovered': "_0KLXruo126",
    'color.background.neutral.subtle.pressed': "_0KLXruN4oS",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.neutral.bold.hovered': "_0KLXrukTlo",
    'color.background.neutral.bold.pressed': "_0KLXruVbka",
    'color.background.selected': "_0KLXruY9q9",
    'color.background.selected.hovered': "_0KLXrusumd",
    'color.background.selected.pressed': "_0KLXruXsxn",
    'color.background.selected.bold': "_0KLXrukLmD",
    'color.background.selected.bold.hovered': "_0KLXruXLOx",
    'color.background.selected.bold.pressed': "_0KLXruPSfI",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.subtlest.hovered': "_0KLXruNPoG",
    'color.background.brand.subtlest.pressed': "_0KLXruLKV0",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.bold.hovered': "_0KLXruhmrj",
    'color.background.brand.bold.pressed': "_0KLXruczkD",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.brand.boldest.hovered': "_0KLXruzGNP",
    'color.background.brand.boldest.pressed': "_0KLXru9Y3T",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.hovered': "_0KLXru1IMt",
    'color.background.danger.pressed': "_0KLXruig7D",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.danger.bold.hovered': "_0KLXruEISo",
    'color.background.danger.bold.pressed': "_0KLXruL5fL",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.hovered': "_0KLXrudEDW",
    'color.background.warning.pressed': "_0KLXruiJjO",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.warning.bold.hovered': "_0KLXruOCpk",
    'color.background.warning.bold.pressed': "_0KLXruSN2W",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.hovered': "_0KLXruYQVR",
    'color.background.success.pressed': "_0KLXruFj7I",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.success.bold.hovered': "_0KLXru1YDn",
    'color.background.success.bold.pressed': "_0KLXrulx7w",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.hovered': "_0KLXruaV2P",
    'color.background.discovery.pressed': "_0KLXruET5a",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.discovery.bold.hovered': "_0KLXrunIkF",
    'color.background.discovery.bold.pressed': "_0KLXruSHT5",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.hovered': "_0KLXruwQql",
    'color.background.information.pressed': "_0KLXruB0Fx",
    'color.background.information.bold': "_0KLXruASYT",
    'color.background.information.bold.hovered': "_0KLXruGaQW",
    'color.background.information.bold.pressed': "_0KLXrujXMX",
    'color.blanket': "_0KLXruA5lS",
    'color.blanket.selected': "_0KLXrumA7q",
    'color.blanket.danger': "_0KLXrupOKR",
    'color.skeleton': "_0KLXruGsB2",
    'color.skeleton.subtle': "_0KLXruaVjy",
    'elevation.surface': "_0KLXrulfZc",
    'elevation.surface.hovered': "_0KLXrud1Zr",
    'elevation.surface.pressed': "_0KLXruJNoT",
    'elevation.surface.overlay': "_0KLXruoI2d",
    'elevation.surface.overlay.hovered': "_0KLXruhWTW",
    'elevation.surface.overlay.pressed': "_0KLXru0GoB",
    'elevation.surface.raised': "_0KLXruqi9L",
    'elevation.surface.raised.hovered': "_0KLXrubvxc",
    'elevation.surface.raised.pressed': "_0KLXruSEy3",
    'elevation.surface.sunken': "_0KLXrunmFW",
    'utility.elevation.surface.current': "_0KLXru4TrO"
};
const $de86aa0b3c6b3430$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $de86aa0b3c6b3430$var$setSurfaceTokenMap = {
    'elevation.surface': "_45TjwHlfZc",
    'elevation.surface.hovered': "_45TjwHd1Zr",
    'elevation.surface.pressed': "_45TjwHJNoT",
    'elevation.surface.overlay': "_45TjwHoI2d",
    'elevation.surface.overlay.hovered': "_45TjwHhWTW",
    'elevation.surface.overlay.pressed': "_45TjwH0GoB",
    'elevation.surface.raised': "_45TjwHqi9L",
    'elevation.surface.raised.hovered': "_45TjwHbvxc",
    'elevation.surface.raised.pressed': "_45TjwHSEy3",
    'elevation.surface.sunken': "_45TjwHnmFW"
};
const $de86aa0b3c6b3430$var$paddingBlockStartMap = {
    'space.0': "_46hvQmPgdg",
    'space.025': "_46hvQmFQfX",
    'space.050': "_46hvQm1Y8M",
    'space.075': "_46hvQmgVvo",
    'space.100': "_46hvQm2ADO",
    'space.150': "_46hvQm8HPE",
    'space.200': "_46hvQm5zaO",
    'space.250': "_46hvQmkG2W",
    'space.300': "_46hvQmNHnM",
    'space.400': "_46hvQmVa5s",
    'space.500': "_46hvQmS40j",
    'space.600': "_46hvQmp0Oa",
    'space.800': "_46hvQmGXk2",
    'space.1000': "_46hvQmyFLW"
};
const $de86aa0b3c6b3430$var$paddingBlockEndMap = {
    'space.0': "_0xmtkoPgdg",
    'space.025': "_0xmtkoFQfX",
    'space.050': "_0xmtko1Y8M",
    'space.075': "_0xmtkogVvo",
    'space.100': "_0xmtko2ADO",
    'space.150': "_0xmtko8HPE",
    'space.200': "_0xmtko5zaO",
    'space.250': "_0xmtkokG2W",
    'space.300': "_0xmtkoNHnM",
    'space.400': "_0xmtkoVa5s",
    'space.500': "_0xmtkoS40j",
    'space.600': "_0xmtkop0Oa",
    'space.800': "_0xmtkoGXk2",
    'space.1000': "_0xmtkoyFLW"
};
const $de86aa0b3c6b3430$var$paddingInlineStartMap = {
    'space.0': "_0LQT5EPgdg",
    'space.025': "_0LQT5EFQfX",
    'space.050': "_0LQT5E1Y8M",
    'space.075': "_0LQT5EgVvo",
    'space.100': "_0LQT5E2ADO",
    'space.150': "_0LQT5E8HPE",
    'space.200': "_0LQT5E5zaO",
    'space.250': "_0LQT5EkG2W",
    'space.300': "_0LQT5ENHnM",
    'space.400': "_0LQT5EVa5s",
    'space.500': "_0LQT5ES40j",
    'space.600': "_0LQT5Ep0Oa",
    'space.800': "_0LQT5EGXk2",
    'space.1000': "_0LQT5EyFLW"
};
const $de86aa0b3c6b3430$var$paddingInlineEndMap = {
    'space.0': "_03SyCPPgdg",
    'space.025': "_03SyCPFQfX",
    'space.050': "_03SyCP1Y8M",
    'space.075': "_03SyCPgVvo",
    'space.100': "_03SyCP2ADO",
    'space.150': "_03SyCP8HPE",
    'space.200': "_03SyCP5zaO",
    'space.250': "_03SyCPkG2W",
    'space.300': "_03SyCPNHnM",
    'space.400': "_03SyCPVa5s",
    'space.500': "_03SyCPS40j",
    'space.600': "_03SyCPp0Oa",
    'space.800': "_03SyCPGXk2",
    'space.1000': "_03SyCPyFLW"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $de86aa0b3c6b3430$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(36);
    let backgroundColor;
    let children;
    let htmlAttributes;
    let padding;
    let style;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: t1, children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: t2, paddingBlockStart: t3, paddingBlockEnd: t4, paddingInline: t5, paddingInlineStart: t6, paddingInlineEnd: t7, style: style, testId: testId, xcss: xcss, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = backgroundColor;
        $[2] = children;
        $[3] = htmlAttributes;
        $[4] = padding;
        $[5] = style;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = testId;
        $[14] = xcss;
    } else {
        backgroundColor = $[1];
        children = $[2];
        htmlAttributes = $[3];
        padding = $[4];
        style = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
        testId = $[13];
        xcss = $[14];
    }
    const Component = t1 === undefined ? "div" : t1;
    const paddingBlock = t2 === undefined ? padding : t2;
    const paddingBlockStart = t3 === undefined ? paddingBlock : t3;
    const paddingBlockEnd = t4 === undefined ? paddingBlock : t4;
    const paddingInline = t5 === undefined ? padding : t5;
    const paddingInlineStart = t6 === undefined ? paddingInline : t6;
    const paddingInlineEnd = t7 === undefined ? paddingInline : t7;
    let safeHtmlAttributes;
    if ($[15] !== htmlAttributes) {
        const { className: _spreadClass, ...t8 } = htmlAttributes;
        safeHtmlAttributes = t8;
        $[15] = htmlAttributes;
        $[16] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[16];
    const t8 = backgroundColor && $de86aa0b3c6b3430$var$backgroundColorMap[backgroundColor];
    let t9;
    if ($[17] !== backgroundColor || $[18] !== paddingBlockEnd || $[19] !== paddingBlockStart || $[20] !== paddingInlineEnd || $[21] !== paddingInlineStart || $[22] !== t8 || $[23] !== xcss) {
        t9 = (0, $hekY6.default)([
            "_30huDKYbGa _24h04i2Njc _034jHtYbGa",
            t8,
            backgroundColor && $de86aa0b3c6b3430$var$isSurfaceToken(backgroundColor) && $de86aa0b3c6b3430$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $de86aa0b3c6b3430$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $de86aa0b3c6b3430$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $de86aa0b3c6b3430$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $de86aa0b3c6b3430$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]);
        $[17] = backgroundColor;
        $[18] = paddingBlockEnd;
        $[19] = paddingBlockStart;
        $[20] = paddingInlineEnd;
        $[21] = paddingInlineStart;
        $[22] = t8;
        $[23] = xcss;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== Component || $[26] !== children || $[27] !== ref || $[28] !== safeHtmlAttributes || $[29] !== style || $[30] !== t9 || $[31] !== testId) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            style: style,
            ref: ref,
            className: t9,
            ...safeHtmlAttributes,
            "data-testid": testId,
            children: children
        });
        $[25] = Component;
        $[26] = children;
        $[27] = ref;
        $[28] = safeHtmlAttributes;
        $[29] = style;
        $[30] = t9;
        $[31] = testId;
        $[32] = t10;
    } else t10 = $[32];
    const node = t10;
    if (backgroundColor) {
        let t11;
        if ($[33] !== backgroundColor || $[34] !== node) {
            t11 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4a7cO.SurfaceContext).Provider, {
                value: backgroundColor,
                children: node
            });
            $[33] = backgroundColor;
            $[34] = node;
            $[35] = t11;
        } else t11 = $[35];
        return t11;
    }
    return node;
} : ({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        style: style,
        ref: ref,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _24h04i2Njc _034jHtYbGa",
            backgroundColor && $de86aa0b3c6b3430$var$backgroundColorMap[backgroundColor],
            backgroundColor && $de86aa0b3c6b3430$var$isSurfaceToken(backgroundColor) && $de86aa0b3c6b3430$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $de86aa0b3c6b3430$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $de86aa0b3c6b3430$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $de86aa0b3c6b3430$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $de86aa0b3c6b3430$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4a7cO.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // The return type of `BoxComponent` does not match the return type of `forwardRef` in React 18
);
function $de86aa0b3c6b3430$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $de86aa0b3c6b3430$var$setSurfaceTokenMap;
}
module.exports["Box"] = $de86aa0b3c6b3430$export$e71c4d32a2263218;

});

parcelRegister("1l0kj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $4ez2K = parcelRequire("4ez2K");

const $00199dedba3cb4b9$var$styles = {
    separator: "_3SamIHPgdg _2YLqiKLl21 _1UtDYzZpcK _1pp6NdYbGa _20VacPYbGa",
    hug: "_2O5VijdnbC",
    fill: "_39xV02N91d _2O5Vij7dHp"
};
const $00199dedba3cb4b9$var$Separator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $00199dedba3cb4b9$var$styles.separator
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $00199dedba3cb4b9$var$styles.separator
        ]),
        children: children
    }); /**
                                                                   * __Inline__
                                                                   *
                                                                   * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
                                                                   *
                                                                   * @example
                                                                   * ```tsx
                                                                   *  <Inline>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *  </Inline>
                                                                   * ```
                                                                   *
                                                                   */ 
const $00199dedba3cb4b9$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(38);
    let alignInline;
    let ariaAttributes;
    let as;
    let grow;
    let rawChildren;
    let role;
    let rowSpace;
    let separator;
    let space;
    let spread;
    let t1;
    let t2;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: as, alignInline: alignInline, alignBlock: t1, shouldWrap: t2, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes } = t0);
        $[0] = t0;
        $[1] = alignInline;
        $[2] = ariaAttributes;
        $[3] = as;
        $[4] = grow;
        $[5] = rawChildren;
        $[6] = role;
        $[7] = rowSpace;
        $[8] = separator;
        $[9] = space;
        $[10] = spread;
        $[11] = t1;
        $[12] = t2;
        $[13] = testId;
        $[14] = xcss;
    } else {
        alignInline = $[1];
        ariaAttributes = $[2];
        as = $[3];
        grow = $[4];
        rawChildren = $[5];
        role = $[6];
        rowSpace = $[7];
        separator = $[8];
        space = $[9];
        spread = $[10];
        t1 = $[11];
        t2 = $[12];
        testId = $[13];
        xcss = $[14];
    }
    const alignItems = t1 === undefined ? "start" : t1;
    const shouldWrap = t2 === undefined ? false : t2;
    let t3;
    if ($[15] !== separator) {
        t3 = typeof separator === "string" ? /*#__PURE__*/ (0, $8aG6j.jsx)($00199dedba3cb4b9$var$Separator, {
            children: separator
        }) : separator;
        $[15] = separator;
        $[16] = t3;
    } else t3 = $[16];
    const separatorComponent = t3;
    let t4;
    if ($[17] !== rawChildren || $[18] !== separator || $[19] !== separatorComponent) {
        t4 = separatorComponent ? (0, $cozmU.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                children: [
                    separator && index > 0 ? separatorComponent : null,
                    child
                ]
            }, index)) : rawChildren;
        $[17] = rawChildren;
        $[18] = separator;
        $[19] = separatorComponent;
        $[20] = t4;
    } else t4 = $[20];
    const children = t4;
    const t5 = spread || alignInline;
    const t6 = shouldWrap ? "wrap" : undefined;
    const t7 = grow === "hug" && $00199dedba3cb4b9$var$styles.hug;
    const t8 = grow === "fill" && $00199dedba3cb4b9$var$styles.fill;
    let t9;
    if ($[21] !== t7 || $[22] !== t8 || $[23] !== xcss) {
        t9 = (0, $w6R6I.cx)(t7, t8, xcss);
        $[21] = t7;
        $[22] = t8;
        $[23] = xcss;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== alignItems || $[26] !== ariaAttributes || $[27] !== as || $[28] !== children || $[29] !== ref || $[30] !== role || $[31] !== rowSpace || $[32] !== space || $[33] !== t5 || $[34] !== t6 || $[35] !== t9 || $[36] !== testId) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            ...ariaAttributes,
            as: as,
            role: role,
            alignItems: alignItems,
            justifyContent: t5,
            direction: "row",
            gap: space,
            rowGap: rowSpace,
            wrap: t6,
            xcss: t9,
            testId: testId,
            ref: ref,
            children: children
        });
        $[25] = alignItems;
        $[26] = ariaAttributes;
        $[27] = as;
        $[28] = children;
        $[29] = ref;
        $[30] = role;
        $[31] = rowSpace;
        $[32] = space;
        $[33] = t5;
        $[34] = t6;
        $[35] = t9;
        $[36] = testId;
        $[37] = t10;
    } else t10 = $[37];
    return t10;
} : ({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $8aG6j.jsx)($00199dedba3cb4b9$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $cozmU.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $w6R6I.cx)(grow === 'hug' && $00199dedba3cb4b9$var$styles.hug, grow === 'fill' && $00199dedba3cb4b9$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$00199dedba3cb4b9$export$fbae5b5ffd8af05e.displayName = 'Inline';
module.exports["Inline"] = $00199dedba3cb4b9$export$fbae5b5ffd8af05e;

});

parcelRegister("4aRua", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $bB0i2 = parcelRequire("bB0i2");


var $lkNt6 = parcelRequire("lkNt6");


var $jWJz9 = parcelRequire("jWJz9");


var $6RgkX = parcelRequire("6RgkX");

const $219df5faf46e29fe$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
const $219df5faf46e29fe$var$useColor = (0, $gtMdU.isReactCompilerActivePlatform)() ? (colorProp, hasTextAncestor)=>{
    const surface = (0, $jWJz9.useSurface)();
    if (colorProp === "inherit") return;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return;
    if ($219df5faf46e29fe$var$inverseColorMap.hasOwnProperty(surface)) return $219df5faf46e29fe$var$inverseColorMap[surface];
    return "color.text";
} : (colorProp, hasTextAncestor)=>{
    const surface = (0, $jWJz9.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($219df5faf46e29fe$var$inverseColorMap.hasOwnProperty(surface)) return $219df5faf46e29fe$var$inverseColorMap[surface];
    return 'color.text';
};
const $219df5faf46e29fe$var$styles = {
    root: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3zvHkHdC7N",
    'as.strong': "_1kk5Tkmb2E",
    'as.em': "_2l4i3rGpkd",
    'textAlign.center': "_2fwxA5DIqT",
    'textAlign.end': "_2fwxA5F05b",
    'textAlign.start': "_2fwxA57p2s",
    truncation: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28",
    breakAll: "_3W2Oc84hR5"
};
const $219df5faf46e29fe$var$fontSizeMap = {
    medium: "_2sNsIgmnOE",
    large: "_2sNsIg20Hp",
    small: "_2sNsIg7NXe"
};
const $219df5faf46e29fe$var$fontWeightMap = {
    bold: "_1kk5Tkmb2E",
    medium: "_1kk5Tkf7mX",
    regular: "_1kk5Tku7m9",
    semibold: "_1kk5Tk7GSX"
};
const $219df5faf46e29fe$var$textColorMap = {
    'color.text': "_1UtDYzy7kJ",
    'color.text.accent.lime': "_1UtDYzqsUt",
    'color.text.accent.lime.bolder': "_1UtDYzfXoY",
    'color.text.accent.red': "_1UtDYzjgGB",
    'color.text.accent.red.bolder': "_1UtDYziNu3",
    'color.text.accent.orange': "_1UtDYzu4OJ",
    'color.text.accent.orange.bolder': "_1UtDYzH9Ub",
    'color.text.accent.yellow': "_1UtDYzDIkS",
    'color.text.accent.yellow.bolder': "_1UtDYzD7aB",
    'color.text.accent.green': "_1UtDYz9qYF",
    'color.text.accent.green.bolder': "_1UtDYzgGm3",
    'color.text.accent.teal': "_1UtDYzY3Jz",
    'color.text.accent.teal.bolder': "_1UtDYz2SoF",
    'color.text.accent.blue': "_1UtDYz866Z",
    'color.text.accent.blue.bolder': "_1UtDYz802h",
    'color.text.accent.purple': "_1UtDYzYfD7",
    'color.text.accent.purple.bolder': "_1UtDYzXCFT",
    'color.text.accent.magenta': "_1UtDYzSbwp",
    'color.text.accent.magenta.bolder': "_1UtDYzcMOQ",
    'color.text.accent.gray': "_1UtDYzUktF",
    'color.text.accent.gray.bolder': "_1UtDYzyXux",
    'color.text.disabled': "_1UtDYzot27",
    'color.text.inverse': "_1UtDYze5R3",
    'color.text.selected': "_1UtDYzjTy9",
    'color.text.brand': "_1UtDYzGaer",
    'color.text.danger': "_1UtDYzAyGJ",
    'color.text.warning': "_1UtDYzZSA9",
    'color.text.warning.inverse': "_1UtDYzVW6T",
    'color.text.success': "_1UtDYzGL5O",
    'color.text.discovery': "_1UtDYzJejw",
    'color.text.information': "_1UtDYzccV4",
    'color.text.subtlest': "_1UtDYzKGUX",
    'color.text.subtle': "_1UtDYzZpcK",
    'color.link': "_1UtDYzM7Tp",
    'color.link.pressed': "_1UtDYzAwSC",
    'color.link.visited': "_1UtDYzWfPD",
    'color.link.visited.pressed': "_1UtDYzWyeI"
};
const $219df5faf46e29fe$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
}; /**
              * __Text__
              *
              * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
              * This includes considerations for text attributes such as color, font size, font weight, and line height.
              * It renders a `span` by default.
              *
              * @internal
              */ 
const $219df5faf46e29fe$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(22);
    let { as: t1, color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children } = t0;
    const Component = t1 === undefined ? "span" : t1;
    (0, $bB0i2.default)($219df5faf46e29fe$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $6RgkX.useHasTextAncestor)();
    const color = $219df5faf46e29fe$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    const t2 = id;
    const t3 = size && $219df5faf46e29fe$var$fontSizeMap[size];
    const t4 = color && $219df5faf46e29fe$var$textColorMap[color];
    const t5 = maxLines && $219df5faf46e29fe$var$styles.truncation;
    const t6 = maxLines === 1 && $219df5faf46e29fe$var$styles.breakAll;
    const t7 = align && $219df5faf46e29fe$var$styles[`textAlign.${align}`];
    const t8 = weight && $219df5faf46e29fe$var$fontWeightMap[weight];
    const t9 = Component === "em" && $219df5faf46e29fe$var$styles["as.em"];
    const t10 = Component === "strong" && $219df5faf46e29fe$var$styles["as.strong"];
    let t11;
    if ($[0] !== t10 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8 || $[7] !== t9 || $[8] !== xcss) {
        t11 = (0, $hekY6.default)([
            $219df5faf46e29fe$var$styles.root,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            t10,
            xcss
        ]);
        $[0] = t10;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
        $[6] = t8;
        $[7] = t9;
        $[8] = xcss;
        $[9] = t11;
    } else t11 = $[9];
    let t12;
    if ($[10] !== maxLines) {
        t12 = {
            WebkitLineClamp: maxLines
        };
        $[10] = maxLines;
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] !== Component || $[13] !== children || $[14] !== id || $[15] !== ref || $[16] !== t11 || $[17] !== t12 || $[18] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            id: t2,
            className: t11,
            style: t12,
            "data-testid": testId,
            ref: ref,
            children: children
        });
        $[12] = Component;
        $[13] = children;
        $[14] = id;
        $[15] = ref;
        $[16] = t11;
        $[17] = t12;
        $[18] = testId;
        $[19] = t13;
    } else t13 = $[19];
    const component = t13;
    if (hasTextAncestor) return component;
    let t14;
    if ($[20] !== component) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lkNt6.HasTextAncestorProvider), {
            value: true,
            children: component
        });
        $[20] = component;
        $[21] = t14;
    } else t14 = $[21];
    return t14;
} : ({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $bB0i2.default)($219df5faf46e29fe$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $6RgkX.useHasTextAncestor)();
    const color = $219df5faf46e29fe$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        id: id,
        className: (0, $hekY6.default)([
            $219df5faf46e29fe$var$styles.root,
            size && $219df5faf46e29fe$var$fontSizeMap[size],
            color && $219df5faf46e29fe$var$textColorMap[color],
            maxLines && $219df5faf46e29fe$var$styles.truncation,
            maxLines === 1 && $219df5faf46e29fe$var$styles.breakAll,
            align && $219df5faf46e29fe$var$styles[`textAlign.${align}`],
            weight && $219df5faf46e29fe$var$fontWeightMap[weight],
            Component === 'em' && $219df5faf46e29fe$var$styles['as.em'],
            Component === 'strong' && $219df5faf46e29fe$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lkNt6.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
module.exports["Text"] = $219df5faf46e29fe$export$5f1af8db9871e1d6;

});

parcelRegister("jWJz9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $4a7cO = parcelRequire("4a7cO");

const $d3c78d7510be0e31$export$1aeb4f6b93c4540d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $4a7cO.SurfaceContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $4a7cO.SurfaceContext));
};
(0, $4a7cO.SurfaceContext).displayName = 'SurfaceProvider';
module.exports["useSurface"] = $d3c78d7510be0e31$export$1aeb4f6b93c4540d;

});

parcelRegister("kh0hi", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $5EzLH = parcelRequire("5EzLH");


var $cl1W1 = parcelRequire("cl1W1");


var $15WAQ = parcelRequire("15WAQ");


var $gjS4Z = parcelRequire("gjS4Z");


var $b2E2m = parcelRequire("b2E2m");


var $1tDzb = parcelRequire("1tDzb");


var $hpqhf = parcelRequire("hpqhf");

function $a2faaf7c81f10acd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $a2faaf7c81f10acd$var$focusRingStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $15WAQ.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hpqhf.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $gjS4Z.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $gjS4Z.borderWidthMap)['border.width']} solid`
        }
    }
});
const $a2faaf7c81f10acd$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $a2faaf7c81f10acd$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $a2faaf7c81f10acd$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $a2faaf7c81f10acd$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $dpsRj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $a2faaf7c81f10acd$var$baseStyles,
            $a2faaf7c81f10acd$var$focusRingStyles,
            isDisabled ? $a2faaf7c81f10acd$var$disabledStyles : $a2faaf7c81f10acd$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $cl1W1.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b2E2m.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b2E2m.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b2E2m.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b2E2m.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b2E2m.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b2E2m.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b2E2m.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a2faaf7c81f10acd$export$2e2bcd8739ae039 = $a2faaf7c81f10acd$export$27c701ed9e449e99;
module.exports["Pressable"] = $a2faaf7c81f10acd$export$27c701ed9e449e99;
module.exports["default"] = $a2faaf7c81f10acd$export$2e2bcd8739ae039;

});

parcelRegister("l5OUH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::828feee5f551f4f72139928d095ef0f9>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $5bd43c0821edd2d0$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
module.exports["inverseColorMap"] = $5bd43c0821edd2d0$export$2185ce37f9bdd963;

});

parcelRegister("dinVW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $4ez2K = parcelRequire("4ez2K");

const $b85052fd2af460c0$var$styles = {
    hug: "_2O5VijdnbC",
    fill: "_39xV02N91d _2O5Vij7dHp"
}; /**
    * __Stack__
    *
    * Stack is a primitive component based on flexbox that manages the block layout of direct children.
    *
    * @example
    * ```tsx
    *  <Stack>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *    <Box padding="space.100" backgroundColor="neutral"></Box>
    *  </Stack>
    * ```
    *
    */ 
const $b85052fd2af460c0$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(27);
    let alignItems;
    let ariaAttributes;
    let as;
    let children;
    let grow;
    let role;
    let space;
    let spread;
    let t1;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: as, alignInline: alignItems, alignBlock: t1, spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes } = t0);
        $[0] = t0;
        $[1] = alignItems;
        $[2] = ariaAttributes;
        $[3] = as;
        $[4] = children;
        $[5] = grow;
        $[6] = role;
        $[7] = space;
        $[8] = spread;
        $[9] = t1;
        $[10] = testId;
        $[11] = xcss;
    } else {
        alignItems = $[1];
        ariaAttributes = $[2];
        as = $[3];
        children = $[4];
        grow = $[5];
        role = $[6];
        space = $[7];
        spread = $[8];
        t1 = $[9];
        testId = $[10];
        xcss = $[11];
    }
    const alignBlock = t1 === undefined ? "stretch" : t1;
    const t2 = spread || alignBlock;
    const t3 = grow === "hug" && $b85052fd2af460c0$var$styles.hug;
    const t4 = grow === "fill" && $b85052fd2af460c0$var$styles.fill;
    let t5;
    if ($[12] !== t3 || $[13] !== t4 || $[14] !== xcss) {
        t5 = (0, $w6R6I.cx)(t3, t4, xcss);
        $[12] = t3;
        $[13] = t4;
        $[14] = xcss;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== alignItems || $[17] !== ariaAttributes || $[18] !== as || $[19] !== children || $[20] !== ref || $[21] !== role || $[22] !== space || $[23] !== t2 || $[24] !== t5 || $[25] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            ...ariaAttributes,
            as: as,
            role: role,
            gap: space,
            direction: "column",
            alignItems: alignItems,
            justifyContent: t2,
            xcss: t5,
            testId: testId,
            ref: ref,
            children: children
        });
        $[16] = alignItems;
        $[17] = ariaAttributes;
        $[18] = as;
        $[19] = children;
        $[20] = ref;
        $[21] = role;
        $[22] = space;
        $[23] = t2;
        $[24] = t5;
        $[25] = testId;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $w6R6I.cx)(grow === 'hug' && $b85052fd2af460c0$var$styles.hug, grow === 'fill' && $b85052fd2af460c0$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$b85052fd2af460c0$export$694e0d28c7ffc90c.displayName = 'Stack';
module.exports["Stack"] = $b85052fd2af460c0$export$694e0d28c7ffc90c;

});

parcelRegister("5SGpQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9NuHu = parcelRequire("9NuHu");


var $9yCGl = parcelRequire("9yCGl");


var $8IeMU = parcelRequire("8IeMU");


var $aRMYx = parcelRequire("aRMYx");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $49ae7bd30d5b86d3$export$437a7f77d13d7916(current, values) {
    return current(values);
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $8ccb8123c224425b$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}



var $2AXFJ = parcelRequire("2AXFJ");

function $5dd62183d5106382$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $5dd62183d5106382$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $5dd62183d5106382$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomThemeButton(t0, ref) {
    const $ = (0, $bDgLe.c)(50);
    let providedOnBlur;
    let providedOnFocus;
    let providedOnMouseDown;
    let providedOnMouseEnter;
    let providedOnMouseLeave;
    let providedOnMouseUp;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] !== t0) {
        ({ appearance: t1, autoFocus: t2, isDisabled: t3, isSelected: t4, shouldFitContainer: t5, spacing: t6, isLoading: t7, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: t8, ...rest } = t0);
        $[0] = t0;
        $[1] = providedOnBlur;
        $[2] = providedOnFocus;
        $[3] = providedOnMouseDown;
        $[4] = providedOnMouseEnter;
        $[5] = providedOnMouseLeave;
        $[6] = providedOnMouseUp;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else {
        providedOnBlur = $[1];
        providedOnFocus = $[2];
        providedOnMouseDown = $[3];
        providedOnMouseEnter = $[4];
        providedOnMouseLeave = $[5];
        providedOnMouseUp = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        t6 = $[13];
        t7 = $[14];
        t8 = $[15];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const autoFocus = t2 === undefined ? false : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const isSelected = t4 === undefined ? false : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    const spacing = t6 === undefined ? "default" : t6;
    const isLoading = t7 === undefined ? false : t7;
    const theme = t8 === undefined ? (0, $49ae7bd30d5b86d3$export$437a7f77d13d7916) : t8;
    let t9;
    if ($[16] !== appearance || $[17] !== autoFocus || $[18] !== isDisabled || $[19] !== isSelected || $[20] !== rest || $[21] !== shouldFitContainer || $[22] !== spacing) {
        t9 = {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            ...rest
        };
        $[16] = appearance;
        $[17] = autoFocus;
        $[18] = isDisabled;
        $[19] = isSelected;
        $[20] = rest;
        $[21] = shouldFitContainer;
        $[22] = spacing;
        $[23] = t9;
    } else t9 = $[23];
    const restProps = t9;
    const [state, setState] = (0, $cozmU.useState)($5dd62183d5106382$var$initial);
    let t10;
    if ($[24] !== providedOnMouseEnter) {
        t10 = (event)=>{
            setState($5dd62183d5106382$var$_temp);
            if (providedOnMouseEnter) providedOnMouseEnter(event);
        };
        $[24] = providedOnMouseEnter;
        $[25] = t10;
    } else t10 = $[25];
    const onMouseEnter = t10;
    let t11;
    if ($[26] !== providedOnMouseLeave) {
        t11 = (event_0)=>{
            setState($5dd62183d5106382$var$_temp2);
            if (providedOnMouseLeave) providedOnMouseLeave(event_0);
        };
        $[26] = providedOnMouseLeave;
        $[27] = t11;
    } else t11 = $[27];
    const onMouseLeave = t11;
    let t12;
    if ($[28] !== providedOnMouseDown) {
        t12 = (event_1)=>{
            setState($5dd62183d5106382$var$_temp3);
            if (providedOnMouseDown) providedOnMouseDown(event_1);
        };
        $[28] = providedOnMouseDown;
        $[29] = t12;
    } else t12 = $[29];
    const onMouseDown = t12;
    let t13;
    if ($[30] !== providedOnMouseUp) {
        t13 = (event_2)=>{
            setState($5dd62183d5106382$var$_temp4);
            if (providedOnMouseUp) providedOnMouseUp(event_2);
        };
        $[30] = providedOnMouseUp;
        $[31] = t13;
    } else t13 = $[31];
    const onMouseUp = t13;
    let t14;
    if ($[32] !== providedOnFocus) {
        t14 = (event_3)=>{
            setState($5dd62183d5106382$var$_temp5);
            if (providedOnFocus) providedOnFocus(event_3);
        };
        $[32] = providedOnFocus;
        $[33] = t14;
    } else t14 = $[33];
    const onFocus = t14;
    let t15;
    if ($[34] !== providedOnBlur) {
        t15 = (event_4)=>{
            setState($5dd62183d5106382$var$_temp6);
            if (providedOnBlur) providedOnBlur(event_4);
        };
        $[34] = providedOnBlur;
        $[35] = t15;
    } else t15 = $[35];
    const onBlur = t15;
    let t16;
    if ($[36] !== isLoading || $[37] !== onBlur || $[38] !== onFocus || $[39] !== onMouseDown || $[40] !== onMouseEnter || $[41] !== onMouseLeave || $[42] !== onMouseUp || $[43] !== ref || $[44] !== restProps || $[45] !== state) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9NuHu))).Consumer, null, (t17)=>{
            const { mode: mode } = t17;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2AXFJ.default).Consumer, {
                mode: mode,
                state: $5dd62183d5106382$var$getInteractionState({
                    ...state,
                    isLoading: isLoading,
                    isSelected: restProps.isSelected,
                    isDisabled: restProps.isDisabled
                }),
                iconIsOnlyChild: (0, $8IeMU.default)(restProps),
                isLoading: isLoading,
                ...restProps
            }, (t18)=>{
                const { buttonStyles: buttonStyles } = t18;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yCGl.default), {
                    ...restProps,
                    ref: ref,
                    overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRMYx.default), restProps) : null,
                    "aria-disabled": isLoading || restProps["aria-disabled"],
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onMouseDown: onMouseDown,
                    onMouseUp: onMouseUp,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    buttonCss: (0, $8ccb8123c224425b$export$643db0b8d8778e)(buttonStyles)
                });
            });
        });
        $[36] = isLoading;
        $[37] = onBlur;
        $[38] = onFocus;
        $[39] = onMouseDown;
        $[40] = onMouseEnter;
        $[41] = onMouseLeave;
        $[42] = onMouseUp;
        $[43] = ref;
        $[44] = restProps;
        $[45] = state;
        $[46] = t16;
    } else t16 = $[46];
    let t17;
    if ($[47] !== t16 || $[48] !== theme) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2AXFJ.default).Provider, {
            value: theme
        }, t16);
        $[47] = t16;
        $[48] = theme;
        $[49] = t17;
    } else t17 = $[49];
    return t17;
} : function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $49ae7bd30d5b86d3$export$437a7f77d13d7916), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $cozmU.useState)($5dd62183d5106382$var$initial);
    const onMouseEnter = (0, $cozmU.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)((event_0)=>{
        setState((current_0)=>({
                ...current_0,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event_0);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $cozmU.useCallback)((event_1)=>{
        setState((current_1)=>({
                ...current_1,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event_1);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $cozmU.useCallback)((event_2)=>{
        setState((current_2)=>({
                ...current_2,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event_2);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $cozmU.useCallback)((event_3)=>{
        setState((current_3)=>({
                ...current_3,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event_3);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $cozmU.useCallback)((event_4)=>{
        setState((current_4)=>({
                ...current_4,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event_4);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2AXFJ.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9NuHu))).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2AXFJ.default).Consumer, {
            mode: mode,
            state: $5dd62183d5106382$var$getInteractionState({
                ...state,
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            }),
            iconIsOnlyChild: (0, $8IeMU.default)(restProps),
            isLoading: isLoading,
            ...restProps
        }, ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yCGl.default), {
                ...restProps,
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRMYx.default), restProps) : null,
                // No need to render aria-disabled when it is false
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $8ccb8123c224425b$export$643db0b8d8778e)(buttonStyles)
            }))));
}));
// Tools including enzyme rely on components having a display name
$5dd62183d5106382$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $5dd62183d5106382$export$2e2bcd8739ae039 = $5dd62183d5106382$var$CustomThemeButton;
function $5dd62183d5106382$var$_temp(current) {
    return {
        ...current,
        isHover: true
    };
}
function $5dd62183d5106382$var$_temp2(current_0) {
    return {
        ...current_0,
        isHover: false,
        isActive: false
    };
}
function $5dd62183d5106382$var$_temp3(current_1) {
    return {
        ...current_1,
        isActive: true
    };
}
function $5dd62183d5106382$var$_temp4(current_2) {
    return {
        ...current_2,
        isActive: false
    };
}
function $5dd62183d5106382$var$_temp5(current_3) {
    return {
        ...current_3,
        isFocus: true
    };
}
function $5dd62183d5106382$var$_temp6(current_4) {
    return {
        ...current_4,
        isFocus: false
    };
}
module.exports["default"] = $5dd62183d5106382$export$2e2bcd8739ae039;

});

parcelRegister("2AXFJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9NuHu = parcelRequire("9NuHu");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $4LCZp = parcelRequire("4LCZp");

const $d0d33179cb553d74$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $d0d33179cb553d74$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $4LCZp.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $d0d33179cb553d74$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}


const $d7a6a39190be127d$var$Theme = (0, $9NuHu.createTheme)((themeProps)=>({
        buttonStyles: (0, $d0d33179cb553d74$export$31512de7fa606fa4)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d7a6a39190be127d$export$2e2bcd8739ae039 = $d7a6a39190be127d$var$Theme;
module.exports["default"] = $d7a6a39190be127d$export$2e2bcd8739ae039;

});

parcelRegister("7aRdF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cgay9 = parcelRequire("cgay9");

/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $1ec3f2e5d6698b7e$var$ModalWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgay9.default), {
            ...props,
            isFullScreen: false,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgay9.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$1ec3f2e5d6698b7e$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ec3f2e5d6698b7e$export$2e2bcd8739ae039 = $1ec3f2e5d6698b7e$var$ModalWrapper;
module.exports["default"] = $1ec3f2e5d6698b7e$export$2e2bcd8739ae039;

});

parcelRegister("jg3tF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $8ab3e19c445e94c4$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


const $e7392a57ea57e339$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $8ab3e19c445e94c4$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
const $e7392a57ea57e339$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $cozmU.useRef)(listener);
    (0, $cozmU.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $e7392a57ea57e339$var$queries[queryString];
    (0, $cozmU.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cbY7C.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $e7392a57ea57e339$export$49e55ae2c03d6045;

});

parcelRegister("6Pqow", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $bB0i2 = parcelRequire("bB0i2");


var $lkNt6 = parcelRequire("lkNt6");


var $jWJz9 = parcelRequire("jWJz9");


var $6RgkX = parcelRequire("6RgkX");


var $l5OUH = parcelRequire("l5OUH");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $ebPt8 = parcelRequire("ebPt8");


var $j9gRX = parcelRequire("j9gRX");

const $b5fce84467129bbb$export$3a1bcba60b23d7f0 = (0, $ebPt8.getSerializedStylesMap)('color', (0, $j9gRX.textColorMap));


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::610f7a87b5183bc177338e33463cac82>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $8d4a5f7544754c47$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};


const $dd7b8380caaa60a3$export$219d364c0da35ae4 = (0, $ebPt8.getSerializedStylesMap)('font', (0, $8d4a5f7544754c47$export$236bfe3a33ef1292));


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled



/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::771460ab0c298bfffbf486012c7cfab6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $80e65d2559d87898$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};


const $d7f41e8c78e0b627$export$38845ca010b93505 = (0, $ebPt8.getSerializedStylesMap)('fontWeight', (0, $80e65d2559d87898$export$855cfd311192d666));


function $da69d6feb1096fe2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $da69d6feb1096fe2$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $da69d6feb1096fe2$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $da69d6feb1096fe2$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $da69d6feb1096fe2$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $da69d6feb1096fe2$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $da69d6feb1096fe2$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $da69d6feb1096fe2$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $da69d6feb1096fe2$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $jWJz9.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $l5OUH.inverseColorMap).hasOwnProperty(surface)) return (0, $l5OUH.inverseColorMap)[surface];
    return 'color.text';
};
const $da69d6feb1096fe2$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $bB0i2.default)($da69d6feb1096fe2$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $6RgkX.useHasTextAncestor)();
    const color = $da69d6feb1096fe2$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        ref: ref,
        css: [
            $da69d6feb1096fe2$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $dd7b8380caaa60a3$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $b5fce84467129bbb$export$3a1bcba60b23d7f0)[color],
            maxLines && $da69d6feb1096fe2$var$truncationStyles,
            maxLines === 1 && $da69d6feb1096fe2$var$wordBreakMap.breakAll,
            align && $da69d6feb1096fe2$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $d7f41e8c78e0b627$export$38845ca010b93505)[weight],
            Component === 'em' && $da69d6feb1096fe2$var$emStyles,
            Component === 'strong' && $da69d6feb1096fe2$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lkNt6.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$da69d6feb1096fe2$export$2e2bcd8739ae039 = $da69d6feb1096fe2$export$5f1af8db9871e1d6;
module.exports["Text"] = $da69d6feb1096fe2$export$5f1af8db9871e1d6;
module.exports["default"] = $da69d6feb1096fe2$export$2e2bcd8739ae039;

});

parcelRegister("ad7Ou", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cOYa = parcelRequire("6cOYa");


var $n1i5T = parcelRequire("n1i5T");


var $aDGhF = parcelRequire("aDGhF");

/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $6bbbf40bed7aace8$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function Button(t0, ref) {
    const $ = (0, $bDgLe.c)(70);
    let analyticsContext;
    let appearance;
    let ariaLabel;
    let ariaLabelledBy;
    let autoFocus;
    let children;
    let iconAfter;
    let iconBefore;
    let interactionName;
    let isDisabled;
    let isSelected;
    let onClick;
    let onClickCapture;
    let onKeyDownCapture;
    let onKeyUpCapture;
    let onMouseDownCapture;
    let onMouseUpCapture;
    let onPointerDownCapture;
    let onPointerUpCapture;
    let onTouchEndCapture;
    let onTouchStartCapture;
    let shouldFitContainer;
    let spacing;
    let t1;
    let t2;
    let testId;
    let unsafeRest;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, appearance: appearance, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: t1, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: t2, ...unsafeRest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = appearance;
        $[3] = ariaLabel;
        $[4] = ariaLabelledBy;
        $[5] = autoFocus;
        $[6] = children;
        $[7] = iconAfter;
        $[8] = iconBefore;
        $[9] = interactionName;
        $[10] = isDisabled;
        $[11] = isSelected;
        $[12] = onClick;
        $[13] = onClickCapture;
        $[14] = onKeyDownCapture;
        $[15] = onKeyUpCapture;
        $[16] = onMouseDownCapture;
        $[17] = onMouseUpCapture;
        $[18] = onPointerDownCapture;
        $[19] = onPointerUpCapture;
        $[20] = onTouchEndCapture;
        $[21] = onTouchStartCapture;
        $[22] = shouldFitContainer;
        $[23] = spacing;
        $[24] = t1;
        $[25] = t2;
        $[26] = testId;
        $[27] = unsafeRest;
    } else {
        analyticsContext = $[1];
        appearance = $[2];
        ariaLabel = $[3];
        ariaLabelledBy = $[4];
        autoFocus = $[5];
        children = $[6];
        iconAfter = $[7];
        iconBefore = $[8];
        interactionName = $[9];
        isDisabled = $[10];
        isSelected = $[11];
        onClick = $[12];
        onClickCapture = $[13];
        onKeyDownCapture = $[14];
        onKeyUpCapture = $[15];
        onMouseDownCapture = $[16];
        onMouseUpCapture = $[17];
        onPointerDownCapture = $[18];
        onPointerUpCapture = $[19];
        onTouchEndCapture = $[20];
        onTouchStartCapture = $[21];
        shouldFitContainer = $[22];
        spacing = $[23];
        t1 = $[24];
        t2 = $[25];
        testId = $[26];
        unsafeRest = $[27];
    }
    const isLoading = t1 === undefined ? false : t1;
    const type = t2 === undefined ? "button" : t2;
    let saferRest;
    if ($[28] !== unsafeRest) {
        const { className: _className, css: _css, as: _as, style: _style, ...t3 } = unsafeRest;
        saferRest = t3;
        $[28] = unsafeRest;
        $[29] = saferRest;
    } else saferRest = $[29];
    const t3 = Boolean(iconBefore);
    const t4 = Boolean(iconAfter);
    let t5;
    if ($[30] !== iconBefore || $[31] !== isLoading) {
        t5 = iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
            icon: iconBefore
        }));
        $[30] = iconBefore;
        $[31] = isLoading;
        $[32] = t5;
    } else t5 = $[32];
    let t6;
    if ($[33] !== children || $[34] !== isLoading) {
        t6 = children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
            isLoading: isLoading
        }, children);
        $[33] = children;
        $[34] = isLoading;
        $[35] = t6;
    } else t6 = $[35];
    let t7;
    if ($[36] !== iconAfter || $[37] !== isLoading) {
        t7 = iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
            icon: iconAfter
        }));
        $[36] = iconAfter;
        $[37] = isLoading;
        $[38] = t7;
    } else t7 = $[38];
    let t8;
    if ($[39] !== analyticsContext || $[40] !== appearance || $[41] !== ariaLabel || $[42] !== ariaLabelledBy || $[43] !== autoFocus || $[44] !== interactionName || $[45] !== isDisabled || $[46] !== isLoading || $[47] !== isSelected || $[48] !== onClick || $[49] !== onClickCapture || $[50] !== onKeyDownCapture || $[51] !== onKeyUpCapture || $[52] !== onMouseDownCapture || $[53] !== onMouseUpCapture || $[54] !== onPointerDownCapture || $[55] !== onPointerUpCapture || $[56] !== onTouchEndCapture || $[57] !== onTouchStartCapture || $[58] !== ref || $[59] !== saferRest || $[60] !== shouldFitContainer || $[61] !== spacing || $[62] !== t3 || $[63] !== t4 || $[64] !== t5 || $[65] !== t6 || $[66] !== t7 || $[67] !== testId || $[68] !== type) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
            analyticsContext: analyticsContext,
            ref: ref,
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            hasIconBefore: t3,
            hasIconAfter: t4,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            testId: testId,
            componentName: "Button",
            type: type,
            interactionName: interactionName,
            ...saferRest
        }, t5, t6, t7);
        $[39] = analyticsContext;
        $[40] = appearance;
        $[41] = ariaLabel;
        $[42] = ariaLabelledBy;
        $[43] = autoFocus;
        $[44] = interactionName;
        $[45] = isDisabled;
        $[46] = isLoading;
        $[47] = isSelected;
        $[48] = onClick;
        $[49] = onClickCapture;
        $[50] = onKeyDownCapture;
        $[51] = onKeyUpCapture;
        $[52] = onMouseDownCapture;
        $[53] = onMouseUpCapture;
        $[54] = onPointerDownCapture;
        $[55] = onPointerUpCapture;
        $[56] = onTouchEndCapture;
        $[57] = onTouchStartCapture;
        $[58] = ref;
        $[59] = saferRest;
        $[60] = shouldFitContainer;
        $[61] = spacing;
        $[62] = t3;
        $[63] = t4;
        $[64] = t5;
        $[65] = t6;
        $[66] = t7;
        $[67] = testId;
        $[68] = type;
        $[69] = t8;
    } else t8 = $[69];
    return t8;
} : function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cOYa.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest
    }, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n1i5T.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDGhF.default), {
        icon: iconAfter
    })));
}));
$6bbbf40bed7aace8$var$Button.displayName = 'Button';
var $6bbbf40bed7aace8$export$2e2bcd8739ae039 = $6bbbf40bed7aace8$var$Button;
module.exports["default"] = $6bbbf40bed7aace8$export$2e2bcd8739ae039;

});

parcelRegister("aRGok", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iODl6 = parcelRequire("iODl6");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $dad1ef2596a12bbd$var$ModalTransition = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const t0 = props.children ?? null;
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t0);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, //Checking if children are undefined to prevent potential runtime errors in React 17
    props.children ?? null);
};
var $dad1ef2596a12bbd$export$2e2bcd8739ae039 = $dad1ef2596a12bbd$var$ModalTransition;
module.exports["default"] = $dad1ef2596a12bbd$export$2e2bcd8739ae039;

});

parcelRegister("3pCca", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $9017cc252c645528$var$rowGapMap = {
    'space.0': "_42d1HAPgdg",
    'space.025': "_42d1HAFQfX",
    'space.050': "_42d1HA1Y8M",
    'space.075': "_42d1HAgVvo",
    'space.100': "_42d1HA2ADO",
    'space.150': "_42d1HA8HPE",
    'space.200': "_42d1HA5zaO",
    'space.250': "_42d1HAkG2W",
    'space.300': "_42d1HANHnM",
    'space.400': "_42d1HAVa5s",
    'space.500': "_42d1HAS40j",
    'space.600': "_42d1HAp0Oa",
    'space.800': "_42d1HAGXk2",
    'space.1000': "_42d1HAyFLW"
};
const $9017cc252c645528$var$columnGapMap = {
    'space.0': "_17lj8pPgdg",
    'space.025': "_17lj8pFQfX",
    'space.050': "_17lj8p1Y8M",
    'space.075': "_17lj8pgVvo",
    'space.100': "_17lj8p2ADO",
    'space.150': "_17lj8p8HPE",
    'space.200': "_17lj8p5zaO",
    'space.250': "_17lj8pkG2W",
    'space.300': "_17lj8pNHnM",
    'space.400': "_17lj8pVa5s",
    'space.500': "_17lj8pS40j",
    'space.600': "_17lj8pp0Oa",
    'space.800': "_17lj8pGXk2",
    'space.1000': "_17lj8pyFLW"
};
const $9017cc252c645528$var$justifyContentMap = {
    start: "_37wbyu7p2s",
    center: "_37wbyuDIqT",
    end: "_37wbyuF05b",
    'space-between': "_37wbyuI7V3",
    'space-around': "_37wbyuxEoi",
    'space-evenly': "_37wbyuZHm0",
    stretch: "_37wbyuFlnN"
};
const $9017cc252c645528$var$alignContentMap = {
    start: "_0GwItX7p2s",
    center: "_0GwItXDIqT",
    end: "_0GwItXF05b",
    'space-between': "_0GwItXI7V3",
    'space-around': "_0GwItXxEoi",
    'space-evenly': "_0GwItXZHm0",
    stretch: "_0GwItXFlnN"
};
const $9017cc252c645528$var$alignItemsMap = {
    start: "_0hPCNL7p2s",
    center: "_0hPCNLDIqT",
    baseline: "_0hPCNLQame",
    end: "_0hPCNLF05b",
    stretch: "_0hPCNLFlnN"
};
const $9017cc252c645528$var$baseStyles = {
    root: "_3iDTPbgBM8 _24h04i2Njc"
};
const $9017cc252c645528$var$gridAutoFlowMap = {
    row: "_293iXK1qpb",
    column: "_293iXKbt8w",
    dense: "_293iXKrVq7",
    'row dense': "_293iXKb2Fs",
    'column dense': "_293iXKs8QB"
}; /**
    * __Grid__
    *
    * `Grid` is a primitive component that implements the CSS Grid API.
    *
    * - [Examples](https://atlassian.design/components/primitives/grid/examples)
    * - [Code](https://atlassian.design/components/primitives/grid/code)
    *
    * @example
    * ```tsx
    * import { Box } from '@atlaskit/primitives/compiled'
    * import { Grid } from '@atlaskit/primitives/compiled/grid'
    *
    * const Component = () => (
    *   <Grid gap="space.100" gridColumns="1fr 1fr">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Grid>
    * )
    * ```
    */ 
const $9017cc252c645528$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(18);
    const { as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss } = t0;
    const Component = as || "div";
    const t1 = gap && $9017cc252c645528$var$columnGapMap[gap];
    const t2 = columnGap && $9017cc252c645528$var$columnGapMap[columnGap];
    const t3 = gap && $9017cc252c645528$var$rowGapMap[gap];
    const t4 = rowGap && $9017cc252c645528$var$rowGapMap[rowGap];
    const t5 = alignItems && $9017cc252c645528$var$alignItemsMap[alignItems];
    const t6 = alignContent && $9017cc252c645528$var$alignContentMap[alignContent];
    const t7 = justifyContent && $9017cc252c645528$var$justifyContentMap[justifyContent];
    const t8 = autoFlow && $9017cc252c645528$var$gridAutoFlowMap[autoFlow];
    let t9;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8 || $[8] !== xcss) {
        t9 = (0, $hekY6.default)([
            $9017cc252c645528$var$baseStyles.root,
            t1,
            t2,
            t3,
            t4,
            t5,
            t6,
            t7,
            t8,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = xcss;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== Component || $[11] !== children || $[12] !== id || $[13] !== ref || $[14] !== role || $[15] !== t9 || $[16] !== testId) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            id: id,
            role: role,
            className: t9,
            "data-testid": testId,
            ref: ref,
            children: children
        });
        $[10] = Component;
        $[11] = children;
        $[12] = id;
        $[13] = ref;
        $[14] = role;
        $[15] = t9;
        $[16] = testId;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hekY6.default)([
            $9017cc252c645528$var$baseStyles.root,
            gap && $9017cc252c645528$var$columnGapMap[gap],
            columnGap && $9017cc252c645528$var$columnGapMap[columnGap],
            gap && $9017cc252c645528$var$rowGapMap[gap],
            rowGap && $9017cc252c645528$var$rowGapMap[rowGap],
            alignItems && $9017cc252c645528$var$alignItemsMap[alignItems],
            alignContent && $9017cc252c645528$var$alignContentMap[alignContent],
            justifyContent && $9017cc252c645528$var$justifyContentMap[justifyContent],
            autoFlow && $9017cc252c645528$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$9017cc252c645528$export$ef2184bd89960b14.displayName = 'Grid';
module.exports["Grid"] = $9017cc252c645528$export$ef2184bd89960b14;

});

parcelRegister("kA6Zo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $3LWAs = parcelRequire("3LWAs");

function $ab88efc0a071a161$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab88efc0a071a161$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $ab88efc0a071a161$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $ab88efc0a071a161$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $ab88efc0a071a161$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $ab88efc0a071a161$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $ab88efc0a071a161$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $ab88efc0a071a161$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $3LWAs.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $3LWAs.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $3LWAs.spaceStylesMap).rowGap[rowGap],
            alignItems && $ab88efc0a071a161$var$alignItemsMap[alignItems],
            direction && $ab88efc0a071a161$var$flexDirectionMap[direction],
            justifyContent && $ab88efc0a071a161$var$justifyContentMap[justifyContent],
            wrap && $ab88efc0a071a161$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$ab88efc0a071a161$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ab88efc0a071a161$export$2e2bcd8739ae039 = $ab88efc0a071a161$export$f51f4c4ede09e011;
module.exports["Flex"] = $ab88efc0a071a161$export$f51f4c4ede09e011;
module.exports["default"] = $ab88efc0a071a161$export$2e2bcd8739ae039;

});

parcelRegister("3LWAs", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $ewTr4 = parcelRequire("ewTr4");


var $hpqhf = parcelRequire("hpqhf");

const $1b793d6279a09bb8$export$bf46c3f9eeafc71f = (0, $ewTr4.createSpacingStylesMap)((0, $hpqhf.positiveSpaceMap));
module.exports["spaceStylesMap"] = $1b793d6279a09bb8$export$bf46c3f9eeafc71f;

});

parcelRegister("7BfeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $15v69 = parcelRequire("15v69");


var $6NZvG = parcelRequire("6NZvG");

const $88d9f9d62ce14398$export$915e9e7bd4f0f96d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
module.exports["ErrorMessage"] = $88d9f9d62ce14398$export$915e9e7bd4f0f96d;

});

parcelRegister("dTHYM", function(module, exports) {
/* form.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $lkYE1 = parcelRequire("lkYE1");


var $19ZlF = parcelRequire("19ZlF");


var $lSFbL = parcelRequire("lSFbL");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $4Ltes = parcelRequire("4Ltes");


var $lavrI = parcelRequire("lavrI");




const $0374e1e5f4a1f6d8$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $lkYE1.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};


const $b5be3bd8b033eeb0$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $cozmU.useRef)(null);
    const onSubmitRef = (0, $cozmU.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $cozmU.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lkYE1.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name_0, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name_0 && typeof defaultValue === 'function' ? defaultValue(initialValues[name_0]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(initialValues, name_0, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(values, name_0, value);
                    }
                }
            }
        });
        (0, $19ZlF.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $0374e1e5f4a1f6d8$export$fc06342dc8588d3b))(finalForm);
        return finalForm;
    });
    const [state_0, setState] = (0, $cozmU.useState)({
        dirty: false,
        submitting: false
    });
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $cozmU.useCallback)((name_1, defaultValue_0, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe_0 = form.registerField(name_1, subscriber, subscription, config);
        form.mutators.setDefaultValue(name_1, defaultValue_0);
        form.resumeValidation();
        return unsubscribe_0;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues_0)=>{
        form.reset(initialValues_0);
    };
    const handleKeyDown = (e_0)=>{
        if (e_0.key === 'Enter' && (e_0.ctrlKey || e_0.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e_0.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty_0, submitting: submitting_0 } = state_0; /**
                * This method is needed in FormContext to use it on the field level
                * to check the current value of the field in case of the component re-mounting.
                */ 
    const getCurrentValue = (0, $cozmU.useCallback)((name_2)=>{
        const formState = form.getState();
        return formState?.values[name_2] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $cozmU.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    }; // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $lmzCg.default)([
            ref,
            formRef
        ]) : formRef
    }; // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty_0,
                reset: handleReset,
                submitting: submitting_0,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ...formProps,
            ...userProvidedFormProps
        }, children);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Ltes.FormContext).Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lavrI.IsDisabledContext).Provider, {
        value: isDisabled
    }, childrenContent));
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $b5be3bd8b033eeb0$var$Form = (0, $4Qc44.default)($b5be3bd8b033eeb0$var$FormBase); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $b5be3bd8b033eeb0$export$2e2bcd8739ae039 = $b5be3bd8b033eeb0$var$Form;
module.exports["default"] = $b5be3bd8b033eeb0$export$2e2bcd8739ae039;

});

parcelRegister("dUI0h", function(module, exports) {
$parcel$export(module.exports, "default", () => $153d26f5a8394ccf$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $7BfeF = parcelRequire("7BfeF");


var $15v69 = parcelRequire("15v69");


var $4Ltes = parcelRequire("4Ltes");


var $9DzWa = parcelRequire("9DzWa");


var $lavrI = parcelRequire("lavrI");


var $kB5K2 = parcelRequire("kB5K2");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $5ZC7N = parcelRequire("5ZC7N");

const $153d26f5a8394ccf$var$fieldWrapperStyles = null;
function $153d26f5a8394ccf$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $153d26f5a8394ccf$var$isFunction(x) {
    return typeof x === 'function';
}
const $153d26f5a8394ccf$var$usePreviousRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePreviousRef(current) {
    const $ = (0, $bDgLe.c)(2);
    const ref = (0, $cozmU.useRef)(current);
    let t0;
    if ($[0] !== current) {
        t0 = ()=>{
            ref.current = current;
        };
        $[0] = current;
        $[1] = t0;
    } else t0 = $[1];
    (0, $cozmU.useEffect)(t0);
    return ref;
} : function usePreviousRef(current) {
    const ref = (0, $cozmU.useRef)(current); // will be updated on the next render
    (0, $cozmU.useEffect)(()=>{
        ref.current = current;
    }); // return the existing current (pre render)
    return ref;
};
function $153d26f5a8394ccf$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
     // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $153d26f5a8394ccf$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $cozmU.useContext)((0, $4Ltes.FormContext));
    const isDisabled = (0, $cozmU.useContext)((0, $lavrI.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $153d26f5a8394ccf$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $153d26f5a8394ccf$var$usePreviousRef(props); /**
                                                 * HACK: defaultValue can potentially be an array or object which cannot be
                                                 * passed directly into a `useEffect` dependency array, since it will trigger
                                                 * the hook every time.
                                                 */ 
    const isDefaultValueChanged = !$153d26f5a8394ccf$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $cozmU.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $153d26f5a8394ccf$var$usePreviousRef(state);
    (0, $cozmU.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $153d26f5a8394ccf$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit; /**
                                                                                                                                                        * Do not update submitFailed until submission has finished.
                                                                                                                                                        */ 
            const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed; /**
                                                                                                                                * Do not use submitError if the value has changed.
                                                                                                                                */ 
            const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error; /**
                                                                                                                  * If there has been a submit error, then use logic in modifiedError to determine validity,
                                                                                                                  * so we can determine when there is a submit error which we do not want to display
                                                                                                                  * because the value has been changed.
                                                                                                                  */ 
            const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($153d26f5a8394ccf$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value_0, formState, fieldState_0) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState_0) return supplied(value_0, formState, fieldStateToMeta(fieldState_0));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $6JrSr.useId)();
    const fieldId = (0, $cozmU.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value_1 = '';
        if (state.error) value_1 += `${fieldId}-error `;
        if (state.valid) value_1 += `${fieldId}-valid `;
        return `${value_1}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $hekY6.default)([
            "_43nrzT2ADO"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Provider, {
        value: fieldId
    }, component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});

parcelRegister("9DzWa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $15v69 = parcelRequire("15v69");


var $6NZvG = parcelRequire("6NZvG");

const $3a1fdbc90d11ce36$export$8fbe3c7d0ed2c683 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
module.exports["HelperMessage"] = $3a1fdbc90d11ce36$export$8fbe3c7d0ed2c683;

});

parcelRegister("kB5K2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $be5040a199625459$var$fieldsetLabelStyles = null;
const $be5040a199625459$export$b04be29aa201d4f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, htmlFor: htmlFor, id: id, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvbI6 _1UtDYzZpcK _1kk5Tkmb2E _0rIjyk1Y8M _43nrzTPgdg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== htmlFor || $[3] !== id || $[4] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement("label", {
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = htmlFor;
        $[3] = id;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ $cozmU.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvbI6 _1UtDYzZpcK _1kk5Tkmb2E _0rIjyk1Y8M _43nrzTPgdg"
        ])
    }, children);
module.exports["Label"] = $be5040a199625459$export$b04be29aa201d4f5;

});

parcelRegister("dQLwo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hHWoV = parcelRequire("hHWoV");

const $7ed009fd92bb7c02$export$ec445f12f63100a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            isWrapper: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const contextValue = t1;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHWoV.MessageWrapperContext).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHWoV.MessageWrapperContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};
module.exports["MessageWrapper"] = $7ed009fd92bb7c02$export$ec445f12f63100a5;

});

parcelRegister("hpa99", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0616ad56943e5380$var$requiredIndicatorStyles = null;
const $0616ad56943e5380$export$a4bb55a1e3b8a49f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredAsterisk() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": "true",
            title: "required",
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0WKd3G4z3T _0LQT5EFQfX"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredAsterisk() {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0WKd3G4z3T _0LQT5EFQfX"
        ])
    }, "*");
};
module.exports["RequiredAsterisk"] = $0616ad56943e5380$export$a4bb55a1e3b8a49f;

});

parcelRegister("5ZC7N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $15v69 = parcelRequire("15v69");


var $6NZvG = parcelRequire("6NZvG");

const $e1e1c1c8a4336b7a$export$5505afb209a532c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $15v69.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NZvG.default), {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
module.exports["ValidMessage"] = $e1e1c1c8a4336b7a$export$5505afb209a532c8;

});

parcelRegister("j7cLK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ab3990913fb4291e$var$formFooterWrapperStyles = null;
const $ab3990913fb4291e$var$justifyContentStyles = null; /**
                                    * __Form footer__
                                    *
                                    * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
                                    *
                                    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    */ 
const $ab3990913fb4291e$export$e7277fd05612133d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FormFooter(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { align: t1, children: children } = t0;
    const align = t1 === undefined ? "end" : t1;
    const t2 = align === "start" && "_37wbyuchRC";
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuz9WS _43nrzTNHnM",
            t2
        ]);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("footer", {
            className: t3
        }, children);
        $[2] = children;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function FormFooter({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ $cozmU.createElement("footer", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuz9WS _43nrzTNHnM",
            align === 'start' && "_37wbyuchRC"
        ])
    }, children);
};
module.exports["FormFooter"] = $ab3990913fb4291e$export$e7277fd05612133d;

});

parcelRegister("2Nu0e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hCkzC = parcelRequire("hCkzC");

const $9f5b8032a14b8fa1$var$fieldSetStyles = null; /**
                              * __Fieldset__
                              *
                              * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
                              * a fieldset can be used to group them together. This makes the form more accessible.
                              *
                              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              */ 
const $9f5b8032a14b8fa1$export$e154be390aa0e14 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, legend: legend } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_43nrzT2ADO"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== legend) {
        t2 = legend && /*#__PURE__*/ $cozmU.createElement((0, $hCkzC.Legend), null, legend);
        $[1] = legend;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("fieldset", {
            className: t1
        }, t2, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ $cozmU.createElement("fieldset", {
        className: (0, $hekY6.default)([
            "_43nrzT2ADO"
        ])
    }, legend && /*#__PURE__*/ $cozmU.createElement((0, $hCkzC.Legend), null, legend), children);
};
module.exports["Fieldset"] = $9f5b8032a14b8fa1$export$e154be390aa0e14;

});

parcelRegister("hCkzC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $2f5fe732f41be4ec$var$fieldsetLabelStyles = null;
const $2f5fe732f41be4ec$export$ed247974535929c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvbI6 _1UtDYzZpcK _1kk5Tkmb2E _0rIjyk1Y8M _43nrzTPgdg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("legend", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ $cozmU.createElement("legend", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvbI6 _1UtDYzZpcK _1kk5Tkmb2E _0rIjyk1Y8M _43nrzTPgdg"
        ])
    }, children);
};
module.exports["Legend"] = $2f5fe732f41be4ec$export$ed247974535929c7;

});

parcelRegister("j1kxT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4Ltes = parcelRequire("4Ltes");

// Constantized to avoid a new object reference built every call
const $37b58cb3fc968538$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $37b58cb3fc968538$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $37b58cb3fc968538$export$606f11b2eb45ecc6 = (subscriptionConfig = $37b58cb3fc968538$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $cozmU.useContext)((0, $4Ltes.FormContext));
    const [state, setState] = (0, $cozmU.useState)();
    /**
   * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
   * We avoid computing the hash if the subscription config has referential equality altogether.
   */ const subscriptionConfigHash = (0, $cozmU.useMemo)(()=>$37b58cb3fc968538$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
   * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
   * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
   * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
   */ const config = (0, $cozmU.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};
module.exports["useFormState"] = $37b58cb3fc968538$export$606f11b2eb45ecc6;

});

parcelRegister("eKMV3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $j1lPy = parcelRequire("j1lPy");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $n1i5T = parcelRequire("n1i5T");


var $aDGhF = parcelRequire("aDGhF");

const $98d5eb992c088187$var$styles = {
    base: "_0bjKvDzXzM _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    baseT26Shape: "_0bjKvDKTcp",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    fullWidth: "_39xV02N91d"
};
const $98d5eb992c088187$var$defaultStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $98d5eb992c088187$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $98d5eb992c088187$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $98d5eb992c088187$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $98d5eb992c088187$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $98d5eb992c088187$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $98d5eb992c088187$var$subtleStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $98d5eb992c088187$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
}; /**
    * __Link Button__
    *
    * Renders a link in the style of a button.
    *
    * - [Examples](https://atlassian.design/components/link-button/examples)
    * - [Code](https://atlassian.design/components/link-button/code)
    * - [Usage](https://atlassian.design/components/link-button/usage)
    */ 
const $98d5eb992c088187$var$LinkButtonBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(70);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let href;
    let iconAfter;
    let iconBefore;
    let interactionName;
    let isDisabled;
    let isSelected;
    let onClick;
    let onClickCapture;
    let onKeyDownCapture;
    let onKeyUpCapture;
    let onMouseDownCapture;
    let onMouseUpCapture;
    let onPointerDownCapture;
    let onPointerUpCapture;
    let onTouchEndCapture;
    let onTouchStartCapture;
    let shouldFitContainer;
    let spacing;
    let t1;
    let t2;
    let testId;
    let unsafeRest;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, appearance: t1, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoFocus: t2, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = children;
        $[5] = href;
        $[6] = iconAfter;
        $[7] = iconBefore;
        $[8] = interactionName;
        $[9] = isDisabled;
        $[10] = isSelected;
        $[11] = onClick;
        $[12] = onClickCapture;
        $[13] = onKeyDownCapture;
        $[14] = onKeyUpCapture;
        $[15] = onMouseDownCapture;
        $[16] = onMouseUpCapture;
        $[17] = onPointerDownCapture;
        $[18] = onPointerUpCapture;
        $[19] = onTouchEndCapture;
        $[20] = onTouchStartCapture;
        $[21] = shouldFitContainer;
        $[22] = spacing;
        $[23] = t1;
        $[24] = t2;
        $[25] = testId;
        $[26] = unsafeRest;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        children = $[4];
        href = $[5];
        iconAfter = $[6];
        iconBefore = $[7];
        interactionName = $[8];
        isDisabled = $[9];
        isSelected = $[10];
        onClick = $[11];
        onClickCapture = $[12];
        onKeyDownCapture = $[13];
        onKeyUpCapture = $[14];
        onMouseDownCapture = $[15];
        onMouseUpCapture = $[16];
        onPointerDownCapture = $[17];
        onPointerUpCapture = $[18];
        onTouchEndCapture = $[19];
        onTouchStartCapture = $[20];
        shouldFitContainer = $[21];
        spacing = $[22];
        t1 = $[23];
        t2 = $[24];
        testId = $[25];
        unsafeRest = $[26];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const autoFocus = t2 === undefined ? false : t2;
    let saferRest;
    if ($[27] !== unsafeRest) {
        const { className: _className, css: _css, as: _as, style: _style, ...t3 } = unsafeRest;
        saferRest = t3;
        $[27] = unsafeRest;
        $[28] = saferRest;
    } else saferRest = $[28];
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $cozmU.useRef)(null);
    (0, $j1lPy.default)(localRef, autoFocus);
    let t3;
    if ($[29] !== ref) {
        t3 = (0, $lmzCg.default)([
            localRef,
            ref
        ]);
        $[29] = ref;
        $[30] = t3;
    } else t3 = $[30];
    const combinedRef = t3;
    const t4 = isDisabled ? undefined : href;
    const t5 = isDisabled ? "link" : undefined;
    const t6 = isDisabled === true ? true : undefined;
    let t7;
    if ($[31] !== appearance || $[32] !== hasIconAfter || $[33] !== hasIconBefore || $[34] !== isDisabled || $[35] !== isSelected || $[36] !== shouldFitContainer || $[37] !== spacing) {
        t7 = (0, $w6R6I.cx)($98d5eb992c088187$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $98d5eb992c088187$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && $98d5eb992c088187$var$styles.interactiveMotion, appearance === "default" && $98d5eb992c088187$var$defaultStyles.root, appearance === "primary" && $98d5eb992c088187$var$primaryStyles.root, appearance === "rovo" && $98d5eb992c088187$var$rovoStyles.root, appearance === "warning" && $98d5eb992c088187$var$warningStyles.root, appearance === "danger" && $98d5eb992c088187$var$dangerStyles.root, appearance === "discovery" && $98d5eb992c088187$var$discoveryStyles.root, appearance === "subtle" && $98d5eb992c088187$var$subtleStyles.root, $98d5eb992c088187$var$styles.linkDecorationUnset, isSelected && $98d5eb992c088187$var$selectedStyles.root, isSelected && appearance === "danger" && $98d5eb992c088187$var$selectedStyles.danger, isSelected && appearance === "warning" && $98d5eb992c088187$var$selectedStyles.warning, isSelected && appearance === "discovery" && $98d5eb992c088187$var$selectedStyles.discovery, isDisabled && $98d5eb992c088187$var$styles.disabled, spacing === "compact" && $98d5eb992c088187$var$styles.spacingCompact, hasIconBefore && $98d5eb992c088187$var$styles.buttonIconBefore, hasIconAfter && $98d5eb992c088187$var$styles.buttonIconAfter, shouldFitContainer && $98d5eb992c088187$var$styles.fullWidth);
        $[31] = appearance;
        $[32] = hasIconAfter;
        $[33] = hasIconBefore;
        $[34] = isDisabled;
        $[35] = isSelected;
        $[36] = shouldFitContainer;
        $[37] = spacing;
        $[38] = t7;
    } else t7 = $[38];
    let t8;
    if ($[39] !== iconBefore) {
        t8 = iconBefore && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            type: "icon",
            position: "before",
            isLoading: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
            icon: iconBefore
        }));
        $[39] = iconBefore;
        $[40] = t8;
    } else t8 = $[40];
    let t9;
    if ($[41] !== children) {
        t9 = children && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            isLoading: false
        }, children);
        $[41] = children;
        $[42] = t9;
    } else t9 = $[42];
    let t10;
    if ($[43] !== iconAfter) {
        t10 = iconAfter && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            type: "icon",
            position: "after",
            isLoading: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
            icon: iconAfter
        }));
        $[43] = iconAfter;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== analyticsContext || $[46] !== ariaLabel || $[47] !== ariaLabelledBy || $[48] !== combinedRef || $[49] !== interactionName || $[50] !== onClick || $[51] !== onClickCapture || $[52] !== onKeyDownCapture || $[53] !== onKeyUpCapture || $[54] !== onMouseDownCapture || $[55] !== onMouseUpCapture || $[56] !== onPointerDownCapture || $[57] !== onPointerUpCapture || $[58] !== onTouchEndCapture || $[59] !== onTouchStartCapture || $[60] !== saferRest || $[61] !== t10 || $[62] !== t4 || $[63] !== t5 || $[64] !== t6 || $[65] !== t7 || $[66] !== t8 || $[67] !== t9 || $[68] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            analyticsContext: analyticsContext,
            ref: combinedRef,
            href: t4,
            role: t5,
            "aria-disabled": t6,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            testId: testId,
            componentName: "LinkButton",
            interactionName: interactionName,
            ...saferRest,
            xcss: t7
        }, t8, t9, t10);
        $[45] = analyticsContext;
        $[46] = ariaLabel;
        $[47] = ariaLabelledBy;
        $[48] = combinedRef;
        $[49] = interactionName;
        $[50] = onClick;
        $[51] = onClickCapture;
        $[52] = onKeyDownCapture;
        $[53] = onKeyUpCapture;
        $[54] = onMouseDownCapture;
        $[55] = onMouseUpCapture;
        $[56] = onPointerDownCapture;
        $[57] = onPointerUpCapture;
        $[58] = onTouchEndCapture;
        $[59] = onTouchStartCapture;
        $[60] = saferRest;
        $[61] = t10;
        $[62] = t4;
        $[63] = t5;
        $[64] = t6;
        $[65] = t7;
        $[66] = t8;
        $[67] = t9;
        $[68] = testId;
        $[69] = t11;
    } else t11 = $[69];
    return t11;
} : ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $cozmU.useRef)(null);
    (0, $j1lPy.default)(localRef, autoFocus);
    const combinedRef = (0, $lmzCg.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $w6R6I.cx)($98d5eb992c088187$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $98d5eb992c088187$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $98d5eb992c088187$var$styles.interactiveMotion, appearance === 'default' && $98d5eb992c088187$var$defaultStyles.root, appearance === 'primary' && $98d5eb992c088187$var$primaryStyles.root, appearance === 'rovo' && $98d5eb992c088187$var$rovoStyles.root, appearance === 'warning' && $98d5eb992c088187$var$warningStyles.root, appearance === 'danger' && $98d5eb992c088187$var$dangerStyles.root, appearance === 'discovery' && $98d5eb992c088187$var$discoveryStyles.root, appearance === 'subtle' && $98d5eb992c088187$var$subtleStyles.root, $98d5eb992c088187$var$styles.linkDecorationUnset, isSelected && $98d5eb992c088187$var$selectedStyles.root, isSelected && appearance === 'danger' && $98d5eb992c088187$var$selectedStyles.danger, isSelected && appearance === 'warning' && $98d5eb992c088187$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $98d5eb992c088187$var$selectedStyles.discovery, isDisabled && $98d5eb992c088187$var$styles.disabled, spacing === 'compact' && $98d5eb992c088187$var$styles.spacingCompact, hasIconBefore && $98d5eb992c088187$var$styles.buttonIconBefore, hasIconAfter && $98d5eb992c088187$var$styles.buttonIconAfter, shouldFitContainer && $98d5eb992c088187$var$styles.fullWidth)
    }, iconBefore && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
        icon: iconAfter
    })));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $98d5eb992c088187$var$LinkButton = /*#__PURE__*/ (0, $cozmU.forwardRef)($98d5eb992c088187$var$LinkButtonBase);
$98d5eb992c088187$var$LinkButton.displayName = 'LinkButton';
var $98d5eb992c088187$export$2e2bcd8739ae039 = $98d5eb992c088187$var$LinkButton;
module.exports["default"] = $98d5eb992c088187$export$2e2bcd8739ae039;

});

parcelRegister("7joZr", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4d733aeb91e726$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $af4d733aeb91e726$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af4d733aeb91e726$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $af4d733aeb91e726$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $af4d733aeb91e726$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("7WEaj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $j1lPy = parcelRequire("j1lPy");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $n1i5T = parcelRequire("n1i5T");


var $aDGhF = parcelRequire("aDGhF");

const $ca2ca66f912ad2d1$var$styles = {
    base: "_0bjKvDzXzM _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    baseT26Shape: "_0bjKvDKTcp",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYxTF4 _3xtjKNOiJt _0H9qDFp3yX _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV _0jFU0V9DVM _39xV029DVM",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    circle: "_0bjKvDS5Zs"
};
const $ca2ca66f912ad2d1$var$defaultStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $ca2ca66f912ad2d1$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $ca2ca66f912ad2d1$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $ca2ca66f912ad2d1$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $ca2ca66f912ad2d1$var$subtleStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $ca2ca66f912ad2d1$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const $ca2ca66f912ad2d1$var$LinkIconButtonBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(36);
    const { "aria-label": preventedAriaLabel, "aria-labelledby": ariaLabelledBy, analyticsContext: analyticsContext, appearance: t1, autoFocus: t2, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: t3, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const autoFocus = t2 === undefined ? false : t2;
    const isTooltipDisabled = t3 === undefined ? true : t3;
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $cozmU.useRef)(null);
    (0, $j1lPy.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...saferRest,
            "aria-labelledby": ariaLabelledBy,
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                saferRest.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                saferRest.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                saferRest.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                saferRest.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                saferRest.onBlur?.(e_4);
            },
            onClick: (event, analyticsEvent)=>{
                onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (0, $lmzCg.default)([
                localRef,
                ref,
                triggerProps.ref
            ].filter(Boolean)),
            xcss: (0, $w6R6I.cx)($ca2ca66f912ad2d1$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $ca2ca66f912ad2d1$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && $ca2ca66f912ad2d1$var$styles.interactiveMotion, appearance === "default" && $ca2ca66f912ad2d1$var$defaultStyles.root, appearance === "primary" && $ca2ca66f912ad2d1$var$primaryStyles.root, appearance === "rovo" && $ca2ca66f912ad2d1$var$rovoStyles.root, appearance === "discovery" && $ca2ca66f912ad2d1$var$discoveryStyles.root, appearance === "subtle" && $ca2ca66f912ad2d1$var$subtleStyles.root, $ca2ca66f912ad2d1$var$styles.linkDecorationUnset, isSelected && $ca2ca66f912ad2d1$var$selectedStyles.root, isSelected && appearance === "discovery" && $ca2ca66f912ad2d1$var$selectedStyles.discovery, isDisabled && $ca2ca66f912ad2d1$var$styles.disabled, $ca2ca66f912ad2d1$var$styles.iconButton, spacing === "compact" && $ca2ca66f912ad2d1$var$styles.spacingCompact, shape === "circle" && $ca2ca66f912ad2d1$var$styles.circle),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            href: isDisabled ? undefined : href,
            role: isDisabled ? "link" : undefined,
            "aria-disabled": isDisabled === true ? true : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            type: "icon",
            isLoading: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
            icon: icon
        }), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, label))));
    const T0 = (0, $7vK9E.Anchor);
    const t4 = (0, $lmzCg.default)([
        localRef,
        ref
    ]);
    let t5;
    if ($[0] !== appearance || $[1] !== isDisabled || $[2] !== isSelected || $[3] !== shape || $[4] !== spacing) {
        t5 = (0, $w6R6I.cx)($ca2ca66f912ad2d1$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $ca2ca66f912ad2d1$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && $ca2ca66f912ad2d1$var$styles.interactiveMotion, appearance === "default" && $ca2ca66f912ad2d1$var$defaultStyles.root, appearance === "primary" && $ca2ca66f912ad2d1$var$primaryStyles.root, appearance === "rovo" && $ca2ca66f912ad2d1$var$rovoStyles.root, appearance === "discovery" && $ca2ca66f912ad2d1$var$discoveryStyles.root, appearance === "subtle" && $ca2ca66f912ad2d1$var$subtleStyles.root, $ca2ca66f912ad2d1$var$styles.linkDecorationUnset, isSelected && $ca2ca66f912ad2d1$var$selectedStyles.root, isSelected && appearance === "discovery" && $ca2ca66f912ad2d1$var$selectedStyles.discovery, isDisabled && $ca2ca66f912ad2d1$var$styles.disabled, $ca2ca66f912ad2d1$var$styles.iconButton, spacing === "compact" && $ca2ca66f912ad2d1$var$styles.spacingCompact, shape === "circle" && $ca2ca66f912ad2d1$var$styles.circle);
        $[0] = appearance;
        $[1] = isDisabled;
        $[2] = isSelected;
        $[3] = shape;
        $[4] = spacing;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isDisabled ? undefined : href;
    const t7 = isDisabled ? "link" : undefined;
    const t8 = isDisabled === true ? true : undefined;
    let t9;
    if ($[6] !== icon) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
            icon: icon
        });
        $[6] = icon;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== label) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, label);
        $[8] = label;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10 || $[11] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            type: "icon",
            isLoading: false
        }, t9, t10);
        $[10] = t10;
        $[11] = t9;
        $[12] = t11;
    } else t11 = $[12];
    let t12;
    if ($[13] !== T0 || $[14] !== analyticsContext || $[15] !== ariaLabelledBy || $[16] !== interactionName || $[17] !== onClick || $[18] !== onClickCapture || $[19] !== onKeyDownCapture || $[20] !== onKeyUpCapture || $[21] !== onMouseDownCapture || $[22] !== onMouseUpCapture || $[23] !== onPointerDownCapture || $[24] !== onPointerUpCapture || $[25] !== onTouchEndCapture || $[26] !== onTouchStartCapture || $[27] !== saferRest || $[28] !== t11 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...saferRest,
            "aria-labelledby": ariaLabelledBy,
            ref: t4,
            xcss: t5,
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            testId: testId,
            href: t6,
            role: t7,
            "aria-disabled": t8,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName
        }, t11);
        $[13] = T0;
        $[14] = analyticsContext;
        $[15] = ariaLabelledBy;
        $[16] = interactionName;
        $[17] = onClick;
        $[18] = onClickCapture;
        $[19] = onKeyDownCapture;
        $[20] = onKeyUpCapture;
        $[21] = onMouseDownCapture;
        $[22] = onMouseUpCapture;
        $[23] = onPointerDownCapture;
        $[24] = onPointerUpCapture;
        $[25] = onTouchEndCapture;
        $[26] = onTouchStartCapture;
        $[27] = saferRest;
        $[28] = t11;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = testId;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
} : ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $cozmU.useRef)(null);
    (0, $j1lPy.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...saferRest,
            "aria-labelledby": ariaLabelledBy,
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e_0)=>{
                triggerProps.onMouseOut?.(e_0);
                saferRest.onMouseOut?.(e_0);
            },
            onMouseMove: (e_1)=>{
                triggerProps.onMouseMove?.(e_1);
                saferRest.onMouseMove?.(e_1);
            },
            onMouseDown: (e_2)=>{
                triggerProps.onMouseDown?.(e_2);
                saferRest.onMouseDown?.(e_2);
            },
            onFocus: (e_3)=>{
                triggerProps.onFocus?.(e_3);
                saferRest.onFocus?.(e_3);
            },
            onBlur: (e_4)=>{
                triggerProps.onBlur?.(e_4);
                saferRest.onBlur?.(e_4);
            },
            onClick: (event, analyticsEvent)=>{
                onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (0, $lmzCg.default)([
                localRef,
                ref,
                triggerProps.ref
            ].filter(Boolean)),
            xcss: (0, $w6R6I.cx)($ca2ca66f912ad2d1$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $ca2ca66f912ad2d1$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $ca2ca66f912ad2d1$var$styles.interactiveMotion, appearance === 'default' && $ca2ca66f912ad2d1$var$defaultStyles.root, appearance === 'primary' && $ca2ca66f912ad2d1$var$primaryStyles.root, appearance === 'rovo' && $ca2ca66f912ad2d1$var$rovoStyles.root, appearance === 'discovery' && $ca2ca66f912ad2d1$var$discoveryStyles.root, appearance === 'subtle' && $ca2ca66f912ad2d1$var$subtleStyles.root, $ca2ca66f912ad2d1$var$styles.linkDecorationUnset, isSelected && $ca2ca66f912ad2d1$var$selectedStyles.root, isSelected && appearance === 'discovery' && $ca2ca66f912ad2d1$var$selectedStyles.discovery, isDisabled && $ca2ca66f912ad2d1$var$styles.disabled, $ca2ca66f912ad2d1$var$styles.iconButton, spacing === 'compact' && $ca2ca66f912ad2d1$var$styles.spacingCompact, shape === 'circle' && $ca2ca66f912ad2d1$var$styles.circle),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: isDisabled ? undefined : href,
            role: isDisabled ? 'link' : undefined,
            "aria-disabled": isDisabled === true ? true : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
            type: "icon",
            isLoading: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
            icon: icon
        }), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, label))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...saferRest,
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $lmzCg.default)([
            localRef,
            ref
        ]),
        xcss: (0, $w6R6I.cx)($ca2ca66f912ad2d1$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $ca2ca66f912ad2d1$var$styles.baseT26Shape, !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $ca2ca66f912ad2d1$var$styles.interactiveMotion, appearance === 'default' && $ca2ca66f912ad2d1$var$defaultStyles.root, appearance === 'primary' && $ca2ca66f912ad2d1$var$primaryStyles.root, appearance === 'rovo' && $ca2ca66f912ad2d1$var$rovoStyles.root, appearance === 'discovery' && $ca2ca66f912ad2d1$var$discoveryStyles.root, appearance === 'subtle' && $ca2ca66f912ad2d1$var$subtleStyles.root, $ca2ca66f912ad2d1$var$styles.linkDecorationUnset, isSelected && $ca2ca66f912ad2d1$var$selectedStyles.root, isSelected && appearance === 'discovery' && $ca2ca66f912ad2d1$var$selectedStyles.discovery, isDisabled && $ca2ca66f912ad2d1$var$styles.disabled, $ca2ca66f912ad2d1$var$styles.iconButton, spacing === 'compact' && $ca2ca66f912ad2d1$var$styles.spacingCompact, shape === 'circle' && $ca2ca66f912ad2d1$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, /*#__PURE__*/ $cozmU.createElement((0, $n1i5T.default), {
        type: "icon",
        isLoading: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $aDGhF.default), {
        icon: icon
    }), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, label)));
}; // Workarounds to support generic types with forwardRef + memo
const $ca2ca66f912ad2d1$var$WithRef = /*#__PURE__*/ (0, $cozmU.forwardRef)($ca2ca66f912ad2d1$var$LinkIconButtonBase); /**
                                               * __Link Icon Button__
                                               *
                                               * Renders a link in the style of an icon button.
                                               *
                                               * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
                                               * - [Code](https://atlassian.design/components/button/link-icon-button/code)
                                               * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
                                               */ 
const $ca2ca66f912ad2d1$var$LinkIconButton = /*#__PURE__*/ (0, $cozmU.memo)($ca2ca66f912ad2d1$var$WithRef);
var $ca2ca66f912ad2d1$export$2e2bcd8739ae039 = $ca2ca66f912ad2d1$var$LinkIconButton;
module.exports["default"] = $ca2ca66f912ad2d1$export$2e2bcd8739ae039;

});

parcelRegister("l8Rhq", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $bB0i2 = parcelRequire("bB0i2");


var $7r5Hr = parcelRequire("7r5Hr");


var $ir4h8 = parcelRequire("ir4h8");


var $dpsRj = parcelRequire("dpsRj");


var $6JrSr = parcelRequire("6JrSr");


var $5EzLH = parcelRequire("5EzLH");


var $9GVkD = parcelRequire("9GVkD");


var $cl1W1 = parcelRequire("cl1W1");


var $15WAQ = parcelRequire("15WAQ");


var $gjS4Z = parcelRequire("gjS4Z");


var $b2E2m = parcelRequire("b2E2m");


var $1tDzb = parcelRequire("1tDzb");


var $hpqhf = parcelRequire("hpqhf");

function $3585cfce569df0c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $3585cfce569df0c2$var$focusRingStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $15WAQ.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hpqhf.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $gjS4Z.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $gjS4Z.borderWidthMap)['border.width']} solid`
        }
    }
});
const $3585cfce569df0c2$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $3585cfce569df0c2$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $3585cfce569df0c2$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $3585cfce569df0c2$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $3585cfce569df0c2$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $3585cfce569df0c2$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $dpsRj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $6JrSr.useId)();
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    const RouterLink = (0, $ir4h8.useRouterLink)();
    const isExternal = typeof href === 'string' && $3585cfce569df0c2$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $3585cfce569df0c2$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $bB0i2.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $3585cfce569df0c2$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $3585cfce569df0c2$var$baseStyles,
            $3585cfce569df0c2$var$positionStyles,
            $3585cfce569df0c2$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $cl1W1.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $b2E2m.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $b2E2m.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $b2E2m.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $b2E2m.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $b2E2m.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $b2E2m.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $b2E2m.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GVkD.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $3585cfce569df0c2$var$OPENS_NEW_WINDOW_LABEL}`));
};
const $3585cfce569df0c2$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $cozmU.forwardRef)($3585cfce569df0c2$var$AnchorNoRef);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3585cfce569df0c2$export$2e2bcd8739ae039 = $3585cfce569df0c2$export$b688253958b8dfe7;
module.exports["Anchor"] = $3585cfce569df0c2$export$b688253958b8dfe7;
module.exports["default"] = $3585cfce569df0c2$export$2e2bcd8739ae039;

});

parcelRegister("iV65j", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");













const $d504981d5a5d8181$var$dividerStyles = {
    baseDivider: "_39xV02NvrM _1mT5xdRAKS _42Yu6B7dHp",
    dividerDisabled: "_0KLXruhQC5 _0wOv4Qsyl5",
    dividerOffset: "_2YLqiKA17z"
};
const $d504981d5a5d8181$var$dividerAppearanceStyles = {
    default: "_0KLXru9r67",
    primary: "_0KLXruxCOs _1YKVNsjLrf",
    navigation: "_3SamIH2ADO _2YLqiKwmY0 _0jFU0Vey7F _0KLXruZpcK _1YKVNsCfZC"
};
const $d504981d5a5d8181$var$dividerHeightStyles = {
    default: "_0jFU0VZ49V",
    compact: "_0jFU0V9DVM"
};
const $d504981d5a5d8181$var$defaultDividerHeightStyles = {
    default: "_0jFU0Vbu0M",
    compact: "_0jFU0Vv8uz"
}; /**
    * __Divider__
    *
    * A divider component for the SplitButton component.
    *
    * - [Examples](https://atlassian.design/components/button/split-button/examples)
    * - [Code](https://atlassian.design/components/button/split-button/code)
    * - [Usage](https://atlassian.design/components/button/split-button/usage)
    */ 
const $d504981d5a5d8181$export$2e0a83ec2e27ecbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { appearance: appearance, spacing: spacing, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isDefaultDivider = appearance === "default" && !isDisabled;
    const t2 = isDefaultDivider && $d504981d5a5d8181$var$defaultDividerHeightStyles[spacing];
    const t3 = !isDefaultDivider && $d504981d5a5d8181$var$dividerHeightStyles[spacing];
    const t4 = isDisabled && $d504981d5a5d8181$var$dividerStyles.dividerDisabled;
    const t5 = !isDisabled && $d504981d5a5d8181$var$dividerAppearanceStyles[appearance];
    let t6;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
        t6 = (0, $hekY6.default)([
            $d504981d5a5d8181$var$dividerStyles.baseDivider,
            t2,
            t3,
            t4,
            t5,
            $d504981d5a5d8181$var$dividerStyles.dividerOffset
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t6
        });
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    return t7;
} : ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $d504981d5a5d8181$var$dividerStyles.baseDivider,
            isDefaultDivider && $d504981d5a5d8181$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $d504981d5a5d8181$var$dividerHeightStyles[spacing],
            isDisabled && $d504981d5a5d8181$var$dividerStyles.dividerDisabled,
            !isDisabled && $d504981d5a5d8181$var$dividerAppearanceStyles[appearance],
            $d504981d5a5d8181$var$dividerStyles.dividerOffset
        ])
    });
};















var $iDrrr = parcelRequire("iDrrr");

const $15848c118827b85a$var$buttonStyles = {
    splitButton: "_3iDTPbccYA _1mT5xdRAKS _0hPCNLDIqT _1ANEUSLRg7",
    defaultAppearanceContainer: "_0bjKvDzXzM _2xIroY9r67 _3e6OgrA17z _497WNw6wH8 _2zndICHZdu",
    defaultAppearanceContainerT26Shape: "_0bjKvDKTcp",
    defaultAppearanceDisabledContainer: "_2xIroYhQC5"
}; // TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
const $15848c118827b85a$export$994ba1b4c598f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { appearance: appearance, children: children, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const t2 = appearance === "default" && $15848c118827b85a$var$buttonStyles.defaultAppearanceContainer;
    let t3;
    if ($[0] !== appearance || $[1] !== isDisabled || $[2] !== t2) {
        t3 = (0, $hekY6.default)([
            t2,
            appearance === "default" && (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $15848c118827b85a$var$buttonStyles.defaultAppearanceContainerT26Shape,
            appearance === "default" && isDisabled && $15848c118827b85a$var$buttonStyles.defaultAppearanceDisabledContainer,
            $15848c118827b85a$var$buttonStyles.splitButton
        ]);
        $[0] = appearance;
        $[1] = isDisabled;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, children);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            appearance === 'default' && $15848c118827b85a$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $15848c118827b85a$var$buttonStyles.defaultAppearanceContainerT26Shape,
            appearance === 'default' && isDisabled && $15848c118827b85a$var$buttonStyles.defaultAppearanceDisabledContainer,
            $15848c118827b85a$var$buttonStyles.splitButton
        ])
    }, children);
};



var $lutEZ = parcelRequire("lutEZ");





var $1P2f3 = parcelRequire("1P2f3");

const $a82a1cb85703b8b8$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $cozmU.Children).toArray(children);
    typeof $1P2f3;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};


const $85e8ac4fdc0e0c65$var$buttonStyles = {
    primaryButton: "_1XLUiSdnbC _0HBrlCdnbC _02S8vQdnbC _0KGxlIdnbC",
    secondaryButton: "_3DzJURdnbC _04FWCddnbC _47z3oxdnbC _2fjHKCdnbC"
};
const $85e8ac4fdc0e0c65$export$651ad66661acd392 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { children: children, appearance: t1, spacing: t2, isDisabled: t3 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    const isDisabled = t3 === undefined ? false : t3;
    let t4;
    if ($[0] !== children) {
        t4 = (0, $a82a1cb85703b8b8$export$fe3955935f564b31)(children);
        $[0] = children;
        $[1] = t4;
    } else t4 = $[1];
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = t4;
    let t5;
    if ($[2] !== appearance || $[3] !== isDisabled || $[4] !== spacing) {
        t5 = {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        };
        $[2] = appearance;
        $[3] = isDisabled;
        $[4] = spacing;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $85e8ac4fdc0e0c65$var$buttonStyles.primaryButton
        ]);
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== PrimaryAction) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t6
        }, PrimaryAction);
        $[7] = PrimaryAction;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== appearance || $[10] !== isDisabled || $[11] !== spacing) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $d504981d5a5d8181$export$2e0a83ec2e27ecbb), {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        });
        $[9] = appearance;
        $[10] = isDisabled;
        $[11] = spacing;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            $85e8ac4fdc0e0c65$var$buttonStyles.secondaryButton
        ]);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== SecondaryAction) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t9
        }, SecondaryAction);
        $[14] = SecondaryAction;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t5 || $[18] !== t7 || $[19] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $lutEZ.SplitButtonContext).Provider, {
            value: t5
        }, t7, t8, t10);
        $[16] = t10;
        $[17] = t5;
        $[18] = t7;
        $[19] = t8;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== appearance || $[22] !== isDisabled || $[23] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $15848c118827b85a$export$994ba1b4c598f7), {
            appearance: appearance,
            isDisabled: isDisabled
        }, t11);
        $[21] = appearance;
        $[22] = isDisabled;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    return t12;
} : ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $a82a1cb85703b8b8$export$fe3955935f564b31)(children);
    return /*#__PURE__*/ $cozmU.createElement((0, $15848c118827b85a$export$994ba1b4c598f7), {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ $cozmU.createElement((0, $lutEZ.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $85e8ac4fdc0e0c65$var$buttonStyles.primaryButton
        ])
    }, PrimaryAction), /*#__PURE__*/ $cozmU.createElement((0, $d504981d5a5d8181$export$2e0a83ec2e27ecbb), {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $85e8ac4fdc0e0c65$var$buttonStyles.secondaryButton
        ])
    }, SecondaryAction)));
};
module.exports["SplitButton"] = $85e8ac4fdc0e0c65$export$651ad66661acd392;

});

parcelRegister("2wCqQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");

const $86535acb81ba89c8$var$flexGrowMap = {
    hug: (0, $buxP3.xcss)({
        flexGrow: 0
    }),
    fill: (0, $buxP3.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $86535acb81ba89c8$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $86535acb81ba89c8$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kA6Zo.Flex), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$86535acb81ba89c8$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$86535acb81ba89c8$export$2e2bcd8739ae039 = $86535acb81ba89c8$export$694e0d28c7ffc90c;
module.exports["Stack"] = $86535acb81ba89c8$export$694e0d28c7ffc90c;
module.exports["default"] = $86535acb81ba89c8$export$2e2bcd8739ae039;

});

parcelRegister("kz1Yj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");

const $0eb3e11c783f6bb0$var$flexGrowMap = {
    hug: (0, $buxP3.xcss)({
        flexGrow: 0
    }),
    fill: (0, $buxP3.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $0eb3e11c783f6bb0$var$separatorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $0eb3e11c783f6bb0$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $0eb3e11c783f6bb0$var$separatorStyles
    }, children);
const $0eb3e11c783f6bb0$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $lOiVq.jsx)($0eb3e11c783f6bb0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $cozmU.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $0eb3e11c783f6bb0$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kA6Zo.Flex), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0eb3e11c783f6bb0$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0eb3e11c783f6bb0$export$2e2bcd8739ae039 = $0eb3e11c783f6bb0$export$fbae5b5ffd8af05e;
module.exports["Inline"] = $0eb3e11c783f6bb0$export$fbae5b5ffd8af05e;
module.exports["default"] = $0eb3e11c783f6bb0$export$2e2bcd8739ae039;

});

parcelRegister("22YX5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $f7390a7a41c9d900$var$styles = {
    root: "_24h04i2Njc",
    'inline.space.025': "_2YLqiKLl21",
    'inline.space.050': "_2YLqiK5UaJ",
    'inline.space.100': "_2YLqiK4F84",
    'inline.space.150': "_2YLqiKB0rP",
    'inline.space.200': "_2YLqiKUgYP",
    'block.space.025': "_3SamIHLl21",
    'block.space.050': "_3SamIH5UaJ",
    'block.space.100': "_3SamIH4F84",
    'block.space.150': "_3SamIHB0rP",
    'block.space.200': "_3SamIHUgYP"
};
const $f7390a7a41c9d900$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss } = t0;
    const t1 = all && $f7390a7a41c9d900$var$styles[`inline.${all}`];
    const t2 = inline && $f7390a7a41c9d900$var$styles[`inline.${inline}`];
    const t3 = all && $f7390a7a41c9d900$var$styles[`block.${all}`];
    const t4 = block && $f7390a7a41c9d900$var$styles[`block.${block}`];
    let t5;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== xcss) {
        t5 = (0, $hekY6.default)([
            $f7390a7a41c9d900$var$styles.root,
            t1,
            t2,
            t3,
            t4,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = xcss;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== children || $[7] !== t5 || $[8] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t5,
            "data-testid": testId,
            children: children
        });
        $[6] = children;
        $[7] = t5;
        $[8] = testId;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $f7390a7a41c9d900$var$styles.root,
            all && $f7390a7a41c9d900$var$styles[`inline.${all}`],
            inline && $f7390a7a41c9d900$var$styles[`inline.${inline}`],
            all && $f7390a7a41c9d900$var$styles[`block.${all}`],
            block && $f7390a7a41c9d900$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$f7390a7a41c9d900$export$a8307195dd50fcbf.displayName = 'Bleed';
module.exports["Bleed"] = $f7390a7a41c9d900$export$a8307195dd50fcbf;

});

parcelRegister("hEsbD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $24dy7 = parcelRequire("24dy7");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $9GVkD = parcelRequire("9GVkD");


var $15v69 = parcelRequire("15v69");

const $a955199181160d06$var$messageContainerStyles = {
    root: "_2sNsIg7NXe _1UtDYzAyGJ _43nrzT1Y8M"
}; // Extracted styles for error icon wrapper, need to use css to override the default height
const $a955199181160d06$var$errorIconWrapperStyles = null; // Error icon with wrapper for character count violations
const $a955199181160d06$var$ErrorIconWithWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0Vey7F _0hPCNLDIqT"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "error",
            size: "small"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0Vey7F _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "error",
        size: "small"
    }));
// Helper to pluralise "character(s)"
const $a955199181160d06$var$pluralize = (count)=>`character${count !== 1 ? 's' : ''}`; /**
                                                                            * __Character Counter__
                                                                            *
                                                                            * A character counter component that displays remaining characters for text input.
                                                                            * Displays messages for over or under the maximum or minimum character limits.
                                                                            */ 
const $a955199181160d06$export$148a43ad58ca4d21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { maxCharacters: maxCharacters, minCharacters: minCharacters, currentValue: currentValue, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, shouldShowAsError: t1, inputId: inputId, testId: testId } = t0;
    const shouldShowAsError = t1 === undefined ? true : t1;
    const [announcementText, setAnnouncementText] = (0, $cozmU.useState)("");
    const debounceTimeoutRef = (0, $cozmU.useRef)(null);
    const contextFieldId = (0, $cozmU.useContext)((0, $15v69.FieldId));
    const resolvedFieldId = contextFieldId || inputId;
    const currentLength = currentValue?.length || 0;
    const isTooShort = minCharacters !== undefined && currentLength < minCharacters;
    const isTooLong = maxCharacters !== undefined && currentLength > maxCharacters;
    let t2;
    if ($[0] !== currentLength || $[1] !== isTooLong || $[2] !== isTooShort || $[3] !== maxCharacters || $[4] !== minCharacters || $[5] !== overMaximumMessage || $[6] !== underMaximumMessage || $[7] !== underMinimumMessage) {
        const getMessage = ()=>{
            if (isTooShort) {
                const needed = minCharacters - currentLength;
                return underMinimumMessage || `${needed} more ${$a955199181160d06$var$pluralize(needed)} needed`;
            }
            if (isTooLong) {
                const over = currentLength - maxCharacters;
                return overMaximumMessage || `${over} ${$a955199181160d06$var$pluralize(over)} too many`;
            }
            if (maxCharacters) {
                const remaining = maxCharacters - currentLength;
                return underMaximumMessage || `${remaining} ${$a955199181160d06$var$pluralize(remaining)} remaining`;
            }
            return null;
        };
        t2 = getMessage();
        $[0] = currentLength;
        $[1] = isTooLong;
        $[2] = isTooShort;
        $[3] = maxCharacters;
        $[4] = minCharacters;
        $[5] = overMaximumMessage;
        $[6] = underMaximumMessage;
        $[7] = underMinimumMessage;
        $[8] = t2;
    } else t2 = $[8];
    const displayText = t2;
    const displayAsError = (isTooShort || isTooLong) && shouldShowAsError;
    let t3;
    let t4;
    if ($[9] !== displayText) {
        t3 = ()=>{
            debounceTimeoutRef.current = setTimeout(()=>{
                setAnnouncementText(displayText || "");
            }, 1000);
            return ()=>{
                clearTimeout(debounceTimeoutRef.current);
            };
        };
        t4 = [
            displayText
        ];
        $[9] = displayText;
        $[10] = t3;
        $[11] = t4;
    } else {
        t3 = $[10];
        t4 = $[11];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!displayText) return null;
    let t5;
    if ($[12] !== displayAsError) {
        t5 = displayAsError && /*#__PURE__*/ $cozmU.createElement($a955199181160d06$var$ErrorIconWithWrapper, null);
        $[12] = displayAsError;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = displayAsError ? "color.text.danger" : "color.text.subtlest";
    const t7 = resolvedFieldId ? `${resolvedFieldId}-character-counter` : undefined;
    let t8;
    if ($[14] !== displayText || $[15] !== t6 || $[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: t6,
            size: "small",
            id: t7
        }, displayText);
        $[14] = displayText;
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t5 || $[19] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            gap: "space.075",
            xcss: $a955199181160d06$var$messageContainerStyles.root
        }, t5, t8);
        $[18] = t5;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== announcementText) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-live": "polite"
        }, announcementText));
        $[21] = announcementText;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t9 || $[25] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            testId: testId
        }, t9, t10);
        $[23] = t10;
        $[24] = t9;
        $[25] = testId;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ({ maxCharacters: maxCharacters, minCharacters: minCharacters, currentValue: currentValue, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, shouldShowAsError: shouldShowAsError = true, inputId: inputId, testId: testId })=>{
    const [announcementText, setAnnouncementText] = (0, $cozmU.useState)('');
    const debounceTimeoutRef = (0, $cozmU.useRef)(null); // Resolve the field ID from context (form use) or inputId prop (standalone use)
    const contextFieldId = (0, $cozmU.useContext)((0, $15v69.FieldId));
    const resolvedFieldId = contextFieldId || inputId;
    const currentLength = currentValue?.length || 0; // Check if character count violates limits
    const isTooShort = minCharacters !== undefined && currentLength < minCharacters;
    const isTooLong = maxCharacters !== undefined && currentLength > maxCharacters; // Determine what to display based on the current value, the maximum and minimum character limits, and any custom messages
    const getMessage = ()=>{
        // Below minimum so show custom message or default
        if (isTooShort) {
            const needed = minCharacters - currentLength;
            return underMinimumMessage || `${needed} more ${$a955199181160d06$var$pluralize(needed)} needed`;
        } // Over maximum so show custom message or default
        if (isTooLong) {
            const over = currentLength - maxCharacters;
            return overMaximumMessage || `${over} ${$a955199181160d06$var$pluralize(over)} too many`;
        } // Within limits - show remaining count (if max is defined)
        if (maxCharacters) {
            const remaining = maxCharacters - currentLength;
            return underMaximumMessage || `${remaining} ${$a955199181160d06$var$pluralize(remaining)} remaining`;
        } // No message to show (min only limit satisfied)
        return null;
    };
    const displayText = getMessage(); // Determine if the current character count violates limits
    const displayAsError = (isTooShort || isTooLong) && shouldShowAsError; // Debounce screen reader announcements so that it only reads the message when it input has settled
    (0, $cozmU.useEffect)(()=>{
        // Debounce by 1 second to avoid announcing every keystroke
        debounceTimeoutRef.current = setTimeout(()=>{
            setAnnouncementText(displayText || '');
        }, 1000); // Cleanup function clears the timeout when displayText changes or component unmounts
        return ()=>{
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [
        displayText
    ]); // Don't render if there's no message to display (min only limit satisfied)
    if (!displayText) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.075",
        xcss: $a955199181160d06$var$messageContainerStyles.root
    }, displayAsError && /*#__PURE__*/ $cozmU.createElement($a955199181160d06$var$ErrorIconWithWrapper, null), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: displayAsError ? 'color.text.danger' : 'color.text.subtlest',
        size: "small",
        id: resolvedFieldId ? `${resolvedFieldId}-character-counter` : undefined
    }, displayText)), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-live": "polite"
    }, announcementText)));
};
module.exports["CharacterCounter"] = $a955199181160d06$export$148a43ad58ca4d21;

});

parcelRegister("5WvJi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cgay9 = parcelRequire("cgay9");





var $fEPJS = parcelRequire("fEPJS");


const $02de961e571d494a$export$103e9686fdc354e8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgay9.default), {
            ...props,
            isFullScreen: true,
            width: "100%",
            height: "100%",
            shouldScrollInViewport: false,
            shouldCloseOnOverlayClick: false,
            isBlanketHidden: false,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgay9.default), {
        ...props,
        /**
   * Making this an internal-only prop and exposing it through a facade
   * component so that we can keep public types simple.
   *
   * Otherwise we need complex conditional types that are harder to
   * understand / maintain and aren't actually any better for consumers.
   */ isFullScreen: true,
        /**
   * Setting width and height to 100% because the `isFullScreen` prop just
   * removes the spacing around the modal. We still need to set the size to
   * be 100%.
   *
   * Intentionally reusing the existing internals as much as possible to
   * keep complexity low and avoid duplication. It also makes the fullscreen
   * changes easier to remove.
   */ width: "100%",
        height: "100%",
        /**
   * Full screen modals only support body scrolling, so that the header
   * and close button will always stay visible.
   */ shouldScrollInViewport: false,
        /**
   * This prop is a noop for fullscreen modals, so we aren't exposing it to consumers.
   * Using `false` internally to avoid potential bugs.
   */ shouldCloseOnOverlayClick: false,
        /**
   * The blanket is only briefly visible for fullscreen modals when fading in,
   * but provides a bit more of a visual cue that it has appeared on top.
   *
   * We don't want consumers to disable it.
   */ isBlanketHidden: false,
        ref: ref
    });
});
$02de961e571d494a$export$103e9686fdc354e8.displayName = 'FullScreenModalDialog';
module.exports["FullScreenModalDialog"] = $02de961e571d494a$export$103e9686fdc354e8;

});

parcelRegister("6qCW4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hEsbD = parcelRequire("hEsbD");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $9DzWa = parcelRequire("9DzWa");


var $dQLwo = parcelRequire("dQLwo");

const $ae71e6a95eb2a27f$var$fieldWrapperStyles = {
    root: "_2Hcpm0Pgdg"
}; // Override helper message margins to fix inconsistent spacing issue
const $ae71e6a95eb2a27f$var$helperMessageWrapperStyles = {
    root: "_0rIjyk1Y8M _0s1P8iPgdg"
};
const $ae71e6a95eb2a27f$export$855931c0be301ec6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CharacterCounterField(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { maxCharacters: maxCharacters, minCharacters: minCharacters, children: children, validate: userValidate, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, helperMessage: helperMessage, defaultValue: defaultValue, id: id, isRequired: isRequired, isDisabled: isDisabled, label: label, elementAfterLabel: elementAfterLabel, name: name, testId: testId } = t0;
    let t1;
    if ($[0] !== maxCharacters || $[1] !== minCharacters) {
        t1 = (value)=>{
            const stringValue = String(value || "");
            const length = stringValue.length;
            if (minCharacters !== undefined && length < minCharacters) return "__TOO_SHORT__";
            if (maxCharacters !== undefined && length > maxCharacters) return "__TOO_LONG__";
        };
        $[0] = maxCharacters;
        $[1] = minCharacters;
        $[2] = t1;
    } else t1 = $[2];
    const validateCharacterCount = t1;
    let t2;
    if ($[3] !== userValidate || $[4] !== validateCharacterCount) {
        t2 = (value_0, formState, fieldState)=>{
            const characterError = validateCharacterCount(value_0);
            const userError = userValidate?.(value_0, formState, fieldState);
            if (userError instanceof Promise) return userError.then((error)=>error || characterError);
            return userError || characterError;
        };
        $[3] = userValidate;
        $[4] = validateCharacterCount;
        $[5] = t2;
    } else t2 = $[5];
    const combinedValidate = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $ae71e6a95eb2a27f$var$fieldWrapperStyles.root
        ]);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== children || $[8] !== helperMessage || $[9] !== maxCharacters || $[10] !== minCharacters || $[11] !== overMaximumMessage || $[12] !== testId || $[13] !== underMaximumMessage || $[14] !== underMinimumMessage) {
        t4 = (t5)=>{
            const { fieldProps: extendedFieldProps, error: error_0, valid: valid, meta: meta } = t5;
            const isCharacterCountViolation = error_0 === "__TOO_SHORT__" || error_0 === "__TOO_LONG__";
            const showExternalError = error_0 && !isCharacterCountViolation;
            const showCharacterCounter = (maxCharacters !== undefined || minCharacters !== undefined) && !showExternalError;
            const fieldPropsWithCounter = {
                ...extendedFieldProps,
                "aria-describedby": showCharacterCounter ? `${extendedFieldProps["aria-describedby"]} ${extendedFieldProps.id}-character-counter`.trim() : extendedFieldProps["aria-describedby"]
            };
            return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $dQLwo.MessageWrapper), null, helperMessage && /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $ae71e6a95eb2a27f$var$helperMessageWrapperStyles.root
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $9DzWa.HelperMessage), {
                testId: `${testId}-helper`
            }, helperMessage))), children({
                fieldProps: fieldPropsWithCounter,
                error: error_0,
                valid: valid,
                meta: meta
            }), /*#__PURE__*/ $cozmU.createElement((0, $dQLwo.MessageWrapper), null, showExternalError && /*#__PURE__*/ $cozmU.createElement((0, $7BfeF.ErrorMessage), {
                testId: `${testId}-error`
            }, error_0)), showCharacterCounter && /*#__PURE__*/ $cozmU.createElement((0, $hEsbD.CharacterCounter), {
                maxCharacters: maxCharacters,
                minCharacters: minCharacters,
                currentValue: String(extendedFieldProps.value || ""),
                shouldShowAsError: isCharacterCountViolation,
                overMaximumMessage: overMaximumMessage,
                underMaximumMessage: underMaximumMessage,
                underMinimumMessage: underMinimumMessage,
                testId: `${testId}-character-counter`
            }));
        };
        $[7] = children;
        $[8] = helperMessage;
        $[9] = maxCharacters;
        $[10] = minCharacters;
        $[11] = overMaximumMessage;
        $[12] = testId;
        $[13] = underMaximumMessage;
        $[14] = underMinimumMessage;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== combinedValidate || $[17] !== defaultValue || $[18] !== elementAfterLabel || $[19] !== id || $[20] !== isDisabled || $[21] !== isRequired || $[22] !== label || $[23] !== name || $[24] !== t4 || $[25] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            defaultValue: defaultValue,
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            label: label,
            elementAfterLabel: elementAfterLabel,
            name: name,
            testId: testId,
            validate: combinedValidate
        }, t4));
        $[16] = combinedValidate;
        $[17] = defaultValue;
        $[18] = elementAfterLabel;
        $[19] = id;
        $[20] = isDisabled;
        $[21] = isRequired;
        $[22] = label;
        $[23] = name;
        $[24] = t4;
        $[25] = testId;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
} : function CharacterCounterField({ maxCharacters: maxCharacters, minCharacters: minCharacters, children: children, validate: userValidate, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, helperMessage: helperMessage, defaultValue: defaultValue, id: id, isRequired: isRequired, isDisabled: isDisabled, label: label, elementAfterLabel: elementAfterLabel, name: name, testId: testId }) {
    // Default validation function for character limits
    // __TOO_SHORT__ and __TOO_LONG__ are default error codes recognised by the CharacterCounter component
    const validateCharacterCount = (value)=>{
        const stringValue = String(value || '');
        const length = stringValue.length; // Check minimum length
        if (minCharacters !== undefined && length < minCharacters) return '__TOO_SHORT__';
         // Check maximum length
        if (maxCharacters !== undefined && length > maxCharacters) return '__TOO_LONG__';
        return undefined;
    }; // Combine user validation and character validation
    // Any user defined validation takes priority over character validation
    // If there is no user defined validation for character limits e.g. used maxLength prior to CharacterCounterField,
    // use the default error codes and display the appropriate error message
    const combinedValidate = (value_0, formState, fieldState)=>{
        // First run character validation
        const characterError = validateCharacterCount(value_0); // Then run user's custom validation if provided
        const userError = userValidate?.(value_0, formState, fieldState); // If user validation returns a promise, handle it
        if (userError instanceof Promise) return userError.then((error)=>{
            // User error takes priority over character validation
            return error || characterError;
        });
         // User error takes priority over character validation
        return userError || characterError;
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ae71e6a95eb2a27f$var$fieldWrapperStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
        defaultValue: defaultValue,
        id: id,
        isRequired: isRequired,
        isDisabled: isDisabled,
        label: label,
        elementAfterLabel: elementAfterLabel,
        name: name,
        testId: testId,
        validate: combinedValidate
    }, ({ fieldProps: extendedFieldProps, error: error_0, valid: valid, meta: meta })=>{
        // Determine if error is a character count violation (handled by CharacterCounter)
        // or an external validation error (needs ErrorMessage)
        const isCharacterCountViolation = error_0 === '__TOO_SHORT__' || error_0 === '__TOO_LONG__';
        const showExternalError = error_0 && !isCharacterCountViolation;
        const showCharacterCounter = (maxCharacters !== undefined || minCharacters !== undefined) && !showExternalError; // Extend aria-describedby to reference the appropriate message component
        const fieldPropsWithCounter = {
            ...extendedFieldProps,
            'aria-describedby': showCharacterCounter ? `${extendedFieldProps['aria-describedby']} ${extendedFieldProps.id}-character-counter`.trim() : extendedFieldProps['aria-describedby']
        };
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $dQLwo.MessageWrapper), null, helperMessage && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $ae71e6a95eb2a27f$var$helperMessageWrapperStyles.root
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $9DzWa.HelperMessage), {
            testId: `${testId}-helper`
        }, helperMessage))), children({
            fieldProps: fieldPropsWithCounter,
            error: error_0,
            valid: valid,
            meta: meta
        }), /*#__PURE__*/ $cozmU.createElement((0, $dQLwo.MessageWrapper), null, showExternalError && /*#__PURE__*/ $cozmU.createElement((0, $7BfeF.ErrorMessage), {
            testId: `${testId}-error`
        }, error_0)), showCharacterCounter && /*#__PURE__*/ $cozmU.createElement((0, $hEsbD.CharacterCounter), {
            maxCharacters: maxCharacters,
            minCharacters: minCharacters,
            currentValue: String(extendedFieldProps.value || ''),
            shouldShowAsError: isCharacterCountViolation,
            overMaximumMessage: overMaximumMessage,
            underMaximumMessage: underMaximumMessage,
            underMinimumMessage: underMinimumMessage,
            testId: `${testId}-character-counter`
        }));
    }));
};
module.exports["CharacterCounterField"] = $ae71e6a95eb2a27f$export$855931c0be301ec6;

});

parcelRegister("0IH32", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74848f30a8ab0264055ca77ebdcac583>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $f3609b76c37101c7$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
module.exports["backgroundColorMap"] = $f3609b76c37101c7$export$d1d79bf68ac056bd;

});

parcelRegister("hpqhf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $0ce5af97a5151567$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
module.exports["positiveSpaceMap"] = $0ce5af97a5151567$export$958d0ae7f2977ae4;

});

parcelRegister("kQDaq", function(module, exports) {
const $b92a26b5e957d56e$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');
module.exports["uniqueSymbol"] = $b92a26b5e957d56e$export$43e479c916cb4ada;

});

parcelRegister("cl1W1", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $0IH32 = parcelRequire("0IH32");


var $ebPt8 = parcelRequire("ebPt8");

const $a487d9d84df40fe2$export$e7af83bafe7f9e63 = (0, $ebPt8.getSerializedStylesMap)('backgroundColor', (0, $0IH32.backgroundColorMap));
module.exports["backgroundColorStylesMap"] = $a487d9d84df40fe2$export$e7af83bafe7f9e63;

});

parcelRegister("15WAQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $ecffa30d7cfdd8cb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
module.exports["borderColorMap"] = $ecffa30d7cfdd8cb$export$1531ad5bb3fbedac;

});

parcelRegister("gjS4Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $126ff522acf279c9$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
module.exports["borderWidthMap"] = $126ff522acf279c9$export$e1b83c5210c471b8;

});

parcelRegister("b2E2m", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $ewTr4 = parcelRequire("ewTr4");


var $hpqhf = parcelRequire("hpqhf");

const $0c4f0405195695f2$export$e615f061ca585a6c = (0, $ewTr4.createSpacingStylesMap)((0, $hpqhf.positiveSpaceMap));
module.exports["paddingStylesMap"] = $0c4f0405195695f2$export$e615f061ca585a6c;

});

parcelRegister("9yCGl", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $j1lPy = parcelRequire("j1lPy");


var $b1FLc = parcelRequire("b1FLc");


var $5EzLH = parcelRequire("5EzLH");


var $iksxH = parcelRequire("iksxH");


var $aQr0R = parcelRequire("aQr0R");


var $dNqAP = parcelRequire("dNqAP");


var $f0MS8 = parcelRequire("f0MS8");


var $h566P = parcelRequire("h566P");


var $aENSa = parcelRequire("aENSa");

function $d7c2a41ef0b23647$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $d7c2a41ef0b23647$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $d7c2a41ef0b23647$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $d7c2a41ef0b23647$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $d7c2a41ef0b23647$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $h566P.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $d7c2a41ef0b23647$var$getChildren = (children, childrenStyles)=>{
    if ((0, $h566P.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $d7c2a41ef0b23647$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $dpsRj.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $dpsRj.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $cozmU.useRef)();
    const setRef = (0, $cozmU.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $j1lPy.default)(ourRef, autoFocus);
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $lOiVq.css)((0, $dNqAP.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b1FLc.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d7c2a41ef0b23647$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $iksxH.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f0MS8.getIconStyle)({
                spacing: spacing
            }),
            $d7c2a41ef0b23647$var$getSpacingFix(children, $d7c2a41ef0b23647$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d7c2a41ef0b23647$var$getChildren(children, [
        fadeStyles,
        (0, $aQr0R.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f0MS8.getIconStyle)({
                spacing: spacing
            }),
            $d7c2a41ef0b23647$var$getSpacingFix(children, $d7c2a41ef0b23647$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            (0, $aENSa.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d7c2a41ef0b23647$export$2e2bcd8739ae039 = $d7c2a41ef0b23647$var$ButtonBase;
module.exports["default"] = $d7c2a41ef0b23647$export$2e2bcd8739ae039;

});

parcelRegister("8IeMU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea511df973b657e3$export$2e2bcd8739ae039);

var $h566P = parcelRequire("h566P");

function $ea511df973b657e3$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $h566P.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("aRMYx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $ebc3825f8a354c14$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
const $ebc3825f8a354c14$var$LoadingSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingSpinner(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: t1 } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const size = spacing === "default" ? "medium" : "small";
    let t2;
    if ($[0] !== appearance || $[1] !== isDisabled || $[2] !== isSelected) {
        t2 = $ebc3825f8a354c14$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        });
        $[0] = appearance;
        $[1] = isDisabled;
        $[2] = isSelected;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== size || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: size,
            label: ", Loading",
            appearance: t2
        });
        $[4] = size;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function LoadingSpinner({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: size,
        label: ", Loading",
        appearance: $ebc3825f8a354c14$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
};
var $ebc3825f8a354c14$export$2e2bcd8739ae039 = $ebc3825f8a354c14$var$LoadingSpinner;
module.exports["default"] = $ebc3825f8a354c14$export$2e2bcd8739ae039;

});

parcelRegister("4LCZp", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iDrrr = parcelRequire("iDrrr");

const $ce48571dd84f931a$var$gridSize = 8;
const $ce48571dd84f931a$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $ce48571dd84f931a$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $ce48571dd84f931a$var$lineHeights = {
    default: $ce48571dd84f931a$var$heights.default,
    compact: $ce48571dd84f931a$var$heights.compact,
    none: 'inherit'
};
const $ce48571dd84f931a$var$padding = {
    // 10px gutter
    default: `0 ${$ce48571dd84f931a$var$gridSize + $ce48571dd84f931a$var$gridSize / 4}px`,
    compact: `0 ${$ce48571dd84f931a$var$gridSize + $ce48571dd84f931a$var$gridSize / 4}px`,
    none: '0'
};
const $ce48571dd84f931a$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$ce48571dd84f931a$var$gridSize / 4}px`,
    default: `0 ${$ce48571dd84f931a$var$gridSize / 4}px`,
    none: '0'
};
const $ce48571dd84f931a$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $ce48571dd84f931a$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $ce48571dd84f931a$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$ce48571dd84f931a$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $ce48571dd84f931a$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $ce48571dd84f931a$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $ce48571dd84f931a$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $ce48571dd84f931a$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $ce48571dd84f931a$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $ce48571dd84f931a$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $ce48571dd84f931a$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$ce48571dd84f931a$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ const $ce48571dd84f931a$var$defaultWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$defaultStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$ce48571dd84f931a$var$defaultStyles['&:hover'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$ce48571dd84f931a$var$defaultStyles['&:active'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }
};
const $ce48571dd84f931a$var$primaryWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$primaryStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$ce48571dd84f931a$var$primaryStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$ce48571dd84f931a$var$primaryStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $ce48571dd84f931a$var$linkWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$linkStyles,
    textDecoration: 'none'
};
const $ce48571dd84f931a$var$subtleWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$subtleStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$ce48571dd84f931a$var$subtleStyles['&:hover'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$ce48571dd84f931a$var$subtleStyles['&:active'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }
};
const $ce48571dd84f931a$var$subtleLinkWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$subtleLinkStyles,
    textDecoration: 'none'
};
const $ce48571dd84f931a$var$warningWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$warningStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$ce48571dd84f931a$var$warningStyles['&:hover'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$ce48571dd84f931a$var$warningStyles['&:active'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }
};
const $ce48571dd84f931a$var$dangerWithAnchorTextColorStyles = {
    ...$ce48571dd84f931a$var$dangerStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$ce48571dd84f931a$var$dangerStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$ce48571dd84f931a$var$dangerStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $ce48571dd84f931a$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $ce48571dd84f931a$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const appearanceStyles = (0, $iDrrr.fg)('platform-dst-legacy-button-anchor-text-color') ? {
        ...appearance === 'default' && $ce48571dd84f931a$var$defaultWithAnchorTextColorStyles,
        ...appearance === 'primary' && $ce48571dd84f931a$var$primaryWithAnchorTextColorStyles,
        ...appearance === 'link' && $ce48571dd84f931a$var$linkWithAnchorTextColorStyles,
        ...appearance === 'subtle' && $ce48571dd84f931a$var$subtleWithAnchorTextColorStyles,
        ...appearance === 'subtle-link' && $ce48571dd84f931a$var$subtleLinkWithAnchorTextColorStyles,
        ...appearance === 'warning' && $ce48571dd84f931a$var$warningWithAnchorTextColorStyles,
        ...appearance === 'danger' && $ce48571dd84f931a$var$dangerWithAnchorTextColorStyles
    } : {
        ...appearance === 'default' && $ce48571dd84f931a$var$defaultStyles,
        ...appearance === 'primary' && $ce48571dd84f931a$var$primaryStyles,
        ...appearance === 'link' && $ce48571dd84f931a$var$linkStyles,
        ...appearance === 'subtle' && $ce48571dd84f931a$var$subtleStyles,
        ...appearance === 'subtle-link' && $ce48571dd84f931a$var$subtleLinkStyles,
        ...appearance === 'warning' && $ce48571dd84f931a$var$warningStyles,
        ...appearance === 'danger' && $ce48571dd84f931a$var$dangerStyles
    };
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $iDrrr.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $iDrrr.fg)('platform-dst-motion-uplift-button') ? `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)` : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $ce48571dd84f931a$var$heights[spacing],
        lineHeight: $ce48571dd84f931a$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $ce48571dd84f931a$var$singleIconPadding[spacing] : $ce48571dd84f931a$var$padding[spacing],
        verticalAlign: $ce48571dd84f931a$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $ce48571dd84f931a$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $ce48571dd84f931a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $ce48571dd84f931a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $ce48571dd84f931a$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$ce48571dd84f931a$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
module.exports["getCss"] = $ce48571dd84f931a$export$955358618f994a11;

});

parcelRegister("d9HXn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6bcaeb6c7ae9f6ed$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["ModalContext"] = $6bcaeb6c7ae9f6ed$export$ab57792b9b6974a6;

});

parcelRegister("gUZwF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d8e83ac73c89eaa6$export$dece24112a937f92 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["ScrollContext"] = $d8e83ac73c89eaa6$export$dece24112a937f92;

});

parcelRegister("lkNt6", function(module, exports) {

var $l5iui = parcelRequire("l5iui");

const $b74b9cc24f89e4ae$export$ae933c6cbe5643ad = (0, $l5iui.HasTextAncestorContext).Provider;
module.exports["HasTextAncestorProvider"] = $b74b9cc24f89e4ae$export$ae933c6cbe5643ad;

});

parcelRegister("6RgkX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $l5iui = parcelRequire("l5iui");

const $f8a89cd24cfa55d0$export$9322276ec105d055 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $l5iui.HasTextAncestorContext));
} : ()=>(0, $cozmU.useContext)((0, $l5iui.HasTextAncestorContext));
module.exports["useHasTextAncestor"] = $f8a89cd24cfa55d0$export$9322276ec105d055;

});

parcelRegister("ebPt8", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

const $bcd7ee12ec00b5dc$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};
module.exports["getSerializedStylesMap"] = $bcd7ee12ec00b5dc$export$ca0f9c2de39ffed7;

});

parcelRegister("j9gRX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5eb11adeb6b8651411b3d8ad1d0c981b>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ const $0c63771230a7f738$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
module.exports["textColorMap"] = $0c63771230a7f738$export$8473307aa00d6ea1;

});

parcelRegister("6cOYa", function(module, exports) {
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $j1lPy = parcelRequire("j1lPy");


var $6JrSr = parcelRequire("6JrSr");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $9GVkD = parcelRequire("9GVkD");


var $lutEZ = parcelRequire("lutEZ");


var $bFZKX = parcelRequire("bFZKX");


var $eRpee = parcelRequire("eRpee");


var $lvyiP = parcelRequire("lvyiP");

const $77cc1a9c285924af$var$LOADING_LABEL = ', Loading';
const $77cc1a9c285924af$var$styles = {
    base: "_0bjKvDzXzM _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    baseT26Shape: "_0bjKvDKTcp",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _1UtDYzot27 _0clgaMot27 _0CMRbkot27",
    sharedDisabled: "_0KLXruVrZW _1eOmH6VrZW _3gzVzLVrZW",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    spacingCompactT26Shape: "_0bjKvDKxmn",
    circle: "_0bjKvDS5Zs",
    fullWidth: "_39xV02N91d",
    loading: "_0wOv4Q2mtD",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    iconButtonCompact: "_0jFU0V9DVM _39xV029DVM",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    splitButton: "_13yjolgtVO",
    loadingOverlay: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1ZB6UyPgdg _2I62gzPgdg _1OKFqYPgdg _3iC0zdPgdg",
    navigationSplitButton: "_39xV02oWWg _0KLXru66of _03SyCPgVvo _0LQT5EgVvo"
};
const $77cc1a9c285924af$var$defaultStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
    interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
    disabled: "_0KLXrujOvk _0z8nYChQC5 _1eOmH6jOvk _3gzVzLjOvk"
};
const $77cc1a9c285924af$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $77cc1a9c285924af$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH63nEM _0CMRbke5R3 _3gzVzLjYGY"
};
const $77cc1a9c285924af$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _0CMRbkVW6T",
    interactive: "_0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $77cc1a9c285924af$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $77cc1a9c285924af$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $77cc1a9c285924af$var$subtleStyles = {
    root: "_0KLXru66of _1UtDYzZpcK _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
    interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
    disabled: "_0KLXrujOvk _0z8nYChQC5 _1eOmH6jOvk _3gzVzLjOvk"
};
const $77cc1a9c285924af$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    insideSplitButton: "_42Yu6BiZR3",
    interactive: "_1eOmH6sumd _0clgaMjTy9 _3gzVzLXsxn _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
}; /**
    * __button base__
    *
    * - Implements auto focus when enabled.
    * - Appends the `onClick` event with UFO analytics tracking.
    *
    * @private
    */ 
const $77cc1a9c285924af$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $cozmU.useRef)(null);
    const splitButtonContext = (0, $bFZKX.useSplitButtonContext)();
    const loadingLabelId = (0, $6JrSr.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading; // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $j1lPy.default)(localRef, autoFocus); // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $lmzCg.default)([
            localRef,
            ref
        ]),
        xcss: (0, $w6R6I.cx)($77cc1a9c285924af$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $77cc1a9c285924af$var$styles.baseT26Shape, isInteractive && (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $77cc1a9c285924af$var$styles.interactiveMotion, appearance === 'default' && $77cc1a9c285924af$var$defaultStyles.root, appearance === 'default' && isInteractive && $77cc1a9c285924af$var$defaultStyles.interactive, appearance === 'primary' && $77cc1a9c285924af$var$primaryStyles.root, appearance === 'primary' && isInteractive && $77cc1a9c285924af$var$primaryStyles.interactive, appearance === 'rovo' && $77cc1a9c285924af$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $77cc1a9c285924af$var$rovoStyles.interactive, appearance === 'warning' && $77cc1a9c285924af$var$warningStyles.root, appearance === 'warning' && isInteractive && $77cc1a9c285924af$var$warningStyles.interactive, appearance === 'danger' && $77cc1a9c285924af$var$dangerStyles.root, appearance === 'danger' && isInteractive && $77cc1a9c285924af$var$dangerStyles.interactive, appearance === 'discovery' && $77cc1a9c285924af$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $77cc1a9c285924af$var$discoveryStyles.interactive, appearance === 'subtle' && $77cc1a9c285924af$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $77cc1a9c285924af$var$subtleStyles.interactive, $77cc1a9c285924af$var$styles.linkDecorationUnset, isSelected && $77cc1a9c285924af$var$selectedStyles.root, isSelected && isSplitButton && $77cc1a9c285924af$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $77cc1a9c285924af$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $77cc1a9c285924af$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $77cc1a9c285924af$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $77cc1a9c285924af$var$selectedStyles.discovery, isDisabled && $77cc1a9c285924af$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $77cc1a9c285924af$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $77cc1a9c285924af$var$defaultStyles.disabled, spacing === 'compact' && $77cc1a9c285924af$var$styles.spacingCompact, spacing === 'compact' && (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $77cc1a9c285924af$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $77cc1a9c285924af$var$styles.circle, shouldFitContainer && $77cc1a9c285924af$var$styles.fullWidth, hasIconBefore && $77cc1a9c285924af$var$styles.buttonIconBefore, hasIconAfter && $77cc1a9c285924af$var$styles.buttonIconAfter, isIconButton && $77cc1a9c285924af$var$styles.iconButton, isIconButton && spacing === 'compact' && $77cc1a9c285924af$var$styles.iconButtonCompact, isLoading && $77cc1a9c285924af$var$styles.loading, isSplitButton && $77cc1a9c285924af$var$styles.splitButton, isNavigationSplitButton && $77cc1a9c285924af$var$styles.navigationSplitButton),
        isDisabled: (0, $iDrrr.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $iDrrr.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $iDrrr.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$77cc1a9c285924af$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $eRpee.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lutEZ.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $77cc1a9c285924af$var$styles.loadingOverlay
        ])
    }, (0, $lvyiP.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: loadingLabelId
    }, $77cc1a9c285924af$var$LOADING_LABEL)));
});
var $77cc1a9c285924af$export$2e2bcd8739ae039 = $77cc1a9c285924af$var$ButtonBase;
module.exports["default"] = $77cc1a9c285924af$export$2e2bcd8739ae039;

});

parcelRegister("n1i5T", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $99b0bc26b32915ae$var$styles = {
    text: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _39HuIbz8Lp _1ANEUSLRg7",
    icon: "_3iDTPbQ4SZ _2O5VijdnbC _3YEZNOdnbC _4xdlr0DIqT _4ya3eEdnbC _26BoRwdnbC _20VacPYbGa",
    common: "_23rrnHBXJV",
    fade: "_1YKVNsdnbC"
};
const $99b0bc26b32915ae$var$Content = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, type: t1, isLoading: isLoading } = t0;
    const type = t1 === undefined ? "text" : t1;
    const t2 = type === "text" && $99b0bc26b32915ae$var$styles.text;
    const t3 = type === "icon" && $99b0bc26b32915ae$var$styles.icon;
    const t4 = isLoading && $99b0bc26b32915ae$var$styles.fade;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $hekY6.default)([
            $99b0bc26b32915ae$var$styles.common,
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== children || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t5
        }, children);
        $[4] = children;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $99b0bc26b32915ae$var$styles.common,
            type === 'text' && $99b0bc26b32915ae$var$styles.text,
            type === 'icon' && $99b0bc26b32915ae$var$styles.icon,
            isLoading && $99b0bc26b32915ae$var$styles.fade
        ])
    }, children);
};
var $99b0bc26b32915ae$export$2e2bcd8739ae039 = $99b0bc26b32915ae$var$Content;
module.exports["default"] = $99b0bc26b32915ae$export$2e2bcd8739ae039;

});

parcelRegister("aDGhF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $090bbb9672abc49b$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $090bbb9672abc49b$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $090bbb9672abc49b$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iDrrr.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $090bbb9672abc49b$export$2e2bcd8739ae039 = $090bbb9672abc49b$var$IconRenderer;
module.exports["default"] = $090bbb9672abc49b$export$2e2bcd8739ae039;

});

parcelRegister("ewTr4", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ebPt8 = parcelRequire("ebPt8");

const $10f48ad9f5ad8edb$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $10f48ad9f5ad8edb$export$f2bee1f59203ac70 = (tokenMap)=>{
    return $10f48ad9f5ad8edb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $ebPt8.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};
module.exports["createSpacingStylesMap"] = $10f48ad9f5ad8edb$export$f2bee1f59203ac70;

});

parcelRegister("15v69", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $680837db78d55f83$export$3c4232819458a302 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["FieldId"] = $680837db78d55f83$export$3c4232819458a302;

});

parcelRegister("4Ltes", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c63254b680595271$export$c24727297075ec6a = /*#__PURE__*/ (0, $cozmU.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
module.exports["FormContext"] = $c63254b680595271$export$c24727297075ec6a;

});

parcelRegister("lavrI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $151d2644741d9400$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["IsDisabledContext"] = $151d2644741d9400$export$c17cf6b332a82dbc;

});

parcelRegister("6NZvG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");


var $hHWoV = parcelRequire("hHWoV");

const $83130490bccb967b$var$messageStyles = null;
const $83130490bccb967b$var$messageAppearanceStyles = {
    default: "_1UtDYzKGUX",
    error: "_1UtDYzAyGJ",
    valid: "_1UtDYzGL5O"
};
const $83130490bccb967b$var$iconWrapperStyles = {
    root: "_3iDTPbQ4SZ _0jFU0Vey7F _0hPCNLDIqT"
};
const $83130490bccb967b$var$IconWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $83130490bccb967b$var$iconWrapperStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $83130490bccb967b$var$iconWrapperStyles.root
        ])
    }, children);
const $83130490bccb967b$var$messageIcons = {
    error: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
}; /**
    * __Message__
    *
    * A message component for displaying messages in a form.
    */ 
const $83130490bccb967b$var$Message = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { children: children, appearance: t1, fieldId: fieldId, testId: testId } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const icon = $83130490bccb967b$var$messageIcons[appearance];
    const messageRef = (0, $cozmU.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $cozmU.useState)(false);
    const { isWrapper: isWrapper } = (0, $cozmU.useContext)((0, $hHWoV.MessageWrapperContext));
    let t2;
    let t3;
    if ($[0] !== isWrapper) {
        t2 = ()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        };
        t3 = [
            isWrapper
        ];
        $[0] = isWrapper;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== children) {
        t4 = typeof children === "string" ? children : /*#__PURE__*/ $cozmU.createElement("span", null, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    const content = t4;
    const t5 = !hasMessageWrapper ? "polite" : undefined;
    const t6 = $83130490bccb967b$var$messageAppearanceStyles[appearance];
    let t7;
    if ($[5] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2mHwu8gVvo _2sNsIg7NXe _3iDTPbQ4SZ _37wbyuQame _43nrzT1Y8M",
            t6
        ]);
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== icon) {
        t8 = icon && /*#__PURE__*/ $cozmU.createElement($83130490bccb967b$var$IconWrapper, null, icon);
        $[7] = icon;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== content || $[10] !== fieldId || $[11] !== t5 || $[12] !== t7 || $[13] !== t8 || $[14] !== testId) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": t5,
            className: t7
        }, t8, content);
        $[9] = content;
        $[10] = fieldId;
        $[11] = t5;
        $[12] = t7;
        $[13] = t8;
        $[14] = testId;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $83130490bccb967b$var$messageIcons[appearance];
    const messageRef = (0, $cozmU.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $cozmU.useState)(false);
    const { isWrapper: isWrapper } = (0, $cozmU.useContext)((0, $hHWoV.MessageWrapperContext));
    (0, $cozmU.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]); /**
                    * The wrapping span is necessary to preserve spaces between children.
                    * Otherwise the flex layout of the message will remove any whitespace
                    * between children.
                    *
                    * If the child is just a string, this is not required and we can use one
                    * less DOM element.
                    */ 
    const content = typeof children === 'string' ? children : /*#__PURE__*/ $cozmU.createElement("span", null, children);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $hekY6.default)([
            "_2mHwu8gVvo _2sNsIg7NXe _3iDTPbQ4SZ _37wbyuQame _43nrzT1Y8M",
            $83130490bccb967b$var$messageAppearanceStyles[appearance]
        ])
    }, icon && /*#__PURE__*/ $cozmU.createElement($83130490bccb967b$var$IconWrapper, null, icon), content);
};
var $83130490bccb967b$export$2e2bcd8739ae039 = $83130490bccb967b$var$Message;
module.exports["default"] = $83130490bccb967b$export$2e2bcd8739ae039;

});

parcelRegister("hHWoV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $87958fcf8a744eaa$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isWrapper: false
});
module.exports["MessageWrapperContext"] = $87958fcf8a744eaa$export$579aef2c392a54d4;

});

parcelRegister("lutEZ", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $b678a00808295630$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["SplitButtonContext"] = $b678a00808295630$export$4b86304b2c0d7e71;

});

parcelRegister("cgay9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $1enXm = parcelRequire("1enXm");


var $cPEb7 = parcelRequire("cPEb7");


var $7r5Hr = parcelRequire("7r5Hr");


var $gyUf8 = parcelRequire("gyUf8");


var $dpsRj = parcelRequire("dpsRj");


var $j1lPy = parcelRequire("j1lPy");


var $6JrSr = parcelRequire("6JrSr");


var $1ZDKy = parcelRequire("1ZDKy");


var $5Tdig = parcelRequire("5Tdig");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $aDtKq = parcelRequire("aDtKq");


var $jp2Q3 = parcelRequire("jp2Q3");


var $dYk5C = parcelRequire("dYk5C");

var $1ADkG = parcelRequire("1ADkG");


var $5wSQb = parcelRequire("5wSQb");


var $d9HXn = parcelRequire("d9HXn");


var $b3wmo = parcelRequire("b3wmo");


var $7J77f = parcelRequire("7J77f");


var $kVYdm = parcelRequire("kVYdm");


var $fFYsc = parcelRequire("fFYsc");


var $jFZOU = parcelRequire("jFZOU");


var $gUZwF = parcelRequire("gUZwF");


var $58f9o = parcelRequire("58f9o");


var $cLXfd = parcelRequire("cLXfd");

const $b2cf4012d085d0e7$var$fillScreenStyles = null; /**
                                * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
                                */ 
const $b2cf4012d085d0e7$var$dialogStyles = {
    'body-scroll': "_4bt5LAYvD1 _2WAcuGYvD1 _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP",
    'viewport-scroll': "_1qyfxmyhct _39xV02qUim _0jFU0VWP8C",
    'full-screen': ""
}; // Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $b2cf4012d085d0e7$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current'; /**
                                                                                                         * Styles applied to the visual modal surface.
                                                                                                         */ 
const $b2cf4012d085d0e7$var$surfaceStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _2l47gTGk8v",
    borderRadius: "_0bjKvDdnbC _0YcdZAyzSk"
};
const $b2cf4012d085d0e7$var$topLayerScrollModeStyles = {
    'full-screen': "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
    'viewport-scroll': "_0jFU0VWP8C _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP _3ShBvMBY1A _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra",
    'body-scroll': "_39xV02qUim _0jFU0VWP8C _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra"
};
const $b2cf4012d085d0e7$var$topLayerAutoHeightStyles = null;
const $b2cf4012d085d0e7$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; // Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
const $b2cf4012d085d0e7$var$useModalCloseHandler = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useModalCloseHandler(providedOnClose) {
    const $ = (0, $bDgLe.c)(2);
    const t0 = providedOnClose || (0, $dpsRj.default);
    let t1;
    if ($[0] !== t0) {
        t1 = {
            fn: t0,
            action: "closed",
            componentName: "modalDialog",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return (0, $7r5Hr.usePlatformLeafEventHandler)(t1);
} : function useModalCloseHandler(providedOnClose) {
    return (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $dpsRj.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
};
function $b2cf4012d085d0e7$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $b2cf4012d085d0e7$var$isWidthName(value) {
    return (0, $58f9o.width).values.includes(value);
}
function $b2cf4012d085d0e7$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($b2cf4012d085d0e7$var$isWidthName(input)) return `${(0, $58f9o.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $b2cf4012d085d0e7$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $b2cf4012d085d0e7$var$getDialogDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
    return 'none';
} /**
   * Top-layer rendering path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: Dialog only forwards allowed reasons.
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   *
   * Every hook here runs unconditionally: this component only mounts on the
   * top-layer path, so it never shares a hook sequence with the legacy path.
   */ 
function $b2cf4012d085d0e7$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $dpsRj.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $b3wmo.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $b2cf4012d085d0e7$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $iODl6.useExitingPersistence)(); // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $6JrSr.useId)();
    const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $cozmU.useRef)(null); // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $cozmU.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
     // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $cozmU.useRef)(null);
    const modalDialogContext = (0, $cozmU.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        providedOnClose,
        isFullScreen
    ]); // Dialog has already applied the close behavior configured by `dismissedBy`.
    // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract.
    const onDialogClose = (0, $cozmU.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $dYk5C.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]);
    const dismissedBy = $b2cf4012d085d0e7$var$getDialogDismissedBy({
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    });
    const shouldShimCloseOnOverlayClick = shouldCloseOnOverlayClick && !shouldCloseOnEscapePress; // Required until we fully remove `shouldCloseOnEscapePress`.
    // Dialog's `dismissedBy` options do not support outside click without Escape (because it is a bad pattern)
    (0, $cozmU.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!dialog || !shouldShimCloseOnOverlayClick) return;
        return (0, $cbY7C.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onDialogClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onDialogClose,
        shouldShimCloseOnOverlayClick
    ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $cozmU.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]); // Fire onOpenComplete after mount.
    (0, $cozmU.useEffect)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $cozmU.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $j1lPy.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object'); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $cozmU.useEffect)(()=>{
        return (0, $aDtKq.combine)((0, $kVYdm.disableDraggingToCrossOriginIFramesForElement)(), (0, $jFZOU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $fFYsc.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $b2cf4012d085d0e7$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $1ADkG.Dialog), {
        ref: dialogRef,
        onClose: onDialogClose,
        dismissedBy: dismissedBy,
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $b2cf4012d085d0e7$var$dialogStyles[scrollMode]
    }, /*#__PURE__*/ $cozmU.createElement((0, $5wSQb.DialogScrollLock), {
        isOpen: true
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: contentRef,
        style: {
            '--modal-dialog-height': $b2cf4012d085d0e7$var$getTopLayerSurfaceHeight(height),
            '--modal-dialog-width': $b2cf4012d085d0e7$var$getTopLayerSurfaceWidth(width)
        },
        className: (0, $hekY6.default)([
            $b2cf4012d085d0e7$var$surfaceStyles.root,
            !isFullScreen && $b2cf4012d085d0e7$var$surfaceStyles.borderRadius,
            $b2cf4012d085d0e7$var$topLayerScrollModeStyles[scrollMode],
            !height && !isFullScreen && "_0Wik48W9qI"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $d9HXn.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $cozmU.createElement((0, $gUZwF.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, children))));
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $b2cf4012d085d0e7$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(43);
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: t0, shouldCloseOnOverlayClick: t1, shouldScrollInViewport: t2, shouldReturnFocus: t3, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: t4, isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: t5 } = props;
    const shouldCloseOnEscapePress = t0 === undefined ? true : t0;
    const shouldCloseOnOverlayClick = t1 === undefined ? true : t1;
    const shouldScrollInViewport = t2 === undefined ? false : t2;
    const shouldReturnFocus = t3 === undefined ? true : t3;
    const onStackChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const UNSAFE_shouldDisableMotionUplift = t5 === undefined ? false : t5;
    let t6;
    if ($[0] !== onStackChange) {
        t6 = {
            onStackChange: onStackChange
        };
        $[0] = onStackChange;
        $[1] = t6;
    } else t6 = $[1];
    const calculatedStackIndex = (0, $b3wmo.default)(t6);
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    const autoFocusLock = !(typeof autoFocus === "object");
    const onCloseHandler = $b2cf4012d085d0e7$var$useModalCloseHandler(providedOnClose);
    let t7;
    if ($[2] !== onCloseHandler || $[3] !== shouldCloseOnOverlayClick) {
        t7 = (e)=>{
            if (shouldCloseOnOverlayClick) onCloseHandler(e);
        };
        $[2] = onCloseHandler;
        $[3] = shouldCloseOnOverlayClick;
        $[4] = t7;
    } else t7 = $[4];
    const onBlanketClicked = t7;
    let t8;
    if ($[5] !== focusLockAllowlist) {
        t8 = (element)=>$b2cf4012d085d0e7$var$allowlistElements(element, focusLockAllowlist);
        $[5] = focusLockAllowlist;
        $[6] = t8;
    } else t8 = $[6];
    const allowListCallback = t8;
    (0, $7J77f.default)();
    let t9;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            type: "modal",
            isOpen: true,
            onClose: (0, $dpsRj.default)
        };
        $[7] = t9;
    } else t9 = $[7];
    (0, $5Tdig.useNotifyOpenLayerObserver)(t9);
    const t10 = !isBlanketHidden;
    const t11 = testId && `${testId}--blanket`;
    const t12 = shouldCloseOnEscapePress && isForeground;
    const t13 = Boolean(providedOnClose);
    let t14;
    if ($[8] !== UNSAFE_shouldDisableMotionUplift || $[9] !== autoFocus || $[10] !== children || $[11] !== height || $[12] !== isFullScreen || $[13] !== label || $[14] !== onCloseComplete || $[15] !== onCloseHandler || $[16] !== onOpenComplete || $[17] !== ref || $[18] !== shouldScrollInViewport || $[19] !== stackIndex || $[20] !== t12 || $[21] !== t13 || $[22] !== testId || $[23] !== width) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $cLXfd.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: t12,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: t13,
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref
        }, children);
        $[8] = UNSAFE_shouldDisableMotionUplift;
        $[9] = autoFocus;
        $[10] = children;
        $[11] = height;
        $[12] = isFullScreen;
        $[13] = label;
        $[14] = onCloseComplete;
        $[15] = onCloseHandler;
        $[16] = onOpenComplete;
        $[17] = ref;
        $[18] = shouldScrollInViewport;
        $[19] = stackIndex;
        $[20] = t12;
        $[21] = t13;
        $[22] = testId;
        $[23] = width;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== onBlanketClicked || $[26] !== t10 || $[27] !== t11 || $[28] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $gyUf8.default), {
            isTinted: t10,
            onBlanketClicked: onBlanketClicked,
            testId: t11
        }, t14);
        $[25] = onBlanketClicked;
        $[26] = t10;
        $[27] = t11;
        $[28] = t14;
        $[29] = t15;
    } else t15 = $[29];
    const modalDialogWithBlanket = t15;
    let onDeactivation;
    let returnFocus;
    if ($[30] !== shouldReturnFocus) {
        returnFocus = true;
        onDeactivation = (0, $dpsRj.default);
        if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
        else onDeactivation = ()=>{
            window.setTimeout(()=>{
                shouldReturnFocus.current?.focus();
            }, 0);
        };
        $[30] = shouldReturnFocus;
        $[31] = onDeactivation;
        $[32] = returnFocus;
    } else {
        onDeactivation = $[31];
        returnFocus = $[32];
    }
    let t16;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $jp2Q3.layers).modal();
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== UNSAFE_shouldDisableMotionUplift || $[35] !== allowListCallback || $[36] !== autoFocusLock || $[37] !== isForeground || $[38] !== modalDialogWithBlanket || $[39] !== onDeactivation || $[40] !== returnFocus || $[41] !== shouldScrollInViewport) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $1ZDKy.Layering), {
            isDisabled: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
            zIndex: t16
        }, !UNSAFE_shouldDisableMotionUplift && (0, $iDrrr.fg)("platform-dst-motion-uplift-modal") ? /*#__PURE__*/ $cozmU.createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": !isForeground,
            className: (0, $hekY6.default)([
                "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1enXm.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cPEb7))), null), shouldScrollInViewport ? /*#__PURE__*/ $cozmU.createElement((0, $cPEb7.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), null, (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...fadeInProps,
                className: (0, $hekY6.default)([
                    "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
                    fadeInProps.className
                ]),
                "aria-hidden": !isForeground
            }, /*#__PURE__*/ $cozmU.createElement((0, $1enXm.default), {
                autoFocus: autoFocusLock,
                returnFocus: returnFocus,
                onDeactivation: onDeactivation,
                whiteList: allowListCallback
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cPEb7))), null), shouldScrollInViewport ? /*#__PURE__*/ $cozmU.createElement((0, $cPEb7.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
        $[34] = UNSAFE_shouldDisableMotionUplift;
        $[35] = allowListCallback;
        $[36] = autoFocusLock;
        $[37] = isForeground;
        $[38] = modalDialogWithBlanket;
        $[39] = onDeactivation;
        $[40] = returnFocus;
        $[41] = shouldScrollInViewport;
        $[42] = t17;
    } else t17 = $[42];
    return t17;
} : (props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $dpsRj.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $b3wmo.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = $b2cf4012d085d0e7$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $cozmU.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $cozmU.useCallback)((element)=>$b2cf4012d085d0e7$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $7J77f.default)(); // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $dpsRj.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ $cozmU.createElement((0, $gyUf8.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ $cozmU.createElement((0, $cLXfd.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
        ref: ref
    }, children));
    let returnFocus = true;
    let onDeactivation = (0, $dpsRj.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $1ZDKy.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, $iDrrr.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $cozmU.createElement((0, $iFlah.default), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, $hekY6.default)([
            "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1enXm.default), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cPEb7))), null), shouldScrollInViewport ? /*#__PURE__*/ $cozmU.createElement((0, $cPEb7.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), null, (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ...fadeInProps,
            className: (0, $hekY6.default)([
                "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }, /*#__PURE__*/ $cozmU.createElement((0, $1enXm.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cPEb7))), null), shouldScrollInViewport ? /*#__PURE__*/ $cozmU.createElement((0, $cPEb7.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
}); // Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $b2cf4012d085d0e7$var$InternalModalWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ $cozmU.createElement($b2cf4012d085d0e7$var$ModalWrapperTopLayer, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props || $[3] !== ref) {
        t0 = /*#__PURE__*/ $cozmU.createElement($b2cf4012d085d0e7$var$ModalWrapperLegacy, {
            ref: ref,
            ...props
        });
        $[2] = props;
        $[3] = ref;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (props, ref)=>{
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ $cozmU.createElement($b2cf4012d085d0e7$var$ModalWrapperTopLayer, props);
    return /*#__PURE__*/ $cozmU.createElement($b2cf4012d085d0e7$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $b2cf4012d085d0e7$export$2e2bcd8739ae039 = $b2cf4012d085d0e7$var$InternalModalWrapper;
module.exports["default"] = $b2cf4012d085d0e7$export$2e2bcd8739ae039;

});

parcelRegister("iksxH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8375fa2f59d340c0$export$2e2bcd8739ae039);
function $8375fa2f59d340c0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $8375fa2f59d340c0$var$tabKeyCode = 9;
function $8375fa2f59d340c0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $8375fa2f59d340c0$var$tabKeyCode) return;
    $8375fa2f59d340c0$var$abort(event);
}
const $8375fa2f59d340c0$var$block = {
    onMouseDownCapture: $8375fa2f59d340c0$var$abort,
    onMouseUpCapture: $8375fa2f59d340c0$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $8375fa2f59d340c0$var$onKey,
    onKeyUpCapture: $8375fa2f59d340c0$var$onKey,
    onTouchStartCapture: $8375fa2f59d340c0$var$abort,
    onTouchEndCapture: $8375fa2f59d340c0$var$abort,
    onPointerDownCapture: $8375fa2f59d340c0$var$abort,
    onPointerUpCapture: $8375fa2f59d340c0$var$abort,
    onClickCapture: $8375fa2f59d340c0$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $8375fa2f59d340c0$var$abort
};
const $8375fa2f59d340c0$var$doNotBlock = {};
function $8375fa2f59d340c0$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $8375fa2f59d340c0$var$doNotBlock : $8375fa2f59d340c0$var$block;
}

});

parcelRegister("aQr0R", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $45e2395a26e0003d$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
module.exports["getContentStyle"] = $45e2395a26e0003d$export$7ad0316cc0dd65a;

});

parcelRegister("dNqAP", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $d5a68a0bc0cb79e5$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
module.exports["getFadingCss"] = $d5a68a0bc0cb79e5$export$1b5827d324e945b1;

});

parcelRegister("f0MS8", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $d1e906e9cf802eb7$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $lOiVq.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
module.exports["getIconStyle"] = $d1e906e9cf802eb7$export$864eea3f4ec3368f;

});

parcelRegister("h566P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9GVkD = parcelRequire("9GVkD");

const $d1b133f5335ba812$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $cozmU.isValidElement)(children) && children.type === (0, $9GVkD.default);
};
module.exports["getIfVisuallyHiddenChildren"] = $d1b133f5335ba812$export$20bbd2efb0d734c4;

});

parcelRegister("aENSa", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $904ff5b96071c6f8$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
module.exports["overlayCss"] = $904ff5b96071c6f8$export$1a9fe1b84c876bb5;

});

parcelRegister("l5iui", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b0c6d56bf6d8a4ba$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["HasTextAncestorContext"] = $b0c6d56bf6d8a4ba$export$19538d0bfc69c6e0;

});

parcelRegister("bFZKX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lutEZ = parcelRequire("lutEZ");

const $99be8f8ee9e21e6f$export$47e2c6fdb142d947 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const context = (0, $cozmU.useContext)((0, $lutEZ.SplitButtonContext));
    if (!context) return;
    if (context.appearance === "navigation") {
        let t0;
        if ($[0] !== context.isHighlighted) {
            t0 = {
                spacing: "default",
                appearance: "subtle",
                isDisabled: false,
                isActiveOverSelected: false,
                isNavigationSplitButton: true,
                isHighlighted: context.isHighlighted
            };
            $[0] = context.isHighlighted;
            $[1] = t0;
        } else t0 = $[1];
        const newContext = t0;
        return newContext;
    }
    let t0;
    if ($[2] !== context.appearance || $[3] !== context.isDisabled || $[4] !== context.spacing) {
        t0 = {
            spacing: context.spacing,
            appearance: context.appearance,
            isDisabled: context.isDisabled,
            isActiveOverSelected: true,
            isNavigationSplitButton: false,
            isHighlighted: false
        };
        $[2] = context.appearance;
        $[3] = context.isDisabled;
        $[4] = context.spacing;
        $[5] = t0;
    } else t0 = $[5];
    const splitButtonContext = t0;
    return splitButtonContext;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $lutEZ.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};
module.exports["useSplitButtonContext"] = $99be8f8ee9e21e6f$export$47e2c6fdb142d947;

});

parcelRegister("eRpee", function(module, exports) {
$parcel$export(module.exports, "default", () => $37c586a2b4fa0c6c$export$2e2bcd8739ae039);
function $37c586a2b4fa0c6c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $37c586a2b4fa0c6c$var$tabKeyCode = 9;
function $37c586a2b4fa0c6c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $37c586a2b4fa0c6c$var$tabKeyCode) return;
    $37c586a2b4fa0c6c$var$abort(event);
}
function $37c586a2b4fa0c6c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $37c586a2b4fa0c6c$var$abort,
        onMouseUpCapture: $37c586a2b4fa0c6c$var$abort,
        onKeyDownCapture: $37c586a2b4fa0c6c$var$onKey,
        onKeyUpCapture: $37c586a2b4fa0c6c$var$onKey,
        onTouchStartCapture: $37c586a2b4fa0c6c$var$abort,
        onTouchEndCapture: $37c586a2b4fa0c6c$var$abort,
        onPointerDownCapture: $37c586a2b4fa0c6c$var$abort,
        onPointerUpCapture: $37c586a2b4fa0c6c$var$abort,
        onClickCapture: $37c586a2b4fa0c6c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $37c586a2b4fa0c6c$var$abort
    } : events;
}

});

parcelRegister("lvyiP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc8f38bb3c4e3e9$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $5fc8f38bb3c4e3e9$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $5fc8f38bb3c4e3e9$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $5fc8f38bb3c4e3e9$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: $5fc8f38bb3c4e3e9$var$getIconSpacing(spacing),
        appearance: $5fc8f38bb3c4e3e9$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});

parcelRegister("b3wmo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d03703c1f97b3149$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $aEhqo = parcelRequire("aEhqo");


var $6iJ3v = parcelRequire("6iJ3v");


var $fl9oe = parcelRequire("fl9oe");


var $iODl6 = parcelRequire("iODl6");

/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $d03703c1f97b3149$var$modalStackRegister = [];
function $d03703c1f97b3149$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $iODl6.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $fl9oe.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $6iJ3v.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $aEhqo.default)(()=>{
        const newStackIndex = $d03703c1f97b3149$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $cozmU.useEffect)(()=>{
        const currentStackIndex_0 = $d03703c1f97b3149$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex_0 === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $d03703c1f97b3149$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex_0 !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $d03703c1f97b3149$var$modalStackRegister.splice(currentStackIndex_0, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $d03703c1f97b3149$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex_1 = $d03703c1f97b3149$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex_1 !== -1) {
                $d03703c1f97b3149$var$modalStackRegister.splice(currentStackIndex_1, 1);
                $d03703c1f97b3149$var$modalStackRegister.forEach((cb_0)=>cb_0());
            }
        }, [
        updateStack
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});

parcelRegister("7J77f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $14a0b0e8f843062d$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
/**
 * Prevents programatic scrolling of the viewport with `scrollIntoView`.
 * Should be used in conjunction with a scroll lock to prevent a user from scrolling.
 *
 * @returns scroll top offset of the viewport
 */ const $14a0b0e8f843062d$var$usePreventProgrammaticScroll = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePreventProgrammaticScroll() {
    const $ = (0, $bDgLe.c)(7);
    const [scrollTopOffset, setScrollTopOffset] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            setScrollTopOffset($14a0b0e8f843062d$var$getScrollDistance());
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    let t2;
    if ($[2] !== scrollTopOffset) {
        t2 = ()=>{
            if ($14a0b0e8f843062d$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
        };
        $[2] = scrollTopOffset;
        $[3] = t2;
    } else t2 = $[3];
    const onWindowScroll = t2;
    let t3;
    let t4;
    if ($[4] !== onWindowScroll) {
        t3 = ()=>(0, $cbY7C.bind)(window, {
                type: "scroll",
                listener: onWindowScroll
            });
        t4 = [
            onWindowScroll
        ];
        $[4] = onWindowScroll;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    return scrollTopOffset;
} : function usePreventProgrammaticScroll() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $cozmU.useState)(0);
    (0, $cozmU.useLayoutEffect)(()=>{
        setScrollTopOffset($14a0b0e8f843062d$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $cozmU.useCallback)(()=>{
        if ($14a0b0e8f843062d$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $cozmU.useEffect)(()=>{
        return (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
};
var $14a0b0e8f843062d$export$2e2bcd8739ae039 = $14a0b0e8f843062d$var$usePreventProgrammaticScroll;
module.exports["default"] = $14a0b0e8f843062d$export$2e2bcd8739ae039;

});

parcelRegister("kVYdm", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");


var $1aO2D = parcelRequire("1aO2D");

function $f0091d849dadb497$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $iSrRp.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $aDtKq.combine)(unbindEvents, unbindMonitor);
}
function $f0091d849dadb497$var$watchForInteractionStart({ start: start }) {
    return (0, $cbY7C.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $f0091d849dadb497$var$api = (0, $1aO2D.makeFixForAdapter)({
    watchForInteractionStart: $f0091d849dadb497$var$watchForInteractionStart,
    watchForInteractionEnd: $f0091d849dadb497$var$watchForInteractionEnd
});
function $f0091d849dadb497$export$ec28e97c7d8b1b35() {
    return $f0091d849dadb497$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForElement"] = $f0091d849dadb497$export$ec28e97c7d8b1b35;

});

parcelRegister("fFYsc", function(module, exports) {

var $6Bv0m = parcelRequire("6Bv0m");


var $1aO2D = parcelRequire("1aO2D");

function $bd0a24077feb0733$var$watchForInteractionStart({ start: start }) {
    return (0, $6Bv0m.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $bd0a24077feb0733$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $6Bv0m.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $bd0a24077feb0733$var$api = (0, $1aO2D.makeFixForAdapter)({
    watchForInteractionStart: $bd0a24077feb0733$var$watchForInteractionStart,
    watchForInteractionEnd: $bd0a24077feb0733$var$watchForInteractionEnd
});
function $bd0a24077feb0733$export$27d79116d3a4e7d5() {
    return $bd0a24077feb0733$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForExternal"] = $bd0a24077feb0733$export$27d79116d3a4e7d5;

});

parcelRegister("jFZOU", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $aDtKq = parcelRequire("aDtKq");


var $6GYKx = parcelRequire("6GYKx");


var $1aO2D = parcelRequire("1aO2D");

function $e17233615bd47b41$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $6GYKx.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $aDtKq.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $e17233615bd47b41$var$watchForInteractionStart({ start: start }) {
    return (0, $cbY7C.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $e17233615bd47b41$var$api = (0, $1aO2D.makeFixForAdapter)({
    watchForInteractionStart: $e17233615bd47b41$var$watchForInteractionStart,
    watchForInteractionEnd: $e17233615bd47b41$var$watchForInteractionEnd
});
function $e17233615bd47b41$export$9c0606fcefb5d1e2() {
    return $e17233615bd47b41$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForTextSelection"] = $e17233615bd47b41$export$9c0606fcefb5d1e2;

});

parcelRegister("58f9o", function(module, exports) {
const $9cce80b0d7e1f543$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
module.exports["width"] = $9cce80b0d7e1f543$export$7e3df82ee760448c;

});

parcelRegister("cLXfd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $j1lPy = parcelRequire("j1lPy");


var $6JrSr = parcelRequire("6JrSr");


var $hekX7 = parcelRequire("hekX7");


var $4CEP6 = parcelRequire("4CEP6");


var $iFlah = parcelRequire("iFlah");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $aDtKq = parcelRequire("aDtKq");


var $d9HXn = parcelRequire("d9HXn");


var $7ZHxa = parcelRequire("7ZHxa");


var $kVYdm = parcelRequire("kVYdm");


var $fFYsc = parcelRequire("fFYsc");


var $jFZOU = parcelRequire("jFZOU");


var $gUZwF = parcelRequire("gUZwF");


var $V2CMv = parcelRequire("V2CMv");


var $e8Nxe = parcelRequire("e8Nxe");


var $cxj2q = parcelRequire("cxj2q");

const $2eedcd14c83bc410$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $2eedcd14c83bc410$var$dialogStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _39xV02N91d _1EqgXlqUim _0jFU0VN91d _4kiQYAdnbC _0NUa3rWP8C _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu _28xGbQOLYo _2l47gTGk8v _2gkHrTOLYo _0iOkeGOLYo _4APJLd5dtV",
    borderRadius: "_0YcdZAzXzM",
    borderRadiusT26Shape: "_0YcdZAyzSk",
    motion: "_0NUa3rOLYo _1EqgXlOLYo _3iDTPbQ4SZ _3GZDR8B2PM _3AHHrTN91d",
    rootMotion: "_2gkHrTIZbP _0iOkeGIZbP",
    fullscreen: "_3GZDR8N91d"
};
const $2eedcd14c83bc410$var$viewportScrollStyles = null;
const $2eedcd14c83bc410$var$bodyScrollStyles = null;
const $2eedcd14c83bc410$var$ModalDialog = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(40);
    const { width: t0, shouldScrollInViewport: t1, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: t2, UNSAFE_shouldDisableMotionUplift: t3 } = props;
    const width = t0 === undefined ? "medium" : t0;
    const shouldScrollInViewport = t1 === undefined ? false : t1;
    const isFullScreen = t2 === undefined ? false : t2;
    const UNSAFE_shouldDisableMotionUplift = t3 === undefined ? false : t3;
    const id = (0, $6JrSr.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || "modal-dialog";
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[0] = t4;
    } else t4 = $[0];
    (0, $cozmU.useEffect)($2eedcd14c83bc410$var$_temp, t4);
    (0, $j1lPy.default)(autoFocus, typeof autoFocus === "object");
    let t5;
    if ($[1] !== onCloseComplete || $[2] !== onOpenComplete) {
        t5 = {
            onOpenComplete: onOpenComplete,
            onCloseComplete: onCloseComplete
        };
        $[1] = onCloseComplete;
        $[2] = onOpenComplete;
        $[3] = t5;
    } else t5 = $[3];
    const [motionRef, onMotionFinish] = (0, $7ZHxa.default)(t5);
    let t6;
    if ($[4] !== defaultTestId || $[5] !== hasProvidedOnClose || $[6] !== isFullScreen || $[7] !== onClose || $[8] !== titleId) {
        t6 = {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
        $[4] = defaultTestId;
        $[5] = hasProvidedOnClose;
        $[6] = isFullScreen;
        $[7] = onClose;
        $[8] = titleId;
        $[9] = t6;
    } else t6 = $[9];
    const modalDialogContext = t6;
    const t7 = !shouldCloseOnEscapePress;
    let t8;
    if ($[10] !== onClose || $[11] !== t7) {
        t8 = {
            onClose: onClose,
            isDisabled: t7
        };
        $[10] = onClose;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    (0, $hekX7.useCloseOnEscapePress)(t8);
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t9;
    if ($[13] !== UNSAFE_shouldDisableMotionUplift || $[14] !== children || $[15] !== currentLevel || $[16] !== defaultTestId || $[17] !== height || $[18] !== isFullScreen || $[19] !== label || $[20] !== motionRef || $[21] !== onMotionFinish || $[22] !== ref || $[23] !== shouldScrollInViewport || $[24] !== stackIndex || $[25] !== titleId || $[26] !== width) {
        t9 = !UNSAFE_shouldDisableMotionUplift && (0, $iDrrr.fg)("platform-dst-motion-uplift-modal") ? /*#__PURE__*/ $cozmU.createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
            exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
            onFinish: onMotionFinish,
            xcss: (0, $w6R6I.cx)($2eedcd14c83bc410$var$dialogStyles.motion, isFullScreen && $2eedcd14c83bc410$var$dialogStyles.fullscreen),
            style: {
                "--modal-dialog-width": (0, $e8Nxe.dialogWidth)(width),
                "--modal-dialog-height": (0, $V2CMv.dialogHeight)(height)
            }
        }, /*#__PURE__*/ $cozmU.createElement("section", {
            "aria-label": label,
            ref: (0, $lmzCg.default)([
                motionRef,
                ref
            ]),
            style: {
                "--modal-dialog-width": (0, $e8Nxe.dialogWidth)(width),
                "--modal-dialog-height": (0, $V2CMv.dialogHeight)(height)
            },
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel,
            className: (0, $hekY6.default)([
                $2eedcd14c83bc410$var$dialogStyles.root,
                $2eedcd14c83bc410$var$dialogStyles.rootMotion,
                !isFullScreen && $2eedcd14c83bc410$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $2eedcd14c83bc410$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo"
            ])
        }, children)) : /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: isFullScreen ? undefined : "bottom",
            onFinish: onMotionFinish
        }, (bottomFadeInProps)=>/*#__PURE__*/ $cozmU.createElement("section", {
                ...bottomFadeInProps,
                "aria-label": label,
                ref: (0, $lmzCg.default)([
                    bottomFadeInProps.ref,
                    motionRef,
                    ref
                ]),
                style: {
                    "--modal-dialog-width": (0, $e8Nxe.dialogWidth)(width),
                    "--modal-dialog-height": (0, $V2CMv.dialogHeight)(height)
                },
                className: (0, $hekY6.default)([
                    $2eedcd14c83bc410$var$dialogStyles.root,
                    !isFullScreen && $2eedcd14c83bc410$var$dialogStyles.borderRadius,
                    !isFullScreen && (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $2eedcd14c83bc410$var$dialogStyles.borderRadiusT26Shape,
                    shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo",
                    bottomFadeInProps.className
                ]),
                role: "dialog",
                "aria-labelledby": label ? undefined : titleId,
                "data-testid": defaultTestId,
                "data-modal-stack": stackIndex,
                tabIndex: -1,
                "aria-modal": true,
                "data-ds--level": currentLevel
            }, children));
        $[13] = UNSAFE_shouldDisableMotionUplift;
        $[14] = children;
        $[15] = currentLevel;
        $[16] = defaultTestId;
        $[17] = height;
        $[18] = isFullScreen;
        $[19] = label;
        $[20] = motionRef;
        $[21] = onMotionFinish;
        $[22] = ref;
        $[23] = shouldScrollInViewport;
        $[24] = stackIndex;
        $[25] = titleId;
        $[26] = width;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== shouldScrollInViewport || $[29] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $gUZwF.ScrollContext).Provider, {
            value: shouldScrollInViewport
        }, t9);
        $[28] = shouldScrollInViewport;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== modalDialogContext || $[32] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $d9HXn.ModalContext).Provider, {
            value: modalDialogContext
        }, t10);
        $[31] = modalDialogContext;
        $[32] = t10;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== defaultTestId || $[35] !== isFullScreen || $[36] !== shouldScrollInViewport || $[37] !== stackIndex || $[38] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $cxj2q.default), {
            stackIndex: stackIndex,
            shouldScrollInViewport: shouldScrollInViewport,
            testId: defaultTestId,
            isFullScreen: isFullScreen
        }, t11);
        $[34] = defaultTestId;
        $[35] = isFullScreen;
        $[36] = shouldScrollInViewport;
        $[37] = stackIndex;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    return t12;
} : (props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $6JrSr.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $cozmU.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $aDtKq.combine)((0, $kVYdm.disableDraggingToCrossOriginIFramesForElement)(), (0, $jFZOU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $fFYsc.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $j1lPy.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $7ZHxa.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $cozmU.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $hekX7.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    return /*#__PURE__*/ $cozmU.createElement((0, $cxj2q.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $cozmU.createElement((0, $d9HXn.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $cozmU.createElement((0, $gUZwF.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, $iDrrr.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $cozmU.createElement((0, $iFlah.default), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, $w6R6I.cx)($2eedcd14c83bc410$var$dialogStyles.motion, isFullScreen && $2eedcd14c83bc410$var$dialogStyles.fullscreen),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $e8Nxe.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $V2CMv.dialogHeight)(height)
        }
    }, /*#__PURE__*/ $cozmU.createElement("section", {
        "aria-label": label,
        ref: (0, $lmzCg.default)([
            motionRef,
            ref
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $e8Nxe.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $V2CMv.dialogHeight)(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, $hekY6.default)([
            $2eedcd14c83bc410$var$dialogStyles.root,
            $2eedcd14c83bc410$var$dialogStyles.rootMotion,
            !isFullScreen && $2eedcd14c83bc410$var$dialogStyles.borderRadius,
            !isFullScreen && (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $2eedcd14c83bc410$var$dialogStyles.borderRadiusT26Shape,
            shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo"
        ])
    }, children)) : /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ $cozmU.createElement("section", {
            ...bottomFadeInProps,
            "aria-label": label,
            ref: (0, $lmzCg.default)([
                bottomFadeInProps.ref,
                motionRef,
                ref
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $e8Nxe.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $V2CMv.dialogHeight)(height)
            },
            className: (0, $hekY6.default)([
                $2eedcd14c83bc410$var$dialogStyles.root,
                !isFullScreen && $2eedcd14c83bc410$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $2eedcd14c83bc410$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }, children)))));
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
var $2eedcd14c83bc410$export$2e2bcd8739ae039 = $2eedcd14c83bc410$var$ModalDialog;
function $2eedcd14c83bc410$var$_temp() {
    return (0, $aDtKq.combine)((0, $kVYdm.disableDraggingToCrossOriginIFramesForElement)(), (0, $jFZOU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $fFYsc.disableDraggingToCrossOriginIFramesForExternal)());
}
module.exports["default"] = $2eedcd14c83bc410$export$2e2bcd8739ae039;

});

parcelRegister("1aO2D", function(module, exports) {

var $aDtKq = parcelRequire("aDtKq");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $d7b477e5b6fb9475$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $d7b477e5b6fb9475$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $d7b477e5b6fb9475$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$d7b477e5b6fb9475$var$hasSameOrigin(window.location.href, iframe.src);
}
const $d7b477e5b6fb9475$var$registry = new Map();
function $d7b477e5b6fb9475$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($d7b477e5b6fb9475$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $d7b477e5b6fb9475$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $d7b477e5b6fb9475$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $d7b477e5b6fb9475$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $d7b477e5b6fb9475$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $aDtKq.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $d7b477e5b6fb9475$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $d7b477e5b6fb9475$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}
module.exports["makeFixForAdapter"] = $d7b477e5b6fb9475$export$a74bff2507e6126b;

});

parcelRegister("7ZHxa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

/**
 * This will run the respective passed in callback functions when modal is
 * opened or closed.
 */ const $ad33d2a90be3d4b2$var$useOnMotionFinish = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOnMotionFinish(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete } = t0;
    const motionRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== onCloseComplete || $[1] !== onOpenComplete) {
        t1 = (state)=>{
            if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
            if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
        };
        $[0] = onCloseComplete;
        $[1] = onOpenComplete;
        $[2] = t1;
    } else t1 = $[2];
    const onMotionFinish = t1;
    let t2;
    if ($[3] !== onMotionFinish) {
        t2 = [
            motionRef,
            onMotionFinish
        ];
        $[3] = onMotionFinish;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function useOnMotionFinish({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $cozmU.useRef)(null);
    const onMotionFinish = (0, $cozmU.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
};
var $ad33d2a90be3d4b2$export$2e2bcd8739ae039 = $ad33d2a90be3d4b2$var$useOnMotionFinish;
module.exports["default"] = $ad33d2a90be3d4b2$export$2e2bcd8739ae039;

});

parcelRegister("V2CMv", function(module, exports) {
const $c128674275b4c22d$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};
module.exports["dialogHeight"] = $c128674275b4c22d$export$ceba93bf0bdd16f2;

});

parcelRegister("e8Nxe", function(module, exports) {

var $58f9o = parcelRequire("58f9o");

const $ee236dfa167237cc$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $58f9o.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $58f9o.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
module.exports["dialogWidth"] = $ee236dfa167237cc$export$a3da89b899389ed8;

});

parcelRegister("cxj2q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4j4gm = parcelRequire("4j4gm");


var $4dGdo = parcelRequire("4dGdo");

const $c5b381fae470e749$var$positionerStyles = null;
const $c5b381fae470e749$var$stackStyles = {
    stackTransition: "_1kOSYtC67X _39Ohv4YbGa _1SdfoHYbGa",
    stackTransform: "_1VJPcamUxd",
    stackIdle: "_1VJPcaYbGa"
}; // Hardcoded pixels are based off a 60px base gutter
const $c5b381fae470e749$var$scrollStyles = {
    viewport: "_0jFU0VIZbP _1mT5xdRAKS _3ns3u9fI2J _3lqkkiIZbP _0Y3dgaYbGa",
    body: "_28xGbQw4ra _0Wik48UMig _2fj8asWVPG _0m5YQyahDP _4pesVsdnbC _3GyDTtdnbC _2gkHrTIZbP _0iOkeGIZbP _0Y3dgaYbGa",
    fullScreen: ""
};
function $c5b381fae470e749$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $c5b381fae470e749$var$Positioner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $c5b381fae470e749$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    const t0 = `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            "--modal-dialog-translate-y": t0,
            transitionDuration: `${(0, $4dGdo.durations).medium}ms`,
            transitionTimingFunction: (0, $4j4gm.easeInOut)
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = t1;
    const t3 = testId && `${testId}--positioner`;
    const t4 = stackIndex > 0 ? $c5b381fae470e749$var$stackStyles.stackTransform : $c5b381fae470e749$var$stackStyles.stackIdle;
    const t5 = $c5b381fae470e749$var$scrollStyles[scrollBehavior];
    let t6;
    if ($[2] !== t4 || $[3] !== t5) {
        t6 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _1EqgXlN91d _0jFU0VN91d _1mT5xdy1CL _42Yu6BFIQA _0aFT5vbt8w _2I62gzdnbC _3iC0zddnbC",
            $c5b381fae470e749$var$stackStyles.stackTransition,
            t4,
            t5
        ]);
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t3 || $[8] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t2,
            "data-testid": t3,
            className: t6
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
} : (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $c5b381fae470e749$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $4dGdo.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $4j4gm.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _1EqgXlN91d _0jFU0VN91d _1mT5xdy1CL _42Yu6BFIQA _0aFT5vbt8w _2I62gzdnbC _3iC0zddnbC",
            $c5b381fae470e749$var$stackStyles.stackTransition,
            stackIndex > 0 ? $c5b381fae470e749$var$stackStyles.stackTransform : $c5b381fae470e749$var$stackStyles.stackIdle,
            $c5b381fae470e749$var$scrollStyles[scrollBehavior]
        ])
    }, children);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c5b381fae470e749$export$2e2bcd8739ae039 = $c5b381fae470e749$var$Positioner;
module.exports["default"] = $c5b381fae470e749$export$2e2bcd8739ae039;

});


$parcel$global.rlb("hhss7")
//# sourceMappingURL=vendors~editor_atlaskit_lg.eb77c667.js.map
